/* Feed Chart Calculator. Copyright (c) 2026 The Hydro Bros, thehydrobros.com.
   Original work, not licensed for reuse. Build v67 · 2026-09-27 · 18 brands · 63 feeds.
   Generated from ui-init.js + nutrient-engine.js by build-asset.js. Do not edit here.
   Ships with sections/feed-calculator.liquid — the two are a pair. */
(function() {
  var FC_BUILD = "v67 · 2026-09-27 · 18 brands · 63 feeds";
  (function(root, factory) {
    if (typeof module === "object" && module.exports) module.exports = factory();
    else root.NUTRI = factory()
  })(typeof self !== "undefined" ? self : this, function() {
    "use strict";
    var LB = .45359237,
      GAL = 3.785411784;
    var CATALOG = {
      ath_grow: {
        handle: "athena-blended-grow-ab",
        title: "Athena Grow A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "9335",
          t: "32oz / 0.94L",
          size: .94,
          price: 23.4
        }, {
          sku: "655",
          t: "1 Gallon",
          size: 3.78,
          price: 62.5
        }, {
          sku: "656",
          t: "5 Gallon",
          size: 18.9,
          price: 191.5
        }]
      },
      ath_bloom: {
        handle: "athena-blended-bloom-ab",
        title: "Athena Bloom A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "9334",
          t: "32oz / 0.94L",
          size: .94,
          price: 23.4
        }, {
          sku: "4398",
          t: "1 Gallon",
          size: 3.78,
          price: 62.5
        }, {
          sku: "4399",
          t: "5 Gallon",
          size: 18.9,
          price: 191.5
        }]
      },
      ath_camg: {
        handle: "athena-blended-calmg",
        title: "Athena CaMg",
        unit: "ml",
        tiers: [{
          sku: "948",
          t: "32oz / 0.9L",
          size: .9,
          price: 16.4
        }, {
          sku: "946",
          t: "1 Gallon",
          size: 3.78,
          price: 38
        }, {
          sku: "10779",
          t: "5 Gallon",
          size: 18.9,
          price: 177
        }]
      },
      ath_pk: {
        handle: "athena-blended-pk",
        title: "Athena PK",
        unit: "ml",
        tiers: [{
          sku: "918",
          t: "32oz / 0.9L",
          size: .9,
          price: 17.4
        }, {
          sku: "919",
          t: "1 Gallon",
          size: 3.78,
          price: 39.5
        }, {
          sku: "920",
          t: "5 Gallon",
          size: 18.9,
          price: 173.5
        }]
      },
      ath_cleanse: {
        handle: "athena-blended-cleanse",
        title: "Athena Cleanse",
        unit: "ml",
        tiers: [{
          sku: "895",
          t: "32oz / 0.9L",
          size: .9,
          price: 19.4
        }, {
          sku: "896",
          t: "1 Gallon",
          size: 3.78,
          price: 53
        }, {
          sku: "897",
          t: "5 Gallon",
          size: 18.9,
          price: 229
        }]
      },
      ath_fade: {
        handle: "athena-fade",
        title: "Athena Fade",
        unit: "ml",
        tiers: [{
          sku: "7403",
          t: "32oz / 0.9L",
          size: .9,
          price: 15
        }, {
          sku: "7404",
          t: "1 Gallon",
          size: 3.78,
          price: 38
        }, {
          sku: "7405",
          t: "5 Gallon",
          size: 18.9,
          price: 187
        }]
      },
      ath_core: {
        handle: "athena-pro-core",
        title: "Athena Pro Core",
        unit: "g",
        tiers: [{
          sku: "10576",
          t: "2lb Bag",
          size: 2 * LB,
          price: 22
        }, {
          sku: "10577",
          t: "5lb Bag",
          size: 5 * LB,
          price: 47
        }, {
          sku: "211",
          t: "10lb Box",
          size: 10 * LB,
          price: 94
        }, {
          sku: "210",
          t: "25lb Box",
          size: 25 * LB,
          price: 188
        }]
      },
      ath_pgrow: {
        handle: "athena-pro-grow",
        title: "Athena Pro Grow",
        unit: "g",
        tiers: [{
          sku: "10574",
          t: "2lb Bag",
          size: 2 * LB,
          price: 22
        }, {
          sku: "10575",
          t: "5lb Bag",
          size: 5 * LB,
          price: 47
        }, {
          sku: "303",
          t: "10lb Box",
          size: 10 * LB,
          price: 94
        }, {
          sku: "302",
          t: "25lb Box",
          size: 25 * LB,
          price: 188
        }]
      },
      ath_pbloom: {
        handle: "athena-pro-bloom",
        title: "Athena Pro Bloom",
        unit: "g",
        tiers: [{
          sku: "10571",
          t: "2lb Bag",
          size: 2 * LB,
          price: 22
        }, {
          sku: "10573",
          t: "5lb Bag",
          size: 5 * LB,
          price: 47
        }, {
          sku: "247",
          t: "10lb Box",
          size: 10 * LB,
          price: 94
        }, {
          sku: "248",
          t: "25lb Box",
          size: 25 * LB,
          price: 188
        }]
      },
      ath_pbal: {
        handle: "athena-pro-balance",
        title: "Athena Pro Balance",
        unit: "g",
        tiers: [{
          sku: "7414",
          t: "2lb Bag",
          size: 2 * LB,
          price: 22
        }, {
          sku: "12188",
          t: "5lb Bag",
          size: 5 * LB,
          price: 44
        }, {
          sku: "12189",
          t: "10lb",
          size: 10 * LB,
          price: 94
        }, {
          sku: "7415",
          t: "25lb",
          size: 25 * LB,
          price: 188
        }]
      },
      can_coco: {
        handle: "canna-coco-nutrients",
        title: "CANNA Coco",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "276",
          t: "1L",
          size: 1,
          price: 13.49
        }, {
          sku: "277",
          t: "5L",
          size: 5,
          price: 38
        }, {
          sku: "278",
          t: "10L",
          size: 10,
          price: 69
        }, {
          sku: "6715",
          t: "20L",
          size: 20,
          price: 116
        }]
      },
      can_vega: {
        handle: "canna-terra-vega",
        title: "CANNA Terra Vega",
        unit: "ml",
        tiers: [{
          sku: "517",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "518",
          t: "5L",
          size: 5,
          price: 43
        }, {
          sku: "519",
          t: "10L",
          size: 10,
          price: 66
        }, {
          sku: "9156",
          t: "20L",
          size: 20,
          price: 120
        }]
      },
      can_flores: {
        handle: "canna-terra-flores",
        title: "CANNA Terra Flores",
        unit: "ml",
        tiers: [{
          sku: "176",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "177",
          t: "5L",
          size: 5,
          price: 43
        }, {
          sku: "178",
          t: "10L",
          size: 10,
          price: 66
        }, {
          sku: "9155",
          t: "20L",
          size: 20,
          price: 120
        }]
      },
      can_rhizo: {
        handle: "canna-rhizotonic",
        title: "CANNA Rhizotonic",
        unit: "ml",
        tiers: [{
          sku: "1064",
          t: "250ml",
          size: .25,
          price: 12.49
        }, {
          sku: "1065",
          t: "1L",
          size: 1,
          price: 29.99
        }, {
          sku: "1066",
          t: "5L",
          size: 5,
          price: 109.99
        }, {
          sku: "1067",
          t: "10L",
          size: 10,
          price: 199
        }]
      },
      can_zym: {
        handle: "canna-cannazym",
        title: "CANNAZYM",
        unit: "ml",
        tiers: [{
          sku: "666",
          t: "250ml",
          size: .25,
          price: 6.95
        }, {
          sku: "667",
          t: "1L",
          size: 1,
          price: 16.95
        }, {
          sku: "665",
          t: "5L",
          size: 5,
          price: 79
        }, {
          sku: "6903",
          t: "10L",
          size: 10,
          price: 135
        }]
      },
      can_boost: {
        handle: "canna-boost-accelerator",
        title: "CANNA Boost Accelerator",
        unit: "ml",
        tiers: [{
          sku: "825",
          t: "250ml",
          size: .25,
          price: 21.5
        }, {
          sku: "826",
          t: "1L",
          size: 1,
          price: 53.99
        }, {
          sku: "827",
          t: "5L",
          size: 5,
          price: 195
        }, {
          sku: "6668",
          t: "10L",
          size: 10,
          price: 379
        }]
      },
      can_pk: {
        handle: "canna-pk-13-14",
        title: "CANNA PK 13/14",
        unit: "ml",
        tiers: [{
          sku: "746",
          t: "250ml",
          size: .25,
          price: 5.5
        }, {
          sku: "747",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "745",
          t: "5L",
          size: 5,
          price: 55
        }]
      },
      can_calmag: {
        handle: "canna-calmag",
        title: "CANNA CalMag Agent",
        unit: "ml",
        tiers: [{
          sku: "854",
          t: "1L",
          size: 1,
          price: 12.95
        }, {
          sku: "855",
          t: "5L",
          size: 5,
          price: 38
        }, {
          sku: "856",
          t: "10L",
          size: 10,
          price: 54
        }]
      },
      can_flush: {
        handle: "canna-flush",
        title: "CANNA Flush",
        unit: "ml",
        tiers: [{
          sku: "427",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "426",
          t: "5L",
          size: 5,
          price: 47
        }]
      },
      sho_coco: {
        handle: "shogun-samurai-coco-ab",
        title: "SHOGUN Samurai Coco",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "481",
          t: "1L",
          size: 1,
          price: 14.5
        }, {
          sku: "482",
          t: "5L",
          size: 5,
          price: 42
        }, {
          sku: "483",
          t: "10L",
          size: 10,
          price: 71
        }, {
          sku: "484",
          t: "25L",
          size: 25,
          price: 148
        }]
      },
      sho_grow: {
        handle: "shogun-samurai-terra-grow",
        title: "SHOGUN Samurai Terra Grow",
        unit: "ml",
        tiers: [{
          sku: "719",
          t: "1L",
          size: 1,
          price: 11.49
        }, {
          sku: "720",
          t: "5L",
          size: 5,
          price: 31.95
        }, {
          sku: "721",
          t: "10L",
          size: 10,
          price: 59.95
        }, {
          sku: "11661",
          t: "25L",
          size: 25,
          price: 154.95
        }]
      },
      sho_bloom: {
        handle: "shogun-samurai-terra-bloom",
        title: "SHOGUN Samurai Terra Bloom",
        unit: "ml",
        tiers: [{
          sku: "557",
          t: "1L",
          size: 1,
          price: 11.49
        }, {
          sku: "558",
          t: "5L",
          size: 5,
          price: 33.95
        }, {
          sku: "559",
          t: "10L",
          size: 10,
          price: 60.95
        }, {
          sku: "11662",
          t: "25L",
          size: 25,
          price: 149.95
        }]
      },
      sho_katana: {
        handle: "shogun-katana-roots",
        title: "SHOGUN Katana Roots",
        unit: "ml",
        tiers: [{
          sku: "351",
          t: "250ml",
          size: .25,
          price: 9.45
        }, {
          sku: "352",
          t: "1L",
          size: 1,
          price: 28.95
        }, {
          sku: "353",
          t: "5L",
          size: 5,
          price: 92
        }, {
          sku: "6255",
          t: "10L",
          size: 10,
          price: 189
        }]
      },
      sho_zenzym: {
        handle: "shogun-zenzyme",
        title: "SHOGUN Zenzym",
        unit: "ml",
        tiers: [{
          sku: "6251",
          t: "250ml",
          size: .25,
          price: 7.95
        }, {
          sku: "6252",
          t: "1L",
          size: 1,
          price: 16.95
        }, {
          sku: "6253",
          t: "5L",
          size: 5,
          price: 64.95
        }, {
          sku: "6254",
          t: "10L",
          size: 10,
          price: 121.95
        }, {
          sku: "12560",
          t: "25L",
          size: 25,
          price: 293
        }]
      },
      sho_sumo: {
        handle: "shogun-sumo-active-boost",
        title: "SHOGUN Sumo Active Boost",
        unit: "ml",
        tiers: [{
          sku: "1164",
          t: "250ml",
          size: .25,
          price: 12
        }, {
          sku: "1162",
          t: "1L",
          size: 1,
          price: 27.95
        }, {
          sku: "1163",
          t: "5L",
          size: 5,
          price: 99.99
        }, {
          sku: "6264",
          t: "10L",
          size: 10,
          price: 159.95
        }, {
          sku: "6265",
          t: "25L",
          size: 25,
          price: 338
        }]
      },
      sho_pk: {
        handle: "shogun-pk-warrior-9-18",
        title: "SHOGUN PK Warrior 9/18",
        unit: "ml",
        tiers: [{
          sku: "288",
          t: "250ml",
          size: .25,
          price: 6.95
        }, {
          sku: "289",
          t: "1L",
          size: 1,
          price: 14.95
        }, {
          sku: "290",
          t: "5L",
          size: 5,
          price: 64.95
        }, {
          sku: "6260",
          t: "10L",
          size: 10,
          price: 149.95
        }]
      },
      sho_si: {
        handle: "shogun-silicon",
        title: "SHOGUN Silicon",
        unit: "ml",
        tiers: [{
          sku: "154",
          t: "250ml",
          size: .25,
          price: 4.95
        }, {
          sku: "155",
          t: "1L",
          size: 1,
          price: 8.95
        }, {
          sku: "156",
          t: "5L",
          size: 5,
          price: 29.95
        }, {
          sku: "6261",
          t: "10L",
          size: 10,
          price: 62.95
        }, {
          sku: "12561",
          t: "25L",
          size: 25,
          price: 145
        }]
      },
      sho_calmag: {
        handle: "shogun-calmag",
        title: "SHOGUN Calmag",
        unit: "ml",
        tiers: [{
          sku: "180",
          t: "250ml",
          size: .25,
          price: 5.49
        }, {
          sku: "181",
          t: "1L",
          size: 1,
          price: 12.49
        }, {
          sku: "182",
          t: "5L",
          size: 5,
          price: 39.9
        }, {
          sku: "5927",
          t: "10L",
          size: 10,
          price: 71.99
        }, {
          sku: "13030",
          t: "25L",
          size: 25,
          price: 174.95
        }]
      },
      sho_dragon: {
        handle: "shogun-dragon-force",
        title: "SHOGUN Dragon Force",
        unit: "ml",
        tiers: [{
          sku: "233",
          t: "250ml",
          size: .25,
          price: 8
        }, {
          sku: "234",
          t: "1L",
          size: 1,
          price: 15.95
        }, {
          sku: "235",
          t: "5L",
          size: 5,
          price: 42.49
        }, {
          sku: "236",
          t: "10L",
          size: 10,
          price: 79.99
        }]
      },
      ta_tri_grow: {
        handle: "terra-aquatica-tripart-grow",
        title: "Terra Aquatica TriPart Grow",
        unit: "ml",
        tiers: [{
          sku: "3340",
          t: "1L",
          size: 1,
          price: 12
        }, {
          sku: "3338",
          t: "5L",
          size: 5,
          price: 37
        }, {
          sku: "3339",
          t: "10L",
          size: 10,
          price: 65
        }]
      },
      ta_tri_micro_h: {
        handle: "terra-aquatica-tripart-micro-hw",
        title: "Terra Aquatica TriPart Micro (hard water)",
        unit: "ml",
        tiers: [{
          sku: "3256",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "3257",
          t: "5L",
          size: 5,
          price: 45
        }, {
          sku: "3255",
          t: "10L",
          size: 10,
          price: 89
        }]
      },
      ta_tri_micro_s: {
        handle: "terra-aquatica-tripart-micro-sw",
        title: "Terra Aquatica TriPart Micro (soft water)",
        unit: "ml",
        tiers: [{
          sku: "4531",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "4529",
          t: "5L",
          size: 5,
          price: 45
        }, {
          sku: "4530",
          t: "10L",
          size: 10,
          price: 89
        }]
      },
      ta_tri_bloom: {
        handle: "terra-aquatica-tripart-bloom",
        title: "Terra Aquatica TriPart Bloom",
        unit: "ml",
        tiers: [{
          sku: "2305",
          t: "1L",
          size: 1,
          price: 8.95
        }, {
          sku: "2306",
          t: "5L",
          size: 5,
          price: 35.95
        }, {
          sku: "2307",
          t: "10L",
          size: 10,
          price: 63.95
        }]
      },
      ta_dp_grow_h: {
        handle: "terra-aquatica-dualpart-grow-hw",
        title: "Terra Aquatica DualPart Grow (hard water)",
        unit: "ml",
        tiers: [{
          sku: "1303",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "1302",
          t: "5L",
          size: 5,
          price: 45
        }]
      },
      ta_dp_grow_s: {
        handle: "terra-aquatica-dualpart-grow-sw",
        title: "Terra Aquatica DualPart Grow (soft water)",
        unit: "ml",
        tiers: [{
          sku: "2681",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "2682",
          t: "5L",
          size: 5,
          price: 45
        }]
      },
      ta_dp_bloom: {
        handle: "terra-aquatica-dualpart-bloom",
        title: "Terra Aquatica DualPart Bloom",
        unit: "ml",
        tiers: [{
          sku: "1622",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "1623",
          t: "5L",
          size: 5,
          price: 45
        }]
      },
      ta_dpc_grow: {
        handle: "terra-aquatica-dualpart-coco-grow",
        title: "Terra Aquatica DualPart Coco Grow",
        unit: "ml",
        tiers: [{
          sku: "4282",
          t: "500ml",
          size: .5,
          price: 10
        }, {
          sku: "4283",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "4284",
          t: "5L",
          size: 5,
          price: 46
        }, {
          sku: "4285",
          t: "10L",
          size: 10,
          price: 85
        }]
      },
      ta_dpc_bloom: {
        handle: "terra-aquatica-dualpart-coco-bloom",
        title: "Terra Aquatica DualPart Coco Bloom",
        unit: "ml",
        tiers: [{
          sku: "2374",
          t: "500ml",
          size: .5,
          price: 10
        }, {
          sku: "2375",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "2376",
          t: "5L",
          size: 5,
          price: 46
        }, {
          sku: "2373",
          t: "10L",
          size: 10,
          price: 85
        }]
      },
      ta_final: {
        handle: "terra-aquatica-final-part",
        title: "Terra Aquatica Final Part",
        unit: "ml",
        tiers: [{
          sku: "4574",
          t: "500ml",
          size: .5,
          price: 7
        }, {
          sku: "4575",
          t: "1L",
          size: 1,
          price: 11
        }, {
          sku: "4576",
          t: "5L",
          size: 5,
          price: 35
        }, {
          sku: "4577",
          t: "10L",
          size: 10,
          price: 63
        }]
      },
      ta_proroots: {
        handle: "terra-aquatica-pro-roots",
        title: "Terra Aquatica Pro Roots",
        unit: "ml",
        tiers: [{
          sku: "3044",
          t: "30ml",
          size: .03,
          price: 12
        }, {
          sku: "3045",
          t: "60ml",
          size: .06,
          price: 19
        }, {
          sku: "3046",
          t: "250ml",
          size: .25,
          price: 64
        }, {
          sku: "3047",
          t: "500ml",
          size: .5,
          price: 115
        }]
      },
      ta_rootboost: {
        handle: "terra-aquatica-root-booster",
        title: "Terra Aquatica Root Booster",
        unit: "ml",
        tiers: [{
          sku: "3983",
          t: "500ml",
          size: .5,
          price: 14
        }, {
          sku: "3981",
          t: "1L",
          size: 1,
          price: 20
        }, {
          sku: "3982",
          t: "5L",
          size: 5,
          price: 73
        }]
      },
      ta_probloom: {
        handle: "terra-aquatica-pro-bloom",
        title: "Terra Aquatica Pro Bloom",
        unit: "ml",
        tiers: [{
          sku: "4672",
          t: "30ml",
          size: .03,
          price: 13
        }, {
          sku: "4673",
          t: "60ml",
          size: .06,
          price: 19
        }, {
          sku: "4674",
          t: "250ml",
          size: .25,
          price: 64
        }, {
          sku: "4671",
          t: "500ml",
          size: .5,
          price: 114
        }]
      },
      ta_bloomboost: {
        handle: "terra-aquatica-bloom-booster",
        title: "Terra Aquatica Bloom Booster",
        unit: "ml",
        tiers: [{
          sku: "1243",
          t: "500ml",
          size: .5,
          price: 13
        }, {
          sku: "1241",
          t: "1L",
          size: 1,
          price: 20
        }, {
          sku: "1242",
          t: "5L",
          size: 5,
          price: 67
        }]
      },
      ta_fulvic: {
        handle: "terra-aquatica-fulvic",
        title: "Terra Aquatica Fulvic",
        unit: "ml",
        tiers: [{
          sku: "3460",
          t: "500ml",
          size: .5,
          price: 15.95
        }, {
          sku: "3457",
          t: "1L",
          size: 1,
          price: 24.95
        }, {
          sku: "3458",
          t: "5L",
          size: 5,
          price: 85.95
        }, {
          sku: "3459",
          t: "10L",
          size: 10,
          price: 164
        }]
      },
      ta_humic: {
        handle: "terra-aquatica-humic",
        title: "Terra Aquatica Humic",
        unit: "ml",
        tiers: [{
          sku: "11247",
          t: "500ml",
          size: .5,
          price: 15.95
        }, {
          sku: "11248",
          t: "1L",
          size: 1,
          price: 20.95
        }, {
          sku: "11249",
          t: "5L",
          size: 5,
          price: 74.95
        }]
      },
      ta_seaweed: {
        handle: "terra-aquatica-seaweed",
        title: "Terra Aquatica Seaweed",
        unit: "ml",
        tiers: [{
          sku: "3609",
          t: "500ml",
          size: .5,
          price: 14
        }, {
          sku: "3608",
          t: "1L",
          size: 1,
          price: 19
        }, {
          sku: "12380",
          t: "5L",
          size: 5,
          price: 82
        }]
      },
      pla_cocos_ab: {
        handle: "plagron-coco-a-b",
        title: "Plagron Cocos A&B",
        unit: "ml",
        tiers: [{
          sku: "10801",
          t: "1L",
          size: 1,
          price: 11.95
        }, {
          sku: "10802",
          t: "5L",
          size: 5,
          price: 38.99
        }, {
          sku: "10803",
          t: "10L",
          size: 10,
          price: 68.95
        }, {
          sku: "11239",
          t: "20L",
          size: 20,
          price: 136.99
        }]
      },
      pla_terra_grow: {
        handle: "plagron-terra-grow",
        title: "Plagron Terra Grow",
        unit: "ml",
        tiers: [{
          sku: "6107",
          t: "1L",
          size: 1,
          price: 8.99
        }, {
          sku: "6108",
          t: "5L",
          size: 5,
          price: 29.99
        }, {
          sku: "6109",
          t: "10L",
          size: 10,
          price: 56
        }]
      },
      pla_terra_bloom: {
        handle: "plagron-terra-bloom",
        title: "Plagron Terra Bloom",
        unit: "ml",
        tiers: [{
          sku: "6103",
          t: "1L",
          size: 1,
          price: 7.95
        }, {
          sku: "6104",
          t: "5L",
          size: 5,
          price: 29.99
        }, {
          sku: "6105",
          t: "10L",
          size: 10,
          price: 53.99
        }, {
          sku: "11254",
          t: "20L",
          size: 20,
          price: 99.99
        }]
      },
      pla_power_roots: {
        handle: "plagron-power-roots",
        title: "Plagron Power Roots",
        unit: "ml",
        tiers: [{
          sku: "6996",
          t: "250ml",
          size: .25,
          price: 16.99
        }, {
          sku: "10489",
          t: "500ml",
          size: .5,
          price: 22.99
        }, {
          sku: "11260",
          t: "1L",
          size: 1,
          price: 29.95
        }, {
          sku: "6997",
          t: "5L",
          size: 5,
          price: 136.99
        }, {
          sku: "6998",
          t: "10L",
          size: 10,
          price: 234.99
        }]
      },
      pla_hydro_roots: {
        handle: "hydro-roots-hydroponic-root-support",
        title: "Plagron Hydro Roots",
        unit: "ml",
        tiers: [{
          sku: "10490",
          t: "250ml",
          size: .25,
          price: 9.99
        }, {
          sku: "11221",
          t: "1L",
          size: 1,
          price: 22
        }, {
          sku: "10491",
          t: "5L",
          size: 5,
          price: 94
        }, {
          sku: "10492",
          t: "10L",
          size: 10,
          price: 169
        }, {
          sku: "11222",
          t: "20L",
          size: 20,
          price: 328
        }]
      },
      pla_pure_zym: {
        handle: "plagron-pure-zym",
        title: "Plagron Pure Zym",
        unit: "ml",
        tiers: [{
          sku: "7000",
          t: "250ml",
          size: .25,
          price: 9.99
        }, {
          sku: "7001",
          t: "500ml",
          size: .5,
          price: 14.49
        }, {
          sku: "7002",
          t: "1L",
          size: 1,
          price: 19.99
        }, {
          sku: "7003",
          t: "5L",
          size: 5,
          price: 89.99
        }, {
          sku: "7004",
          t: "10L",
          size: 10,
          price: 148.99
        }]
      },
      pla_green_sens: {
        handle: "plagron-green-sensation",
        title: "Plagron Green Sensation",
        unit: "ml",
        tiers: [{
          sku: "4676",
          t: "250ml",
          size: .25,
          price: 35.95
        }, {
          sku: "4677",
          t: "500ml",
          size: .5,
          price: 64
        }, {
          sku: "4678",
          t: "1L",
          size: 1,
          price: 98.99
        }, {
          sku: "4675",
          t: "5L",
          size: 5,
          price: 349.95
        }, {
          sku: "6999",
          t: "10L",
          size: 10,
          price: 621.95
        }]
      },
      pla_sugar_royal: {
        handle: "sugar-royal-plant-support-additive",
        title: "Plagron Sugar Royal",
        unit: "ml",
        tiers: [{
          sku: "9621",
          t: "50ml",
          size: .05,
          price: 15
        }, {
          sku: "1607",
          t: "100ml",
          size: .1,
          price: 18
        }, {
          sku: "1608",
          t: "250ml",
          size: .25,
          price: 22.95
        }, {
          sku: "1609",
          t: "500ml",
          size: .5,
          price: 33.99
        }, {
          sku: "1606",
          t: "1L",
          size: 1,
          price: 48.95
        }, {
          sku: "6929",
          t: "5L",
          size: 5,
          price: 201.95
        }]
      },
      pla_power_buds: {
        handle: "plagron-power-buds",
        title: "Plagron Power Buds",
        unit: "ml",
        tiers: [{
          sku: "11258",
          t: "250ml",
          size: .25,
          price: 15.95
        }, {
          sku: "10419",
          t: "1L",
          size: 1,
          price: 41.99
        }, {
          sku: "10420",
          t: "5L",
          size: 5,
          price: 154.95
        }, {
          sku: "10421",
          t: "10L",
          size: 10,
          price: 299.99
        }]
      },
      ch_upthrive: {
        handle: "crazy-hills-upthrive",
        title: "Crazy Hills Upthrive",
        unit: "ml",
        tiers: [{
          sku: "10432",
          t: "1L",
          size: 1,
          price: 10.75
        }, {
          sku: "10433",
          t: "5L",
          size: 5,
          price: 44.95
        }, {
          sku: "10901",
          t: "10L",
          size: 10,
          price: 82.95
        }]
      },
      ch_elan: {
        handle: "crazy-hills-elan",
        title: "Crazy Hills Élan",
        unit: "ml",
        tiers: [{
          sku: "10186",
          t: "1L",
          size: 1,
          price: 35.95
        }, {
          sku: "10187",
          t: "5L",
          size: 5,
          price: 161.95
        }, {
          sku: "10903",
          t: "10L",
          size: 10,
          price: 309.95
        }]
      },
      ch_prosper: {
        handle: "crazy-hills-prosper",
        title: "Crazy Hills Prosper",
        unit: "ml",
        tiers: [{
          sku: "10430",
          t: "1L",
          size: 1,
          price: 12.55
        }, {
          sku: "10431",
          t: "5L",
          size: 5,
          price: 53.95
        }, {
          sku: "10900",
          t: "10L",
          size: 10,
          price: 97
        }]
      },
      ch_spark: {
        handle: "crazy-hills-spark",
        title: "Crazy Hills Spark",
        unit: "ml",
        tiers: [{
          sku: "10188",
          t: "1L",
          size: 1,
          price: 22.45
        }, {
          sku: "10189",
          t: "5L",
          size: 5,
          price: 98.95
        }, {
          sku: "10902",
          t: "10L",
          size: 10,
          price: 189.95
        }]
      },
      ch_kickoff: {
        handle: "crazy-hills-kick-off-microbial-root-inoculant",
        title: "Crazy Hills Kick Off",
        unit: "g",
        tiers: [{
          sku: "13268",
          t: "50g",
          size: .05,
          price: 11.99
        }, {
          sku: "10904",
          t: "200g",
          size: .2,
          price: 24.99
        }, {
          sku: "10906",
          t: "500g",
          size: .5,
          price: 44.99
        }]
      },
      can_hyd_vega_h: {
        handle: "canna-hydro-veg-hard-water",
        title: "CANNA Hydro Vega (Hard)",
        unit: "ml",
        water: "hard",
        tiers: [{
          sku: "331",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "332",
          t: "5L",
          size: 5,
          price: 42
        }, {
          sku: "333",
          t: "10L",
          size: 10,
          price: 65
        }]
      },
      can_hyd_vega_s: {
        handle: "canna-hydro-veg-soft-water",
        title: "CANNA Hydro Vega (Soft)",
        unit: "ml",
        water: "soft",
        tiers: [{
          sku: "1110",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "1111",
          t: "5L",
          size: 5,
          price: 42
        }, {
          sku: "1112",
          t: "10L",
          size: 10,
          price: 65
        }]
      },
      can_hyd_flor_h: {
        handle: "canna-hydro-flores-hard-water",
        title: "CANNA Hydro Flores (Hard)",
        unit: "ml",
        water: "hard",
        tiers: [{
          sku: "65",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "66",
          t: "5L",
          size: 5,
          price: 42
        }, {
          sku: "67",
          t: "10L",
          size: 10,
          price: 65
        }]
      },
      can_hyd_flor_s: {
        handle: "canna-hydro-flores-soft-water",
        title: "CANNA Hydro Flores (Soft)",
        unit: "ml",
        water: "soft",
        tiers: [{
          sku: "505",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "503",
          t: "5L",
          size: 5,
          price: 42
        }, {
          sku: "504",
          t: "10L",
          size: 10,
          price: 65
        }]
      },
      can_aqua_vega: {
        handle: "canna-aqua-vega-ab",
        title: "CANNA Aqua Vega",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "677",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "678",
          t: "5L",
          size: 5,
          price: 42
        }, {
          sku: "679",
          t: "10L",
          size: 10,
          price: 75
        }]
      },
      can_aqua_flor: {
        handle: "canna-aqua-flores-ab",
        title: "CANNA Aqua Flores",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "860",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "861",
          t: "5L",
          size: 5,
          price: 42
        }, {
          sku: "862",
          t: "10L",
          size: 10,
          price: 75
        }]
      },
      sho_hyd_grow_h: {
        handle: "shogun-samurai-hydro-grow",
        title: "SHOGUN Samurai Hydro Grow (Hard)",
        unit: "ml",
        ab: true,
        water: "hard",
        tiers: [{
          sku: "231",
          t: "Hard / 1L",
          size: 1,
          price: 12.45
        }, {
          sku: "232",
          t: "Hard / 5L",
          size: 5,
          price: 44.95
        }, {
          sku: "6256",
          t: "Hard / 10L",
          size: 10,
          price: 75
        }, {
          sku: "6257",
          t: "Hard / 25L",
          size: 25,
          price: 184.95
        }]
      },
      sho_hyd_grow_s: {
        handle: "shogun-samurai-hydro-grow",
        title: "SHOGUN Samurai Hydro Grow (Soft)",
        unit: "ml",
        ab: true,
        water: "soft",
        tiers: [{
          sku: "6283",
          t: "Soft / 1L",
          size: 1,
          price: 12.45
        }, {
          sku: "6284",
          t: "Soft / 5L",
          size: 5,
          price: 44.95
        }, {
          sku: "6285",
          t: "Soft / 10L",
          size: 10,
          price: 75
        }, {
          sku: "6286",
          t: "Soft / 25L",
          size: 25,
          price: 184.95
        }]
      },
      sho_hyd_bloom_h: {
        handle: "shogun-samurai-hydro-bloom",
        title: "SHOGUN Samurai Hydro Bloom (Hard)",
        unit: "ml",
        ab: true,
        water: "hard",
        tiers: [{
          sku: "12171",
          t: "Hard / 1L",
          size: 1,
          price: 12.45
        }, {
          sku: "467",
          t: "Hard / 5L",
          size: 5,
          price: 44.95
        }, {
          sku: "6258",
          t: "Hard / 10L",
          size: 10,
          price: 69
        }, {
          sku: "6259",
          t: "Hard / 25L",
          size: 25,
          price: 139
        }]
      },
      sho_hyd_bloom_s: {
        handle: "shogun-samurai-hydro-bloom",
        title: "SHOGUN Samurai Hydro Bloom (Soft)",
        unit: "ml",
        ab: true,
        water: "soft",
        tiers: [{
          sku: "6279",
          t: "Soft / 1L",
          size: 1,
          price: 12.45
        }, {
          sku: "6280",
          t: "Soft / 5L",
          size: 5,
          price: 44.95
        }, {
          sku: "6281",
          t: "Soft / 10L",
          size: 10,
          price: 69
        }, {
          sku: "6282",
          t: "Soft / 25L",
          size: 25,
          price: 139
        }]
      },
      vbx_craft: {
        handle: "vegbloom-vbx",
        title: "VBX Craft Powder",
        unit: "g",
        vbx: "craft",
        tiers: [{
          sku: "7263",
          t: "1lb",
          size: 1 * LB,
          price: 24.95
        }, {
          sku: "7265",
          t: "5lb",
          size: 5 * LB,
          price: 115
        }, {
          sku: "7266",
          t: "25lb",
          size: 25 * LB,
          price: 449
        }, {
          sku: "7704",
          t: "100lb",
          size: 100 * LB,
          price: 1559
        }]
      },
      vbx_clean: {
        handle: "veg-bloom-vbx-clean-dripper-friendly-version",
        title: "VBX CLEAN (Dripper Friendly)",
        unit: "g",
        vbx: "clean",
        tiers: [{
          sku: "11314",
          t: "1lb",
          size: 1 * LB,
          price: 24.99
        }, {
          sku: "11315",
          t: "5lb",
          size: 5 * LB,
          price: 108
        }, {
          sku: "11316",
          t: "25lb",
          size: 25 * LB,
          price: 449
        }, {
          sku: "11317",
          t: "100lb",
          size: 100 * LB,
          price: 1559
        }]
      },
      vbx_shine: {
        handle: "veg-bloom-shine-additive",
        title: "VBX SHINE Bloom Additive",
        unit: "g",
        vbx: "craft",
        tiers: [{
          sku: "4190",
          t: "1lb",
          size: 1 * LB,
          price: 32.99
        }, {
          sku: "4191",
          t: "2.2lb",
          size: 2.2 * LB,
          price: 68.99
        }, {
          sku: "4192",
          t: "5lb",
          size: 5 * LB,
          price: 148.49
        }, {
          sku: "4189",
          t: "25lb",
          size: 25 * LB,
          price: 599.99
        }]
      },
      vbx_shine_c: {
        handle: "veg-bloom-shine-clean-dripper-friendly-additive",
        title: "VBX SHINE CLEAN (Dripper Friendly)",
        unit: "g",
        vbx: "clean",
        tiers: [{
          sku: "11318",
          t: "1lb",
          size: 1 * LB,
          price: 33.99
        }, {
          sku: "11319",
          t: "2.2lb",
          size: 2.2 * LB,
          price: 69.99
        }, {
          sku: "11320",
          t: "5lb",
          size: 5 * LB,
          price: 133.39
        }, {
          sku: "11321",
          t: "25lb",
          size: 25 * LB,
          price: 544.49
        }]
      },
      vb_ro: {
        handle: "veg-bloom-ro-soft-base",
        title: "Veg+Bloom RO / Soft Base",
        unit: "g",
        water: "soft",
        tiers: [{
          sku: "2986",
          t: "1lb",
          size: 1 * LB,
          price: 22
        }, {
          sku: "6704",
          t: "5lb",
          size: 5 * LB,
          price: 98
        }, {
          sku: "2988",
          t: "25lb",
          size: 25 * LB,
          price: 419
        }, {
          sku: "7703",
          t: "100lb",
          size: 100 * LB,
          price: 1150
        }]
      },
      vb_tap: {
        handle: "veg-bloom-tap-hard-base",
        title: "Veg+Bloom Tap / Hard Base",
        unit: "g",
        water: "hard",
        tiers: [{
          sku: "4451",
          t: "1lb",
          size: 1 * LB,
          price: 19.95
        }, {
          sku: "4452",
          t: "5lb",
          size: 5 * LB,
          price: 96
        }, {
          sku: "4453",
          t: "25lb",
          size: 25 * LB,
          price: 399
        }, {
          sku: "4454",
          t: "100lb",
          size: 100 * LB,
          price: 1150
        }]
      },
      vb_dirt: {
        handle: "veg-bloom-dirty-base-soil",
        title: "Veg+Bloom Dirty Base (Soil)",
        unit: "g",
        tiers: [{
          sku: "3857",
          t: "1lb",
          size: 1 * LB,
          price: 24
        }, {
          sku: "3858",
          t: "5lb",
          size: 5 * LB,
          price: 116
        }, {
          sku: "3859",
          t: "25lb",
          size: 25 * LB,
          price: 496
        }]
      },
      ff_veg: {
        handle: "floraflex-nutrients-vegetative-bundle",
        title: "FloraFlex V1 + V2",
        unit: "g",
        ab: true,
        tiers: [{
          sku: "5155",
          t: "1lb",
          size: 1 * LB,
          price: 19
        }, {
          sku: "5156",
          t: "5lb",
          size: 5 * LB,
          price: 79
        }]
      },
      ff_bloom: {
        handle: "floraflex-nutrients-bloom-bundle-b1b2",
        title: "FloraFlex B1 + B2",
        unit: "g",
        ab: true,
        tiers: [{
          sku: "5161",
          t: "1lb",
          size: 1 * LB,
          price: 19
        }, {
          sku: "5162",
          t: "5lb",
          size: 5 * LB,
          price: 79
        }]
      },
      ff_bulky: {
        handle: "flora-flex-nutrients-bulky-b",
        title: "FloraFlex Bulky B",
        unit: "g",
        tiers: [{
          sku: "5726",
          t: "1lb",
          size: 1 * LB,
          price: 8.9
        }, {
          sku: "5727",
          t: "5lb",
          size: 5 * LB,
          price: 41
        }]
      },
      ff_tilt: {
        handle: "floraflex-nutrients-full-tilt-late-bloom-ripener",
        title: "FloraFlex Full Tilt",
        unit: "g",
        tiers: [{
          sku: "5136",
          t: "1lb",
          size: 1 * LB,
          price: 11
        }, {
          sku: "5137",
          t: "5lb",
          size: 5 * LB,
          price: 51.3
        }]
      },
      ff_root: {
        handle: "floraflex-root-drip",
        title: "FloraFlex Root Drip",
        unit: "ml",
        tiers: [{
          sku: "7074",
          t: "250ml",
          size: .25,
          price: 10
        }, {
          sku: "11433",
          t: "1L",
          size: 1,
          price: 25
        }, {
          sku: "7075",
          t: "1 Gallon",
          size: GAL,
          price: 79
        }]
      },
      ff_folveg: {
        handle: "floraflex-foliar-nutrients-vegative",
        title: "FloraFlex Veg Foliar",
        unit: "g",
        tiers: [{
          sku: "5138",
          t: "1lb",
          size: 1 * LB,
          price: 7.4
        }, {
          sku: "5139",
          t: "5lb",
          size: 5 * LB,
          price: 25
        }]
      },
      ff_folbloom: {
        handle: "floraflex-foliar-nutrients-bloom",
        title: "FloraFlex Bloom Foliar",
        unit: "g",
        tiers: [{
          sku: "5140",
          t: "1lb",
          size: 1 * LB,
          price: 9
        }, {
          sku: "5141",
          t: "5lb",
          size: 5 * LB,
          price: 25
        }]
      },
      mky_grow: {
        handle: "monkey-nutrients-grow-ab",
        title: "Monkey Grow A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "1120",
          t: "1L",
          size: 1,
          price: 18
        }, {
          sku: "1121",
          t: "5L",
          size: 5,
          price: 40
        }, {
          sku: "5339",
          t: "10L",
          size: 10,
          price: 75
        }, {
          sku: "1122",
          t: "25L",
          size: 25,
          price: 170
        }]
      },
      mky_bloom: {
        handle: "monkey-nutrients-bloom-ab",
        title: "Monkey Bloom A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "348",
          t: "1L",
          size: 1,
          price: 18
        }, {
          sku: "346",
          t: "5L",
          size: 5,
          price: 40
        }, {
          sku: "5338",
          t: "10L",
          size: 10,
          price: 75
        }, {
          sku: "347",
          t: "25L",
          size: 25,
          price: 170
        }]
      },
      mky_root: {
        handle: "monkey-nutrients-root-shoot",
        title: "Monkey Root Shoot",
        unit: "ml",
        tiers: [{
          sku: "511",
          t: "300ml",
          size: .3,
          price: 40
        }, {
          sku: "512",
          t: "600ml",
          size: .6,
          price: 70
        }, {
          sku: "513",
          t: "1.2L",
          size: 1.2,
          price: 120
        }, {
          sku: "514",
          t: "6.25L",
          size: 6.25,
          price: 500
        }]
      },
      mky_boost: {
        handle: "monkey-nutrients-boost",
        title: "Monkey Boost",
        unit: "ml",
        tiers: [{
          sku: "298",
          t: "1L",
          size: 1,
          price: 30
        }, {
          sku: "299",
          t: "5L",
          size: 5,
          price: 80
        }, {
          sku: "300",
          t: "10L",
          size: 10,
          price: 150
        }, {
          sku: "301",
          t: "25L",
          size: 25,
          price: 265
        }]
      },
      mky_pk: {
        handle: "monkey-nutrients-pk",
        title: "Monkey PK 14/15",
        unit: "ml",
        tiers: [{
          sku: "4689",
          t: "250ml",
          size: .25,
          price: 15
        }, {
          sku: "4690",
          t: "1L",
          size: 1,
          price: 40
        }, {
          sku: "4691",
          t: "5L",
          size: 5,
          price: 170
        }]
      },
      mky_resin: {
        handle: "monkey-resin",
        title: "Monkey Resin",
        unit: "ml",
        tiers: [{
          sku: "6422",
          t: "300ml",
          size: .3,
          price: 25
        }, {
          sku: "6423",
          t: "600ml",
          size: .6,
          price: 40
        }, {
          sku: "6424",
          t: "1.2L",
          size: 1.2,
          price: 70
        }, {
          sku: "6425",
          t: "6.25L",
          size: 6.25,
          price: 300
        }]
      },
      mky_stress: {
        handle: "monkey-nutrients-stress",
        title: "Monkey Stress",
        unit: "ml",
        tiers: [{
          sku: "4538",
          t: "250ml",
          size: .25,
          price: 44
        }, {
          sku: "4536",
          t: "1L",
          size: 1,
          price: 138
        }, {
          sku: "4537",
          t: "5L",
          size: 5,
          price: 445
        }]
      },
      mky_magcal: {
        handle: "monkey-nutrients-mag-cal",
        title: "Monkey Mag Cal",
        unit: "ml",
        tiers: [{
          sku: "2786",
          t: "1L",
          size: 1,
          price: 17
        }, {
          sku: "2787",
          t: "5L",
          size: 5,
          price: 55
        }, {
          sku: "2788",
          t: "10L",
          size: 10,
          price: 100
        }]
      },
      mky_zyme: {
        handle: "monkey-nutrients-ultra-zyme",
        title: "Monkey Ultra Zyme",
        unit: "ml",
        tiers: [{
          sku: "11300",
          t: "1L",
          size: 1,
          price: 20
        }, {
          sku: "11301",
          t: "5L",
          size: 5,
          price: 80
        }, {
          sku: "11299",
          t: "10L",
          size: 10,
          price: 150
        }]
      },
      bac_coco_g: {
        handle: "bac-coco-grow-ab",
        title: "BAC Coco Grow A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "8139",
          t: "1L",
          size: 1,
          price: 11.55
        }, {
          sku: "8140",
          t: "5L",
          size: 5,
          price: 35.2
        }, {
          sku: "8141",
          t: "10L",
          size: 10,
          price: 54.45
        }, {
          sku: "8142",
          t: "20L",
          size: 20,
          price: 89.1
        }]
      },
      bac_coco_b: {
        handle: "bac-coco-bloom-ab",
        title: "BAC Coco Bloom A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "8135",
          t: "1L",
          size: 1,
          price: 11.55
        }, {
          sku: "8136",
          t: "5L",
          size: 5,
          price: 35.2
        }, {
          sku: "8137",
          t: "10L",
          size: 10,
          price: 56.5
        }, {
          sku: "8138",
          t: "20L",
          size: 20,
          price: 89.1
        }]
      },
      bac_hyd_g: {
        handle: "bac-hydro-grow-ab",
        title: "BAC Hydro Grow A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "12280",
          t: "1L",
          size: 1,
          price: 12
        }, {
          sku: "12281",
          t: "5L",
          size: 5,
          price: 39.95
        }, {
          sku: "12282",
          t: "10L",
          size: 10,
          price: 49.95
        }]
      },
      bac_hyd_b: {
        handle: "bac-hydro-bloom-ab",
        title: "BAC Hydro Bloom A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "12283",
          t: "1L",
          size: 1,
          price: 12
        }, {
          sku: "12284",
          t: "5L",
          size: 5,
          price: 39.95
        }, {
          sku: "12285",
          t: "10L",
          size: 10,
          price: 49.95
        }]
      },
      bac_soil_g: {
        handle: "bac-soil-grow-one-part",
        title: "BAC Soil Grow",
        unit: "ml",
        tiers: [{
          sku: "8150",
          t: "1L",
          size: 1,
          price: 11.5
        }, {
          sku: "8151",
          t: "5L",
          size: 5,
          price: 33
        }, {
          sku: "8152",
          t: "10L",
          size: 10,
          price: 48.5
        }, {
          sku: "8153",
          t: "20L",
          size: 20,
          price: 89
        }]
      },
      bac_soil_b: {
        handle: "bac-soil-bloom-one-part",
        title: "BAC Soil Bloom",
        unit: "ml",
        tiers: [{
          sku: "8143",
          t: "1L",
          size: 1,
          price: 11.5
        }, {
          sku: "8144",
          t: "5L",
          size: 5,
          price: 33
        }, {
          sku: "8145",
          t: "10L",
          size: 10,
          price: 48.5
        }, {
          sku: "8146",
          t: "20L",
          size: 20,
          price: 89
        }]
      },
      bac_org_g: {
        handle: "bac-grow",
        title: "BAC Organic Grow",
        unit: "ml",
        tiers: [{
          sku: "2531",
          t: "1L",
          size: 1,
          price: 17
        }, {
          sku: "2532",
          t: "5L",
          size: 5,
          price: 57
        }]
      },
      bac_org_b: {
        handle: "bac-bloom",
        title: "BAC Organic Bloom",
        unit: "ml",
        tiers: [{
          sku: "4167",
          t: "1L",
          size: 1,
          price: 17
        }, {
          sku: "4166",
          t: "5L",
          size: 5,
          price: 57
        }]
      },
      bac_pk: {
        handle: "bac-organic-pk-booster",
        title: "BAC Organic PK Booster",
        unit: "ml",
        tiers: [{
          sku: "1225",
          t: "500ml",
          size: .5,
          price: 25.5
        }, {
          sku: "1226",
          t: "1L",
          size: 1,
          price: 44
        }, {
          sku: "1224",
          t: "5L",
          size: 5,
          price: 136
        }]
      },
      bac_f1: {
        handle: "bac-f1-extreme-booster",
        title: "BAC F1 Extreme Booster",
        unit: "ml",
        tiers: [{
          sku: "8130",
          t: "1L",
          size: 1,
          price: 22.5
        }, {
          sku: "8131",
          t: "5L",
          size: 5,
          price: 59.5
        }, {
          sku: "8133",
          t: "10L",
          size: 10,
          price: 99.5
        }, {
          sku: "8134",
          t: "20L",
          size: 20,
          price: 154.5
        }]
      },
      bac_root: {
        handle: "bac-organic-root-stim",
        title: "BAC Root Stimulator",
        unit: "ml",
        tiers: [{
          sku: "2440",
          t: "60ml",
          size: .06,
          price: 24
        }, {
          sku: "2441",
          t: "120ml",
          size: .12,
          price: 38.5
        }, {
          sku: "2442",
          t: "300ml",
          size: .3,
          price: 74
        }, {
          sku: "8173",
          t: "1L",
          size: 1,
          price: 231
        }]
      },
      bac_bstim: {
        handle: "bac-organic-bloom-stim",
        title: "BAC Bloom Stimulator",
        unit: "ml",
        tiers: [{
          sku: "4138",
          t: "60ml",
          size: .06,
          price: 27.5
        }, {
          sku: "4139",
          t: "120ml",
          size: .12,
          price: 40
        }, {
          sku: "4137",
          t: "300ml",
          size: .3,
          price: 79
        }, {
          sku: "8172",
          t: "1L",
          size: 1,
          price: 236
        }]
      },
      bac_final: {
        handle: "bac-final-solution",
        title: "BAC Final Solution",
        unit: "ml",
        tiers: [{
          sku: "3761",
          t: "60ml",
          size: .06,
          price: 29
        }, {
          sku: "3758",
          t: "120ml",
          size: .12,
          price: 43
        }, {
          sku: "3759",
          t: "300ml",
          size: .3,
          price: 85
        }, {
          sku: "3760",
          t: "1L",
          size: 1,
          price: 242
        }]
      },
      bac_silica: {
        handle: "bac-silica-power",
        title: "BAC Silica Power",
        unit: "ml",
        tiers: [{
          sku: "8166",
          t: "500ml",
          size: .5,
          price: 27
        }, {
          sku: "8167",
          t: "1L",
          size: 1,
          price: 41
        }, {
          sku: "8168",
          t: "5L",
          size: 5,
          price: 156
        }]
      },
      bac_calmag: {
        handle: "bac-calmag-20",
        title: "BAC CalMag 2.0",
        unit: "ml",
        tiers: [{
          sku: "12436",
          t: "250ml",
          size: .25,
          price: 8
        }, {
          sku: "8154",
          t: "500ml",
          size: .5,
          price: 11.5
        }, {
          sku: "8155",
          t: "1L",
          size: 1,
          price: 20.5
        }, {
          sku: "8156",
          t: "5L",
          size: 5,
          price: 92
        }, {
          sku: "8157",
          t: "10L",
          size: 10,
          price: 166.5
        }]
      },
      dp_hc_grow_h: {
        handle: "dutch-pro-hydro-coco-grow-a-b",
        title: "Dutch Pro Hydro/Coco Grow A+B (Hard)",
        unit: "ml",
        ab: true,
        water: "hard",
        tiers: [{
          sku: "5588",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "5589",
          t: "5L",
          size: 5,
          price: 35
        }, {
          sku: "5590",
          t: "10L",
          size: 10,
          price: 53
        }, {
          sku: "5591",
          t: "20L",
          size: 20,
          price: 97
        }]
      },
      dp_hc_grow_s: {
        handle: "dutch-pro-hydro-coco-grow-a-b",
        title: "Dutch Pro Hydro/Coco Grow A+B (Soft)",
        unit: "ml",
        ab: true,
        water: "soft",
        tiers: [{
          sku: "710",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "711",
          t: "5L",
          size: 5,
          price: 35
        }, {
          sku: "712",
          t: "10L",
          size: 10,
          price: 53
        }, {
          sku: "713",
          t: "20L",
          size: 20,
          price: 97
        }]
      },
      dp_hc_bloom_h: {
        handle: "dutch-pro-hydro-coco-bloom-a-b",
        title: "Dutch Pro Hydro/Coco Bloom A+B (Hard)",
        unit: "ml",
        ab: true,
        water: "hard",
        tiers: [{
          sku: "5560",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "5561",
          t: "5L",
          size: 5,
          price: 34
        }, {
          sku: "5562",
          t: "10L",
          size: 10,
          price: 53
        }, {
          sku: "5563",
          t: "20L",
          size: 20,
          price: 97
        }]
      },
      dp_hc_bloom_s: {
        handle: "dutch-pro-hydro-coco-bloom-a-b",
        title: "Dutch Pro Hydro/Coco Bloom A+B (Soft)",
        unit: "ml",
        ab: true,
        water: "soft",
        tiers: [{
          sku: "1154",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "1155",
          t: "5L",
          size: 5,
          price: 34
        }, {
          sku: "1156",
          t: "10L",
          size: 10,
          price: 53
        }, {
          sku: "1157",
          t: "20L",
          size: 20,
          price: 97
        }]
      },
      dp_so_grow_h: {
        handle: "dutch-pro-soil-grow-a-b",
        title: "Dutch Pro Soil Grow A+B (Hard)",
        unit: "ml",
        ab: true,
        water: "hard",
        tiers: [{
          sku: "5601",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "5602",
          t: "5L",
          size: 5,
          price: 34
        }, {
          sku: "5603",
          t: "10L",
          size: 10,
          price: 53
        }, {
          sku: "5604",
          t: "20L",
          size: 20,
          price: 97
        }]
      },
      dp_so_grow_s: {
        handle: "dutch-pro-soil-grow-a-b",
        title: "Dutch Pro Soil Grow A+B (Soft)",
        unit: "ml",
        ab: true,
        water: "soft",
        tiers: [{
          sku: "1080",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "1081",
          t: "5L",
          size: 5,
          price: 34
        }, {
          sku: "1082",
          t: "10L",
          size: 10,
          price: 53
        }, {
          sku: "1083",
          t: "20L",
          size: 20,
          price: 97
        }]
      },
      dp_so_bloom_h: {
        handle: "dutch-pro-soil-bloom-a-b",
        title: "Dutch Pro Soil Bloom A+B (Hard)",
        unit: "ml",
        ab: true,
        water: "hard",
        tiers: [{
          sku: "5597",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "5598",
          t: "5L",
          size: 5,
          price: 34
        }, {
          sku: "5599",
          t: "10L",
          size: 10,
          price: 53
        }, {
          sku: "5600",
          t: "20L",
          size: 20,
          price: 97
        }]
      },
      dp_so_bloom_s: {
        handle: "dutch-pro-soil-bloom-a-b",
        title: "Dutch Pro Soil Bloom A+B (Soft)",
        unit: "ml",
        ab: true,
        water: "soft",
        tiers: [{
          sku: "254",
          t: "1L",
          size: 1,
          price: 16
        }, {
          sku: "255",
          t: "5L",
          size: 5,
          price: 34
        }, {
          sku: "256",
          t: "10L",
          size: 10,
          price: 53
        }, {
          sku: "257",
          t: "20L",
          size: 20,
          price: 97
        }]
      },
      dp_silica: {
        handle: "dutch-pro-silica-von-liebig-1",
        title: "Dutch Pro Silica (Von Liebig)",
        unit: "ml",
        tiers: [{
          sku: "10101",
          t: "250ml",
          size: .25,
          price: 33
        }, {
          sku: "10102",
          t: "1L",
          size: 1,
          price: 78
        }, {
          sku: "10103",
          t: "5L",
          size: 5,
          price: 329
        }, {
          sku: "10104",
          t: "10L",
          size: 10,
          price: 595
        }, {
          sku: "10105",
          t: "20L",
          size: 20,
          price: 1075
        }]
      },
      dp_root: {
        handle: "dutch-pro-take-root",
        title: "Dutch Pro Take Root",
        unit: "ml",
        tiers: [{
          sku: "139",
          t: "250ml",
          size: .25,
          price: 17.99
        }, {
          sku: "140",
          t: "1L",
          size: 1,
          price: 42
        }, {
          sku: "141",
          t: "5L",
          size: 5,
          price: 179.99
        }, {
          sku: "6990",
          t: "10L",
          size: 10,
          price: 315
        }, {
          sku: "8585",
          t: "20L",
          size: 20,
          price: 589
        }]
      },
      dp_multi: {
        handle: "dutch-pro-multi-total",
        title: "Dutch Pro Multi Total",
        unit: "ml",
        tiers: [{
          sku: "642",
          t: "250ml",
          size: .25,
          price: 8.99
        }, {
          sku: "643",
          t: "1L",
          size: 1,
          price: 24
        }, {
          sku: "644",
          t: "5L",
          size: 5,
          price: 89.99
        }, {
          sku: "645",
          t: "10L",
          size: 10,
          price: 170
        }, {
          sku: "8586",
          t: "20L",
          size: 20,
          price: 274.99
        }]
      },
      dp_explode: {
        handle: "dutch-pro-explode",
        title: "Dutch Pro Explode",
        unit: "ml",
        tiers: [{
          sku: "937",
          t: "250ml",
          size: .25,
          price: 32
        }, {
          sku: "938",
          t: "1L",
          size: 1,
          price: 75
        }, {
          sku: "939",
          t: "5L",
          size: 5,
          price: 283
        }, {
          sku: "940",
          t: "10L",
          size: 10,
          price: 529
        }, {
          sku: "8584",
          t: "20L",
          size: 20,
          price: 962
        }]
      },
      dp_amino: {
        handle: "amino-strength-amino-acid-nutrient-blend",
        title: "Dutch Pro Amino Strength",
        unit: "ml",
        tiers: [{
          sku: "10094",
          t: "250ml",
          size: .25,
          price: 49.95
        }, {
          sku: "10095",
          t: "1L",
          size: 1,
          price: 124
        }, {
          sku: "10096",
          t: "5L",
          size: 5,
          price: 580
        }]
      },
      dp_calmag: {
        handle: "dutch-pro-cal-mag-1",
        title: "Dutch Pro Cal Mag",
        unit: "ml",
        tiers: [{
          sku: "10097",
          t: "1L",
          size: 1,
          price: 19.5
        }, {
          sku: "10098",
          t: "5L",
          size: 5,
          price: 74
        }, {
          sku: "10099",
          t: "10L",
          size: 10,
          price: 155
        }, {
          sku: "10100",
          t: "20L",
          size: 20,
          price: 259
        }]
      },
      dp_clean: {
        handle: "dutch-pro-keep-it-clean",
        title: "Dutch Pro Keep It Clean",
        unit: "ml",
        tiers: [{
          sku: "1960",
          t: "1L",
          size: 1,
          price: 31.45
        }, {
          sku: "1961",
          t: "5L",
          size: 5,
          price: 130.45
        }, {
          sku: "10062",
          t: "10L",
          size: 10,
          price: 189
        }, {
          sku: "10063",
          t: "20L",
          size: 20,
          price: 369
        }]
      },
      ht_hy_grow: {
        handle: "hydrotops-hydro-grow",
        title: "Hydrotops Hydro Grow A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "657",
          t: "1L",
          size: 1,
          price: 20
        }, {
          sku: "658",
          t: "5L",
          size: 5,
          price: 50
        }, {
          sku: "659",
          t: "25L",
          size: 25,
          price: 195
        }]
      },
      ht_hy_bloom: {
        handle: "hydrotops-hydro-bloom",
        title: "Hydrotops Hydro Bloom A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "118",
          t: "1L",
          size: 1,
          price: 20
        }, {
          sku: "116",
          t: "5L",
          size: 5,
          price: 50
        }, {
          sku: "117",
          t: "25L",
          size: 25,
          price: 195
        }]
      },
      ht_co_grow: {
        handle: "hydrotops-coco-grow",
        title: "Hydrotops Coco Grow A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "883",
          t: "1L",
          size: 1,
          price: 20
        }, {
          sku: "884",
          t: "5L",
          size: 5,
          price: 50
        }, {
          sku: "885",
          t: "25L",
          size: 25,
          price: 195
        }]
      },
      ht_co_bloom: {
        handle: "hydrotops-coco-bloom",
        title: "Hydrotops Coco Bloom A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "1088",
          t: "1L",
          size: 1,
          price: 20
        }, {
          sku: "1089",
          t: "5L",
          size: 5,
          price: 50
        }, {
          sku: "1090",
          t: "25L",
          size: 25,
          price: 195
        }]
      },
      ht_so_grow: {
        handle: "hydrotops-solo-grow-soil",
        title: "Hydrotops Solo Grow (soil)",
        unit: "ml",
        tiers: [{
          sku: "260",
          t: "1L",
          size: 1,
          price: 22
        }, {
          sku: "261",
          t: "5L",
          size: 5,
          price: 50
        }, {
          sku: "262",
          t: "25L",
          size: 25,
          price: 195
        }]
      },
      ht_so_bloom: {
        handle: "hydrotops-solo-bloom-soil",
        title: "Hydrotops Solo Bloom (soil)",
        unit: "ml",
        tiers: [{
          sku: "336",
          t: "1L",
          size: 1,
          price: 22
        }, {
          sku: "337",
          t: "5L",
          size: 5,
          price: 50
        }, {
          sku: "338",
          t: "25L",
          size: 25,
          price: 195
        }]
      },
      ht_root: {
        handle: "hydrotops-root-stim",
        title: "Hydrotops Root Stimulator",
        unit: "ml",
        tiers: [{
          sku: "1767",
          t: "1L",
          size: 1,
          price: 22
        }, {
          sku: "1768",
          t: "5L",
          size: 5,
          price: 75
        }, {
          sku: "1769",
          t: "25L",
          size: 25,
          price: 275
        }]
      },
      ht_bact: {
        handle: "hydrotops-bactivator",
        title: "Hydrotops Bactivator",
        unit: "ml",
        tiers: [{
          sku: "775",
          t: "12 dose / 125ml",
          size: .125,
          price: 25
        }, {
          sku: "776",
          t: "25 dose / 250ml",
          size: .25,
          price: 40
        }]
      },
      ht_head: {
        handle: "hydrotops-head-start",
        title: "Hydrotops Head Start",
        unit: "ml",
        tiers: [{
          sku: "2842",
          t: "1L",
          size: 1,
          price: 19
        }, {
          sku: "2843",
          t: "5L",
          size: 5,
          price: 55
        }, {
          sku: "2841",
          t: "25L",
          size: 25,
          price: 220
        }]
      },
      ht_thc: {
        handle: "hydrotops-top-heavy-crop",
        title: "Hydrotops Top Heavy Crop",
        unit: "ml",
        tiers: [{
          sku: "2416",
          t: "125ml",
          size: .125,
          price: 43
        }, {
          sku: "2417",
          t: "250ml",
          size: .25,
          price: 70
        }, {
          sku: "2418",
          t: "500ml",
          size: .5,
          price: 105
        }]
      },
      ht_triplef: {
        handle: "hydrotops-triple-f",
        title: "Hydrotops Triple F",
        unit: "ml",
        tiers: [{
          sku: "2253",
          t: "125ml",
          size: .125,
          price: 40
        }, {
          sku: "2254",
          t: "250ml",
          size: .25,
          price: 65
        }, {
          sku: "2255",
          t: "500ml",
          size: .5,
          price: 100
        }]
      },
      ht_boost: {
        handle: "hydrotops-floral-boost",
        title: "Hydrotops Floral Boost",
        unit: "ml",
        tiers: [{
          sku: "2383",
          t: "1L",
          size: 1,
          price: 22
        }, {
          sku: "2384",
          t: "5L",
          size: 5,
          price: 75
        }, {
          sku: "2385",
          t: "25L",
          size: 25,
          price: 275
        }]
      },
      ht_flush: {
        handle: "hydrotops-flush",
        title: "Hydrotops Flush",
        unit: "ml",
        tiers: [{
          sku: "4807",
          t: "1L",
          size: 1,
          price: 19
        }, {
          sku: "4808",
          t: "5L",
          size: 5,
          price: 55
        }, {
          sku: "4809",
          t: "25L",
          size: 25,
          price: 220
        }]
      },
      an_coco_grow: {
        handle: "advanced-nutrients-coco-sensi-grow-ab",
        title: "AN Coco Sensi Grow A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "8496",
          t: "500ml",
          size: .5,
          price: 13.95
        }, {
          sku: "2905",
          t: "1L",
          size: 1,
          price: 22.49
        }, {
          sku: "8497",
          t: "5L",
          size: 5,
          price: 98.99
        }, {
          sku: "7036",
          t: "10L",
          size: 10,
          price: 157.99
        }]
      },
      an_coco_bloom: {
        handle: "advanced-nutrients-coco-sensi-bloom-ab",
        title: "AN Coco Sensi Bloom A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "8494",
          t: "500ml",
          size: .5,
          price: 13.95
        }, {
          sku: "4800",
          t: "1L",
          size: 1,
          price: 22.45
        }, {
          sku: "8495",
          t: "5L",
          size: 5,
          price: 93.95
        }, {
          sku: "6159",
          t: "10L",
          size: 10,
          price: 163.95
        }, {
          sku: "9675",
          t: "20L",
          size: 20,
          price: 319
        }]
      },
      an_soil_grow: {
        handle: "advanced-nutrients-sensi-grow-ab",
        title: "AN Sensi Grow A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "9677",
          t: "500ml",
          size: .5,
          price: 13.95
        }, {
          sku: "1829",
          t: "1L",
          size: 1,
          price: 22.45
        }, {
          sku: "1828",
          t: "4L",
          size: 4,
          price: 84
        }, {
          sku: "8500",
          t: "5L",
          size: 5,
          price: 93.95
        }, {
          sku: "7047",
          t: "10L",
          size: 10,
          price: 163.95
        }]
      },
      an_soil_bloom: {
        handle: "advanced-nutrients-sensi-bloom-ab",
        title: "AN Sensi Bloom A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "9676",
          t: "500ml",
          size: .5,
          price: 13.95
        }, {
          sku: "2648",
          t: "1L",
          size: 1,
          price: 22.45
        }, {
          sku: "2649",
          t: "4L",
          size: 4,
          price: 84
        }, {
          sku: "8499",
          t: "5L",
          size: 5,
          price: 93.95
        }, {
          sku: "6158",
          t: "10L",
          size: 10,
          price: 163.95
        }]
      },
      an_gmb_grow: {
        handle: "advanced-nutrients-3-part-micro-grow-bloom",
        title: "AN 3-Part Grow",
        unit: "ml",
        tiers: [{
          sku: "8501",
          t: "500ml",
          size: .5,
          price: 7.9
        }, {
          sku: "6550",
          t: "1L",
          size: 1,
          price: 10.2
        }, {
          sku: "6551",
          t: "4L",
          size: 4,
          price: 34
        }, {
          sku: "8502",
          t: "5L",
          size: 5,
          price: 42.95
        }, {
          sku: "7037",
          t: "10L",
          size: 10,
          price: 84
        }]
      },
      an_gmb_micro: {
        handle: "advanced-nutrients-3-part-micro-grow-bloom",
        title: "AN 3-Part Micro",
        unit: "ml",
        tiers: [{
          sku: "8503",
          t: "500ml",
          size: .5,
          price: 11.05
        }, {
          sku: "6552",
          t: "1L",
          size: 1,
          price: 14
        }, {
          sku: "6554",
          t: "4L",
          size: 4,
          price: 34
        }, {
          sku: "8504",
          t: "5L",
          size: 5,
          price: 42.95
        }, {
          sku: "7038",
          t: "10L",
          size: 10,
          price: 88
        }]
      },
      an_gmb_bloom: {
        handle: "advanced-nutrients-3-part-micro-grow-bloom",
        title: "AN 3-Part Bloom",
        unit: "ml",
        tiers: [{
          sku: "8505",
          t: "500ml",
          size: .5,
          price: 7.9
        }, {
          sku: "6553",
          t: "1L",
          size: 1,
          price: 10.2
        }, {
          sku: "6555",
          t: "4L",
          size: 4,
          price: 34
        }, {
          sku: "8506",
          t: "5L",
          size: 5,
          price: 42.09
        }, {
          sku: "7039",
          t: "10L",
          size: 10,
          price: 84
        }]
      },
      an_b52: {
        handle: "advanced-nutrients-b52",
        title: "AN B-52",
        unit: "ml",
        tiers: [{
          sku: "8507",
          t: "250ml",
          size: .25,
          price: 9.99
        }, {
          sku: "8508",
          t: "500ml",
          size: .5,
          price: 19.95
        }, {
          sku: "2141",
          t: "1L",
          size: 1,
          price: 32.49
        }, {
          sku: "2139",
          t: "5L",
          size: 5,
          price: 149.99
        }, {
          sku: "2140",
          t: "10L",
          size: 10,
          price: 256.95
        }]
      },
      an_voodoo: {
        handle: "advanced-nutrients-voodoo",
        title: "AN Voodoo Juice",
        unit: "ml",
        tiers: [{
          sku: "3347",
          t: "250ml",
          size: .25,
          price: 21.99
        }, {
          sku: "3344",
          t: "500ml",
          size: .5,
          price: 42
        }, {
          sku: "3345",
          t: "1L",
          size: 1,
          price: 54.99
        }, {
          sku: "8538",
          t: "5L",
          size: 5,
          price: 229.99
        }]
      },
      an_bigbud: {
        handle: "advanced-nutrients-big-bud",
        title: "AN Big Bud",
        unit: "ml",
        tiers: [{
          sku: "7383",
          t: "250ml",
          size: .25,
          price: 11.8
        }, {
          sku: "8491",
          t: "500ml",
          size: .5,
          price: 22
        }, {
          sku: "4513",
          t: "1L",
          size: 1,
          price: 28.5
        }, {
          sku: "8188",
          t: "5L",
          size: 5,
          price: 124.1
        }, {
          sku: "4515",
          t: "10L",
          size: 10,
          price: 197.2
        }]
      },
      an_bigbud_coco: {
        handle: "advanced-nutrients-coco-big-bud",
        title: "AN COCO Big Bud",
        unit: "ml",
        tiers: [{
          sku: "7385",
          t: "250ml",
          size: .25,
          price: 9.79
        }, {
          sku: "8493",
          t: "500ml",
          size: .5,
          price: 20.45
        }, {
          sku: "1803",
          t: "1L",
          size: 1,
          price: 28.9
        }, {
          sku: "8187",
          t: "5L",
          size: 5,
          price: 130.9
        }, {
          sku: "1802",
          t: "10L",
          size: 10,
          price: 201.89
        }, {
          sku: "11261",
          t: "20L",
          size: 20,
          price: 386.75
        }]
      },
      an_overdrive: {
        handle: "advanced-nutrients-overdrive",
        title: "AN Overdrive",
        unit: "ml",
        tiers: [{
          sku: "7386",
          t: "250ml",
          size: .25,
          price: 10.79
        }, {
          sku: "8498",
          t: "500ml",
          size: .5,
          price: 18.95
        }, {
          sku: "3746",
          t: "1L",
          size: 1,
          price: 30.5
        }, {
          sku: "8189",
          t: "5L",
          size: 5,
          price: 134.99
        }, {
          sku: "3748",
          t: "10L",
          size: 10,
          price: 206.99
        }, {
          sku: "12565",
          t: "20L",
          size: 20,
          price: 395
        }]
      },
      an_tarantula: {
        handle: "advanced-nutrients-tarantula",
        title: "AN Tarantula",
        unit: "ml",
        tiers: [{
          sku: "3421",
          t: "250ml",
          size: .25,
          price: 18.99
        }, {
          sku: "7045",
          t: "500ml",
          size: .5,
          price: 34.95
        }, {
          sku: "3422",
          t: "1L",
          size: 1,
          price: 54.99
        }, {
          sku: "8537",
          t: "5L",
          size: 5,
          price: 493
        }]
      },
      an_piranha: {
        handle: "advanced-nutrients-piranha",
        title: "AN Piranha",
        unit: "ml",
        tiers: [{
          sku: "2484",
          t: "250ml",
          size: .25,
          price: 21.49
        }, {
          sku: "2485",
          t: "500ml",
          size: .5,
          price: 40.99
        }, {
          sku: "2486",
          t: "1L",
          size: 1,
          price: 69.99
        }, {
          sku: "8526",
          t: "5L",
          size: 5,
          price: 296.99
        }]
      },
      an_rhino: {
        handle: "advanced-nutrients-rhino-skin",
        title: "AN Rhino Skin",
        unit: "ml",
        tiers: [{
          sku: "8532",
          t: "250ml",
          size: .25,
          price: 9.79
        }, {
          sku: "8530",
          t: "500ml",
          size: .5,
          price: 16.99
        }, {
          sku: "4556",
          t: "1L",
          size: 1,
          price: 23.99
        }, {
          sku: "8531",
          t: "5L",
          size: 5,
          price: 114.99
        }, {
          sku: "12564",
          t: "10L",
          size: 10,
          price: 195
        }]
      },
      an_sensizym: {
        handle: "advanced-nutrients-sensizym",
        title: "AN Sensizym",
        unit: "ml",
        tiers: [{
          sku: "8535",
          t: "250ml",
          size: .25,
          price: 11.95
        }, {
          sku: "8534",
          t: "500ml",
          size: .5,
          price: 20
        }, {
          sku: "4607",
          t: "1L",
          size: 1,
          price: 24.49
        }, {
          sku: "8536",
          t: "5L",
          size: 5,
          price: 139.99
        }]
      },
      an_budcandy: {
        handle: "advanced-nutrients-bud-candy",
        title: "AN Bud Candy",
        unit: "ml",
        tiers: [{
          sku: "8492",
          t: "250ml",
          size: .25,
          price: 10.99
        }, {
          sku: "7384",
          t: "500ml",
          size: .5,
          price: 15.95
        }, {
          sku: "1735",
          t: "1L",
          size: 1,
          price: 27.95
        }, {
          sku: "7775",
          t: "5L",
          size: 5,
          price: 109
        }, {
          sku: "1737",
          t: "10L",
          size: 10,
          price: 210
        }]
      },
      an_terpenes: {
        handle: "advanced-nutrients-nirvana",
        title: "AN Tasty Terpenes",
        unit: "ml",
        tiers: [{
          sku: "8524",
          t: "250ml",
          size: .25,
          price: 14.49
        }, {
          sku: "8523",
          t: "500ml",
          size: .5,
          price: 28
        }, {
          sku: "5111",
          t: "1L",
          size: 1,
          price: 40.4
        }, {
          sku: "8525",
          t: "5L",
          size: 5,
          price: 169
        }]
      },
      an_flawless: {
        handle: "advanced-nutrients-flawless-finish",
        title: "AN Flawless Finish",
        unit: "ml",
        tiers: [{
          sku: "8521",
          t: "250ml",
          size: .25,
          price: 6.29
        }, {
          sku: "8520",
          t: "500ml",
          size: .5,
          price: 12.94
        }, {
          sku: "1753",
          t: "1L",
          size: 1,
          price: 17.09
        }, {
          sku: "1754",
          t: "4L",
          size: 4,
          price: 62
        }, {
          sku: "8522",
          t: "5L",
          size: 5,
          price: 80
        }]
      },
      rm_micro: {
        handle: "remo-nutrients-micro-micronutrient-base",
        title: "Remo Micro",
        unit: "ml",
        tiers: [{
          sku: "13308",
          t: "1L",
          size: 1,
          price: 9.95
        }, {
          sku: "13309",
          t: "5L",
          size: 5,
          price: 50.95
        }, {
          sku: "13310",
          t: "10L",
          size: 10,
          price: 91.95
        }, {
          sku: "13311",
          t: "20L",
          size: 20,
          price: 148.95
        }]
      },
      rm_grow: {
        handle: "remo-nutrients-grow-vegetative-base-nutrient",
        title: "Remo Grow",
        unit: "ml",
        tiers: [{
          sku: "13300",
          t: "1L",
          size: 1,
          price: 9.95
        }, {
          sku: "13301",
          t: "5L",
          size: 5,
          price: 48.95
        }, {
          sku: "13302",
          t: "10L",
          size: 10,
          price: 88.95
        }, {
          sku: "13303",
          t: "20L",
          size: 20,
          price: 144.95
        }]
      },
      rm_bloom: {
        handle: "remo-nutrients-bloom-flowering-base-nutrient",
        title: "Remo Bloom",
        unit: "ml",
        tiers: [{
          sku: "13304",
          t: "1L",
          size: 1,
          price: 9.95
        }, {
          sku: "13305",
          t: "5L",
          size: 5,
          price: 48.95
        }, {
          sku: "13306",
          t: "10L",
          size: 10,
          price: 88.95
        }, {
          sku: "13307",
          t: "20L",
          size: 20,
          price: 144.95
        }]
      },
      rm_velo: {
        handle: "remo-nutrients-velokelp-kelp-extract-root-vigour-booster",
        title: "Remo VeloKelp",
        unit: "ml",
        tiers: [{
          sku: "13324",
          t: "1L",
          size: 1,
          price: 17.95
        }, {
          sku: "13325",
          t: "5L",
          size: 5,
          price: 98.95
        }, {
          sku: "13326",
          t: "10L",
          size: 10,
          price: 179.95
        }, {
          sku: "13327",
          t: "20L",
          size: 20,
          price: 294.95
        }]
      },
      rm_magni: {
        handle: "remo-nutrients-magnifical-calcium-magnesium-supplement",
        title: "Remo MagNifiCal",
        unit: "ml",
        tiers: [{
          sku: "13316",
          t: "1L",
          size: 1,
          price: 9.95
        }, {
          sku: "13317",
          t: "5L",
          size: 5,
          price: 50.95
        }, {
          sku: "13318",
          t: "10L",
          size: 10,
          price: 91.95
        }, {
          sku: "13319",
          t: "20L",
          size: 20,
          price: 148.95
        }]
      },
      rm_candy: {
        handle: "remo-nutrients-natures-candy-carbohydrate-flavour-enhancer",
        title: "Remo Nature's Candy",
        unit: "ml",
        tiers: [{
          sku: "13320",
          t: "1L",
          size: 1,
          price: 11.95
        }, {
          sku: "13321",
          t: "5L",
          size: 5,
          price: 64.95
        }, {
          sku: "13322",
          t: "10L",
          size: 10,
          price: 117.95
        }, {
          sku: "13323",
          t: "20L",
          size: 20,
          price: 191.95
        }]
      },
      rm_astro: {
        handle: "remo-nutrients-astro-flower-flowering-booster",
        title: "Remo AstroFlower",
        unit: "ml",
        tiers: [{
          sku: "13312",
          t: "1L",
          size: 1,
          price: 12.95
        }, {
          sku: "13313",
          t: "5L",
          size: 5,
          price: 65.95
        }, {
          sku: "13314",
          t: "10L",
          size: 10,
          price: 119.95
        }, {
          sku: "13315",
          t: "20L",
          size: 20,
          price: 195.95
        }]
      },
      rm_el_a: {
        handle: "remo-elements-part-a-water-soluble-base-nutrient",
        title: "Remo Elements Part A",
        unit: "g",
        tiers: [{
          sku: "13328",
          t: "250g",
          size: .25,
          price: 13.95
        }, {
          sku: "13329",
          t: "1kg",
          size: 1,
          price: 34.95
        }]
      },
      rm_el_b: {
        handle: "remo-elements-part-b-water-soluble-bloom-supplement",
        title: "Remo Elements Part B",
        unit: "g",
        tiers: [{
          sku: "13330",
          t: "250g",
          size: .25,
          price: 9.95
        }, {
          sku: "13331",
          t: "1kg",
          size: 1,
          price: 24.95
        }]
      },
      rm_el_boost: {
        handle: "remo-elements-supercharged-boost-water-soluble-pk-booster",
        title: "Remo Elements Supercharged Boost",
        unit: "g",
        tiers: [{
          sku: "13332",
          t: "250g",
          size: .25,
          price: 11.95
        }, {
          sku: "13333",
          t: "1kg",
          size: 1,
          price: 31.95
        }]
      },
      hg_aqua: {
        handle: "house-garden-aqua-flakes-ab",
        title: "H&G Aqua Flakes A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "4213",
          t: "1L",
          size: 1,
          price: 19
        }, {
          sku: "4214",
          t: "5L",
          size: 5,
          price: 45
        }, {
          sku: "4215",
          t: "10L",
          size: 10,
          price: 69
        }]
      },
      hg_coco: {
        handle: "house-garden-coco-ab-grow",
        title: "H&G Cocos A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "2469",
          t: "1L",
          size: 1,
          price: 19
        }, {
          sku: "2470",
          t: "5L",
          size: 5,
          price: 45
        }, {
          sku: "2471",
          t: "10L",
          size: 10,
          price: 65
        }, {
          sku: "2472",
          t: "20L",
          size: 20,
          price: 110
        }]
      },
      hg_hydro: {
        handle: "house-garden-hydro-ab",
        title: "H&G Hydro A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "2500",
          t: "1L",
          size: 1,
          price: 19
        }, {
          sku: "2501",
          t: "5L",
          size: 5,
          price: 45
        }, {
          sku: "2502",
          t: "10L",
          size: 10,
          price: 69
        }]
      },
      hg_soil: {
        handle: "house-garden-aarde-soil-ab",
        title: "H&G Soil A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "3827",
          t: "1L",
          size: 1,
          price: 18
        }, {
          sku: "3828",
          t: "5L",
          size: 5,
          price: 46
        }, {
          sku: "3829",
          t: "10L",
          size: 10,
          price: 69
        }, {
          sku: "3830",
          t: "20L",
          size: 20,
          price: 105
        }]
      },
      hg_drip: {
        handle: "house-garden-drip-clean",
        title: "H&G Drip Clean",
        unit: "ml",
        tiers: [{
          sku: "2673",
          t: "250ml",
          size: .25,
          price: 9.95
        }, {
          sku: "9380",
          t: "500ml",
          size: .5,
          price: 16.95
        }, {
          sku: "2672",
          t: "1L",
          size: 1,
          price: 28.95
        }]
      },
      hg_roots: {
        handle: "house-garden-roots-excelurator",
        title: "H&G Roots Excelurator",
        unit: "ml",
        tiers: [{
          sku: "4054",
          t: "100ml",
          size: .1,
          price: 19
        }, {
          sku: "4055",
          t: "250ml",
          size: .25,
          price: 36.95
        }, {
          sku: "4056",
          t: "500ml",
          size: .5,
          price: 62
        }, {
          sku: "4057",
          t: "1L",
          size: 1,
          price: 110
        }, {
          sku: "4058",
          t: "5L",
          size: 5,
          price: 490
        }]
      },
      hg_amino: {
        handle: "house-garden-amino-treatment",
        title: "H&G Amino Treatment",
        unit: "ml",
        tiers: [{
          sku: "4141",
          t: "100ml",
          size: .1,
          price: 14.99
        }, {
          sku: "4142",
          t: "250ml",
          size: .25,
          price: 30
        }, {
          sku: "4143",
          t: "500ml",
          size: .5,
          price: 39.99
        }, {
          sku: "4144",
          t: "1L",
          size: 1,
          price: 79.99
        }]
      },
      hg_zen: {
        handle: "house-garden-multi-zyme",
        title: "H&G Multi Zen",
        unit: "ml",
        tiers: [{
          sku: "1890",
          t: "500ml",
          size: .5,
          price: 13
        }, {
          sku: "1891",
          t: "1L",
          size: 1,
          price: 20
        }, {
          sku: "1888",
          t: "5L",
          size: 5,
          price: 87
        }, {
          sku: "1889",
          t: "20L",
          size: 20,
          price: 295
        }]
      },
      hg_algen: {
        handle: "house-garden-algen-extract",
        title: "H&G Algen Extract",
        unit: "ml",
        tiers: [{
          sku: "1840",
          t: "250ml",
          size: .25,
          price: 17.5
        }, {
          sku: "1841",
          t: "1L",
          size: 1,
          price: 58
        }]
      },
      hg_nitro: {
        handle: "house-garden-nitrogen-n-27",
        title: "H&G Nitrogen Boost",
        unit: "ml",
        tiers: [{
          sku: "4202",
          t: "250ml",
          size: .25,
          price: 16
        }, {
          sku: "4203",
          t: "500ml",
          size: .5,
          price: 25
        }, {
          sku: "10215",
          t: "1L",
          size: 1,
          price: 42
        }]
      },
      hg_budxl: {
        handle: "house-garden-bud-xl",
        title: "H&G Bud-XL",
        unit: "ml",
        tiers: [{
          sku: "12129",
          t: "250ml",
          size: .25,
          price: 8.99
        }, {
          sku: "3297",
          t: "500ml",
          size: .5,
          price: 17
        }, {
          sku: "3298",
          t: "1L",
          size: 1,
          price: 27
        }, {
          sku: "3299",
          t: "5L",
          size: 5,
          price: 96
        }, {
          sku: "3300",
          t: "20L",
          size: 20,
          price: 385
        }]
      },
      hg_topb: {
        handle: "house-garden-top-booster",
        title: "H&G Top Booster",
        unit: "ml",
        tiers: [{
          sku: "3912",
          t: "500ml",
          size: .5,
          price: 9
        }, {
          sku: "3913",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "3914",
          t: "5L",
          size: 5,
          price: 55
        }]
      },
      hg_tops: {
        handle: "house-garden-topshooter-additive-alu",
        title: "H&G Top Shooter",
        unit: "ml",
        tiers: [{
          sku: "3898",
          t: "250ml",
          size: .25,
          price: 26
        }, {
          sku: "3899",
          t: "500ml",
          size: .5,
          price: 44
        }, {
          sku: "3900",
          t: "1L",
          size: 1,
          price: 79
        }]
      },
      hg_shoot: {
        handle: "house-garden-shooting-powder",
        title: "H&G Shooting Powder",
        unit: "g",
        tiers: [{
          sku: "2666",
          t: "1 sachet",
          size: .065,
          price: 10
        }, {
          sku: "2667",
          t: "5 sachets",
          size: .325,
          price: 35
        }]
      },
      hg_magic: {
        handle: "house-garden-magic-green-foliar",
        title: "H&G Magic Green",
        unit: "ml",
        tiers: [{
          sku: "2178",
          t: "250ml",
          size: .25,
          price: 18
        }, {
          sku: "2179",
          t: "500ml",
          size: .5,
          price: 29
        }, {
          sku: "2180",
          t: "1L",
          size: 1,
          price: 52
        }]
      },
      si_canna: {
        handle: "canna-silica",
        title: "CANNA Silica",
        unit: "ml",
        tiers: [{
          sku: "13077",
          t: "1L",
          size: 1,
          price: 19.99
        }]
      },
      si_mills: {
        handle: "mills-vitalize-silicon-supplement",
        title: "Mills Vitalize",
        unit: "ml",
        tiers: [{
          sku: "6556",
          t: "250ml",
          size: .25,
          price: 53.99
        }, {
          sku: "709",
          t: "1L",
          size: 1,
          price: 166
        }, {
          sku: "708",
          t: "5L",
          size: 5,
          price: 510
        }]
      },
      si_grenade: {
        handle: "grenade-white-msa-max",
        title: "Grenade White MSA Max",
        unit: "ml",
        tiers: [{
          sku: "13171",
          t: "250ml",
          size: .25,
          price: 60
        }, {
          sku: "13172",
          t: "1L",
          size: 1,
          price: 190
        }]
      },
      ipm_athena: {
        handle: "athena-ipm",
        title: "Athena IPW (IPM)",
        unit: "ml",
        tiers: [{
          sku: "1032",
          t: "0.9L",
          size: .9,
          price: 58
        }, {
          sku: "1033",
          t: "3.78L",
          size: 3.785,
          price: 139
        }, {
          sku: "9154",
          t: "5 x 3.78L",
          size: 18.927,
          price: 599
        }]
      },
      ipm_evios: {
        handle: "optic-foliar-evios-transport-pair-flower-safe-ipm-kit",
        title: "Optic Foliar Evios + Transport",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "13288",
          t: "250ml",
          size: .25,
          price: 54
        }, {
          sku: "13289",
          t: "500ml",
          size: .5,
          price: 90.99
        }]
      },
      ipm_cure: {
        handle: "canna-cure-concentrate",
        title: "CANNA Cure Concentrate",
        unit: "ml",
        tiers: [{
          sku: "648",
          t: "1L",
          size: 1,
          price: 21
        }, {
          sku: "649",
          t: "5L",
          size: 5,
          price: 73
        }]
      },
      bb_grow: {
        handle: "biobizz-bio-grow",
        title: "Biobizz Bio-Grow",
        unit: "ml",
        tiers: [{
          sku: "6557",
          t: "250ml",
          size: .25,
          price: 4.5
        }, {
          sku: "27",
          t: "500ml",
          size: .5,
          price: 5.39
        }, {
          sku: "28",
          t: "1L",
          size: 1,
          price: 8.99
        }, {
          sku: "29",
          t: "5L",
          size: 5,
          price: 31.49
        }, {
          sku: "6274",
          t: "10L",
          size: 10,
          price: 62.99
        }, {
          sku: "7649",
          t: "20L",
          size: 20,
          price: 107.99
        }]
      },
      bb_fish: {
        handle: "biobizz-fish-mix",
        title: "Biobizz Fish-Mix",
        unit: "ml",
        tiers: [{
          sku: "11403",
          t: "250ml",
          size: .25,
          price: 4.49
        }, {
          sku: "394",
          t: "500ml",
          size: .5,
          price: 6.29
        }, {
          sku: "395",
          t: "1L",
          size: 1,
          price: 10.5
        }, {
          sku: "396",
          t: "5L",
          size: 5,
          price: 31.5
        }, {
          sku: "7027",
          t: "10L",
          size: 10,
          price: 58
        }, {
          sku: "7026",
          t: "20L",
          size: 20,
          price: 107
        }]
      },
      bb_bloom: {
        handle: "biobizz-bio-bloom",
        title: "Biobizz Bio-Bloom",
        unit: "ml",
        tiers: [{
          sku: "6773",
          t: "250ml",
          size: .25,
          price: 4.5
        }, {
          sku: "470",
          t: "500ml",
          size: .5,
          price: 5.39
        }, {
          sku: "471",
          t: "1L",
          size: 1,
          price: 8.99
        }, {
          sku: "472",
          t: "5L",
          size: 5,
          price: 35.99
        }, {
          sku: "6273",
          t: "10L",
          size: 10,
          price: 62.99
        }, {
          sku: "7648",
          t: "20L",
          size: 20,
          price: 112.49
        }]
      },
      bb_topmax: {
        handle: "biobizz-top-max",
        title: "Biobizz Top-Max",
        unit: "ml",
        tiers: [{
          sku: "12713",
          t: "250ml",
          size: .25,
          price: 8.09
        }, {
          sku: "626",
          t: "500ml",
          size: .5,
          price: 13.49
        }, {
          sku: "627",
          t: "1L",
          size: 1,
          price: 20.69
        }, {
          sku: "628",
          t: "5L",
          size: 5,
          price: 89.99
        }, {
          sku: "6276",
          t: "10L",
          size: 10,
          price: 170.9
        }]
      },
      bb_heaven: {
        handle: "biobizz-bio-heaven",
        title: "Biobizz Bio-Heaven",
        unit: "ml",
        tiers: [{
          sku: "74",
          t: "250ml",
          size: .25,
          price: 19
        }, {
          sku: "75",
          t: "500ml",
          size: .5,
          price: 36
        }, {
          sku: "76",
          t: "1L",
          size: 1,
          price: 50
        }, {
          sku: "77",
          t: "5L",
          size: 5,
          price: 202
        }, {
          sku: "7488",
          t: "10L",
          size: 10,
          price: 360
        }, {
          sku: "13195",
          t: "20L",
          size: 20,
          price: 699
        }]
      },
      bb_acti: {
        handle: "biobizz-acti-vera",
        title: "Biobizz Acti-Vera",
        unit: "ml",
        tiers: [{
          sku: "8550",
          t: "250ml",
          size: .25,
          price: 6.29
        }, {
          sku: "1141",
          t: "500ml",
          size: .5,
          price: 11.69
        }, {
          sku: "1142",
          t: "1L",
          size: 1,
          price: 17.99
        }, {
          sku: "6272",
          t: "5L",
          size: 5,
          price: 89.99
        }, {
          sku: "13194",
          t: "10L",
          size: 10,
          price: 155
        }]
      },
      bb_alg: {
        handle: "biobizz-alg-a-mic",
        title: "Biobizz Alg-A-Mic",
        unit: "ml",
        tiers: [{
          sku: "672",
          t: "500ml",
          size: .5,
          price: 8.99
        }, {
          sku: "673",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "671",
          t: "5L",
          size: 5,
          price: 62.99
        }, {
          sku: "12434",
          t: "10L",
          size: 10,
          price: 107.99
        }, {
          sku: "12435",
          t: "20L",
          size: 20,
          price: 197
        }]
      },
      bb_root: {
        handle: "biobizz-root-juice",
        title: "Biobizz Root-Juice",
        unit: "ml",
        tiers: [{
          sku: "7108",
          t: "250ml",
          size: .25,
          price: 11.69
        }, {
          sku: "3693",
          t: "500ml",
          size: .5,
          price: 22.49
        }, {
          sku: "3694",
          t: "1L",
          size: 1,
          price: 35
        }, {
          sku: "3695",
          t: "5L",
          size: 5,
          price: 179
        }, {
          sku: "12741",
          t: "10L",
          size: 10,
          price: 295
        }]
      },
      bb_calmag: {
        handle: "biobizz-cal-mag",
        title: "Biobizz Cal-Mag",
        unit: "ml",
        tiers: [{
          sku: "7487",
          t: "250ml",
          size: .25,
          price: 4.49
        }, {
          sku: "408",
          t: "500ml",
          size: .5,
          price: 8.99
        }, {
          sku: "409",
          t: "1L",
          size: 1,
          price: 13.49
        }, {
          sku: "6275",
          t: "5L",
          size: 5,
          price: 53.99
        }, {
          sku: "13197",
          t: "10L",
          size: 10,
          price: 99
        }]
      },
      gg_msa: {
        handle: "grow-genius-mono-silicic-acid",
        title: "Grow Genius Mono Silicic Acid",
        unit: "ml",
        tiers: [{
          sku: "735",
          t: "10ml",
          size: .01,
          price: 20.95
        }, {
          sku: "13196",
          t: "15ml",
          size: .015,
          price: 22
        }, {
          sku: "736",
          t: "100ml",
          size: .1,
          price: 38.95
        }, {
          sku: "737",
          t: "250ml",
          size: .25,
          price: 75.95
        }, {
          sku: "738",
          t: "500ml",
          size: .5,
          price: 134.95
        }, {
          sku: "7489",
          t: "1L",
          size: 1,
          price: 196.95
        }]
      },
      /* Plant Magic, added 27 Sep 2026 from the four Essential PDFs (Old Timer,
         Coco, Hydro, Soil — plantmagic.co.uk, © 2023 Global Air Supplies Ltd).
         Coco and Hydro map onto the AB family (plant-magic-coco-ab /
         plant-magic-hydro-ab), matching the PDFs' own "Coco A&B" / "Hydro A&B"
         naming. Soil is Soil Grow + Soil Bloom, the PDF's own product names —
         Soil Bloom was archived and was republished 27 Sep 2026 with Steve's
         sign-off so the engine's Soil line matches the chart exactly, rather
         than reinterpreting onto the newer (draft, unpublished) Soil AB
         product. Boost was likewise archived and republished 27 Sep 2026 with
         Steve's sign-off, since it appears on three of the four charts every
         bloom week. Evolution 2.0 is deliberately NOT modelled: the PDFs print
         it as "SPRAY 1-2 TIMES PER WEEK, AS NEEDED" with no tank rate, so there
         is nothing to cost — see the chartNote on each PLANT MAGIC line. */
      pm_coco_ab: {
        handle: "plant-magic-coco-ab",
        title: "Plant Magic Coco A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "8835",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "8836",
          t: "5L",
          size: 5,
          price: 36
        }, {
          sku: "8837",
          t: "10L",
          size: 10,
          price: 63
        }]
      },
      pm_hydro_ab: {
        handle: "plant-magic-hydro-ab",
        title: "Plant Magic Hydro A+B",
        unit: "ml",
        ab: true,
        tiers: [{
          sku: "8838",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "8839",
          t: "5L",
          size: 5,
          price: 36
        }, {
          sku: "8840",
          t: "10L",
          size: 10,
          price: 65
        }]
      },
      pm_soil_grow: {
        handle: "plant-magic-soil-grow",
        title: "Plant Magic Soil Grow",
        unit: "ml",
        tiers: [{
          sku: "702",
          t: "1L",
          size: 1,
          price: 15
        }, {
          sku: "703",
          t: "5L",
          size: 5,
          price: 35.79
        }, {
          sku: "704",
          t: "10L",
          size: 10,
          price: 62.52
        }]
      },
      pm_soil_bloom: {
        handle: "plant-magic-soil-bloom",
        title: "Plant Magic Soil Bloom",
        unit: "ml",
        tiers: [{
          sku: "477",
          t: "1L",
          size: 1,
          price: 9.95
        }, {
          sku: "478",
          t: "5L",
          size: 5,
          price: 35.95
        }, {
          sku: "479",
          t: "10L",
          size: 10,
          price: 68.95
        }]
      },
      pm_root: {
        handle: "plant-magic-root-stimulant",
        title: "Plant Magic Root Stimulant",
        unit: "ml",
        tiers: [{
          sku: "1143",
          t: "1L",
          size: 1,
          price: 11.95
        }, {
          sku: "1144",
          t: "5L",
          size: 5,
          price: 59
        }, {
          sku: "8841",
          t: "10L",
          size: 10,
          price: 109
        }]
      },
      pm_magcal: {
        handle: "plant-magic-magne-cal",
        title: "Plant Magic MAGNE Cal+",
        unit: "ml",
        tiers: [{
          sku: "9376",
          t: "500ml",
          size: .5,
          price: 8.9
        }, {
          sku: "252",
          t: "1L",
          size: 1,
          price: 17
        }, {
          sku: "253",
          t: "5L",
          size: 5,
          price: 63
        }, {
          sku: "9314",
          t: "10L",
          size: 10,
          price: 109
        }]
      },
      pm_boost: {
        handle: "plant-magic-ignition-flower-boost",
        title: "Plant Magic Boost",
        unit: "ml",
        tiers: [{
          sku: "174",
          t: "1L",
          size: 1,
          price: 28.95
        }, {
          sku: "175",
          t: "5L",
          size: 5,
          price: 114
        }, {
          sku: "9981",
          t: "10L",
          size: 10,
          price: 159.95
        }]
      },
      pm_pk1314: {
        handle: "plant-magic-bloom-boost-pk",
        title: "Plant Magic PK 13/14",
        unit: "ml",
        tiers: [{
          sku: "245",
          t: "1L",
          size: 1,
          price: 8.95
        }, {
          sku: "246",
          t: "5L",
          size: 5,
          price: 45.95
        }, {
          sku: "9990",
          t: "10L",
          size: 10,
          price: 74.95
        }]
      },
      pm_ot_grow: {
        handle: "plant-magic-oldtime-organic-grow",
        title: "Plant Magic Old Timer Organic Grow",
        unit: "ml",
        tiers: [{
          sku: "700",
          t: "1L",
          size: 1,
          price: 9.85
        }, {
          sku: "701",
          t: "5L",
          size: 5,
          price: 35.95
        }, {
          sku: "9987",
          t: "10L",
          size: 10,
          price: 65.95
        }]
      },
      pm_ot_bloom: {
        handle: "plant-magic-oldtime-organic-bloom",
        title: "Plant Magic Old Timer Organic Bloom",
        unit: "ml",
        tiers: [{
          sku: "909",
          t: "1L",
          size: 1,
          price: 12
        }, {
          sku: "910",
          t: "5L",
          size: 5,
          price: 41
        }, {
          sku: "9986",
          t: "10L",
          size: 10,
          price: 68
        }]
      },
      pm_ot_pk: {
        handle: "plant-magic-oldtime-organic-pk-4-8",
        title: "Plant Magic Old Timer PK 4/8",
        unit: "ml",
        tiers: [{
          sku: "683",
          t: "1L",
          size: 1,
          price: 19.95
        }, {
          sku: "684",
          t: "5L",
          size: 5,
          price: 88.95
        }, {
          sku: "9988",
          t: "10L",
          size: 10,
          price: 125.95
        }]
      }
    };
    var MEDIA_TYPES = {
      coco: {
        label: "Coco",
        sub: "Quick Fill bags or coco in fabric pots",
        daily: .2,
        ph: "5.8 – 6.2"
      },
      soil: {
        label: "Soil / compost",
        sub: "Potting mix in fabric pots",
        daily: .1,
        ph: "6.0 – 6.5"
      },
      rockwool: {
        label: "Hydro / inert",
        sub: "Rockwool, clay pebbles, DWC and RDWC",
        daily: .36,
        ph: "5.5 – 6.0"
      }
    };
    var STYLES = {
      light: {
        label: "Light",
        mult: .7,
        sub: "Bigger drybacks, less water overall"
      },
      standard: {
        label: "Standard",
        mult: 1,
        sub: "Chart-typical watering"
      },
      heavy: {
        label: "Heavy",
        mult: 1.4,
        sub: "Keeps the substrate wet"
      }
    };
    var FABRIC = [{
      k: "fp12",
      label: "12 L",
      litres: 12,
      sku: "687"
    }, {
      k: "fp16",
      label: "16 L",
      litres: 16,
      sku: "691"
    }, {
      k: "fp20",
      label: "20 L",
      litres: 20,
      sku: "692"
    }, {
      k: "fp25",
      label: "25 L",
      litres: 25,
      sku: "693"
    }, {
      k: "fp30",
      label: "30 L",
      litres: 30,
      sku: "694"
    }];
    var CANOPY = {
      qf1: .1,
      qf2: .16,
      qf3: .25,
      fp12: .25,
      fp16: .3,
      fp20: .36,
      fp25: .42,
      fp30: .49,
      hugo: .16,
      hugoi: .16
    };
    var SIZES = {
      coco: [{
        k: "qf1",
        label: "Quick Fill 1 gal",
        litres: 3.78
      }, {
        k: "qf2",
        label: "Quick Fill 2 gal",
        litres: 7.57
      }, {
        k: "qf3",
        label: "Quick Fill 3 gal",
        litres: 11.4
      }].concat(FABRIC.map(function(f) {
        return {
          k: f.k,
          label: f.label + " pot",
          litres: f.litres
        }
      })),
      soil: FABRIC.map(function(f) {
        return {
          k: f.k,
          label: f.label + " pot",
          litres: f.litres
        }
      }),
      rockwool: [{
        k: "hugo",
        label: '6" Grodan Hugo',
        litres: 3.2
      }, {
        k: "hugoi",
        label: '6" Grodan Improved',
        litres: 3.2
      }]
    };
    var CUSTOM_SIZE = "custom";

    function sizesFor(type) {
      return SIZES[type] || SIZES.coco
    }

    function sizeOf(type, key, litres) {
      var l = sizesFor(type);
      if (key === CUSTOM_SIZE) {
        var v = clampNum(litres, 11, LIMITS.potLitres);
        return {
          k: CUSTOM_SIZE,
          label: fmtL(v) + " L",
          litres: v,
          custom: true
        }
      }
      for (var i = 0; i < l.length; i++)
        if (l[i].k === key) return l[i];
      return l[0]
    }

    function fmtL(v) {
      return Math.round(v * 10) / 10 === Math.round(v) ? String(Math.round(v)) : String(Math.round(v * 10) / 10)
    }
    var CANOPY_CURVE = null;

    function canopyFor(size) {
      if (!size) return .25;
      if (CANOPY[size.k]) return CANOPY[size.k];
      if (!CANOPY_CURVE) {
        var pts = [];
        for (var t in SIZES)
          if (SIZES.hasOwnProperty(t)) {
            if (t === "rockwool") continue;
            SIZES[t].forEach(function(s) {
              if (CANOPY[s.k]) pts.push([s.litres, CANOPY[s.k]])
            })
          } pts.sort(function(a, b) {
          return a[0] - b[0]
        });
        CANOPY_CURVE = pts
      }
      var c = CANOPY_CURVE,
        L = size.litres;
      if (!c.length) return .25;
      if (L <= c[0][0]) return c[0][1];
      if (L >= c[c.length - 1][0]) return c[c.length - 1][1];
      for (var i = 1; i < c.length; i++) {
        if (L <= c[i][0]) {
          var span = c[i][0] - c[i - 1][0];
          if (span <= 0) return c[i][1];
          return c[i - 1][1] + (c[i][1] - c[i - 1][1]) * (L - c[i - 1][0]) / span
        }
      }
      return .25
    }
    var ATH_VEG = [{
      ec: 2.1,
      d: {
        ath_grow: 29,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 2.1,
      d: {
        ath_grow: 29,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 2.1,
      d: {
        ath_grow: 29,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 2.1,
      d: {
        ath_grow: 29,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }];
    var ATH_FLOWER = [{
      ec: 2.3,
      d: {
        ath_bloom: 32,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 2.3,
      d: {
        ath_bloom: 32,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 2.5,
      d: {
        ath_bloom: 32,
        ath_pk: 11,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 2.6,
      d: {
        ath_bloom: 32,
        ath_pk: 16,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 2.4,
      d: {
        ath_bloom: 26,
        ath_pk: 24,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 2.3,
      d: {
        ath_bloom: 24,
        ath_pk: 26,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 1.7,
      d: {
        ath_bloom: 13,
        ath_pk: 32,
        ath_camg: 10,
        ath_cleanse: 9
      }
    }, {
      ec: 1.5,
      d: {
        ath_bloom: 11,
        ath_pk: 26,
        ath_cleanse: 9
      }
    }, {
      ec: 1.5,
      d: {
        ath_bloom: 11,
        ath_pk: 26,
        ath_cleanse: 9
      }
    }];
    var ATH_FLOWER_FADE = [{
      ec: 1.7,
      d: {
        ath_fade: 32,
        ath_pk: 32,
        ath_cleanse: 9
      }
    }, {
      ec: 1.7,
      d: {
        ath_fade: 32,
        ath_pk: 32,
        ath_cleanse: 9
      }
    }];
    var EC_TABLE = [{
      ec: .5,
      core: .17,
      gb: .28
    }, {
      ec: 1,
      core: .36,
      gb: .61
    }, {
      ec: 1.5,
      core: .57,
      gb: .94
    }, {
      ec: 2,
      core: .77,
      gb: 1.29
    }, {
      ec: 2.5,
      core: .99,
      gb: 1.65
    }, {
      ec: 3,
      core: 1.22,
      gb: 2.03
    }, {
      ec: 3.5,
      core: 1.45,
      gb: 2.41
    }, {
      ec: 4,
      core: 1.69,
      gb: 2.81
    }];
    var PRO_EC = 3;

    function proDose(ec) {
      var f = EC_TABLE[0],
        l = EC_TABLE[EC_TABLE.length - 1];
      if (ec <= f.ec) return {
        core: f.core,
        gb: f.gb
      };
      if (ec >= l.ec) return {
        core: l.core,
        gb: l.gb
      };
      for (var i = 1; i < EC_TABLE.length; i++) {
        var a = EC_TABLE[i - 1],
          b = EC_TABLE[i];
        if (ec <= b.ec) {
          var t = (ec - a.ec) / (b.ec - a.ec);
          return {
            core: a.core + t * (b.core - a.core),
            gb: a.gb + t * (b.gb - a.gb)
          }
        }
      }
      return {
        core: l.core,
        gb: l.gb
      }
    }
    var CANNA = {
      coco: {
        veg1: {
          ec: 1.1,
          d: {
            can_coco: 25,
            can_rhizo: 20,
            can_zym: 25
          }
        },
        veg2: {
          ec: 1.3,
          d: {
            can_coco: 30,
            can_rhizo: 20,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen1: {
          ec: 1.6,
          d: {
            can_coco: 35,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen2: {
          ec: 1.8,
          d: {
            can_coco: 35,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20,
            can_pk: 15
          }
        },
        gen3: {
          ec: 1.2,
          d: {
            can_coco: 25,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen4: {
          ec: 0,
          d: {
            can_zym: 25
          }
        }
      },
      hydro: {
        veg1: {
          ec: 1.1,
          d: {
            can_hyd_vega: 20,
            can_rhizo: 20,
            can_zym: 25
          }
        },
        veg2: {
          ec: 1.3,
          d: {
            can_hyd_vega: 30,
            can_rhizo: 20,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen1: {
          ec: 1.6,
          d: {
            can_hyd_flores: 30,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen2: {
          ec: 1.8,
          d: {
            can_hyd_flores: 30,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20,
            can_pk: 15
          }
        },
        gen3: {
          ec: 1.2,
          d: {
            can_hyd_flores: 20,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen4: {
          ec: 0,
          d: {
            can_zym: 25
          }
        }
      },
      aqua: {
        veg1: {
          ec: 1.1,
          d: {
            can_aqua_vega: 25,
            can_rhizo: 20,
            can_zym: 25
          }
        },
        veg2: {
          ec: 1.3,
          d: {
            can_aqua_vega: 30,
            can_rhizo: 20,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen1: {
          ec: 1.6,
          d: {
            can_aqua_flor: 35,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen2: {
          ec: 1.8,
          d: {
            can_aqua_flor: 35,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20,
            can_pk: 15
          }
        },
        gen3: {
          ec: 1.2,
          d: {
            can_aqua_flor: 25,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen4: {
          ec: 0,
          d: {
            can_zym: 25
          }
        }
      },
      terra: {
        veg1: {
          ec: .9,
          d: {
            can_vega: 40,
            can_rhizo: 20,
            can_zym: 25
          }
        },
        veg2: {
          ec: 1.1,
          d: {
            can_vega: 45,
            can_rhizo: 20,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen1: {
          ec: 1.4,
          d: {
            can_flores: 60,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen2: {
          ec: 1.7,
          d: {
            can_flores: 60,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20,
            can_pk: 15
          }
        },
        gen3: {
          ec: 1.2,
          d: {
            can_flores: 50,
            can_rhizo: 5,
            can_zym: 25,
            can_boost: 20
          }
        },
        gen4: {
          ec: 0,
          d: {
            can_zym: 25
          }
        }
      }
    };

    function cannaPhase(isVeg, i, nVeg, nFlower) {
      if (isVeg) return i < Math.ceil(nVeg / 2) ? "veg1" : "veg2";
      var fromEnd = nFlower - 1 - i;
      if (fromEnd === 0) return "gen4";
      if (fromEnd <= 2) return "gen3";
      if (fromEnd === 3) return "gen2";
      return "gen1"
    }
    var SHOGUN_ADD = {
      si: 1,
      zenzym: 2.5,
      katana: .2,
      sumo: 2,
      dragon: 4
    };

    function shogunWeeks(vegKey, flowerKey, vegBase, flowerBase, vegEc, flowerEc, opt) {
      opt = opt || {};
      var A = SHOGUN_ADD;
      var veg = vegBase.map(function(v, i) {
        var d = {
          sho_si: A.si,
          sho_zenzym: A.zenzym,
          sho_katana: A.katana
        };
        d[vegKey] = v;
        return {
          ec: vegEc[i],
          d: d
        }
      });
      var nF = flowerBase.length;
      var flower = flowerBase.map(function(v, i) {
        var fin = i === nF - 1;
        var d = {
          sho_sumo: A.sumo
        };
        if (v) d[flowerKey] = v;
        if (!fin) d.sho_si = A.si;
        if (!fin || opt.zenzymToEnd) d.sho_zenzym = A.zenzym;
        if (i < 3) d.sho_katana = A.katana;
        if (i === 3) d.sho_pk = 1;
        else if (i >= 4 && i <= 6) d.sho_pk = .5;
        if (fin) d.sho_dragon = A.dragon;
        return {
          ec: flowerEc[i],
          d: d
        }
      });
      return {
        veg: veg,
        flower: flower,
        repeat: {
          flower: 2
        }
      }
    }
    var SHOGUN_COCO = shogunWeeks("sho_coco", "sho_coco", [2.5, 2.5, 3, 3], [3.5, 3.5, 3.5, 3, 2, 2, 2, 0], [1.75, 1.75, 2.1, 2.1], [2.3, 2.3, 2.3, 2.4, 1.75, 1.75, 1.75, 1.75]);
    var SHOGUN_TERRA = shogunWeeks("sho_grow", "sho_bloom", [2, 2, 2.5, 2.5], [3.5, 3.5, 3.5, 2.5, 2, 2, 2, 0], [1.6, 1.6, 1.9, 1.9], [2.1, 2.1, 2.1, 2.15, 2.2, 1.75, 1.75, 1.75]);
    var SHOGUN_HYDRO = shogunWeeks("sho_hyd_grow", "sho_hyd_bloom", [1.18, 1.18, 1.61, 1.61], [2.45, 2.45, 2.45, 1.65, 1.15, 1.15, 1.15, 0], [1.5, 1.5, 1.8, 1.8], [1.9, 1.9, 1.9, 2, 1.5, 1.5, 1.5, 1.5], {
      zenzymToEnd: true
    });

    function shogunDose(isVeg, i, nVeg, nFl, base, env) {
      var d = {},
        last = !isVeg && i === nFl - 1;
      var lo = env && env[0] || 1,
        hi = env && env[1] || 4;
      var mid = lo + (hi - lo) * .67,
        vegLo = lo + (hi - lo) * .17;
      if (isVeg) {
        d[base.veg] = vegLo + (mid - vegLo) * (nVeg > 1 ? i / (nVeg - 1) : 1)
      } else if (!last) {
        d[base.flower] = i < 2 ? mid + (hi - mid) * (i / 2) : i >= nFl - 2 ? mid : hi
      }
      var A = SHOGUN_ADD;
      d.sho_zenzym = A.zenzym;
      if (isVeg || i < 3) d.sho_katana = A.katana;
      if (!isVeg) d.sho_sumo = A.sumo;
      if (!isVeg && i >= 3 && i <= 6) d.sho_pk = i === 3 ? 1 : .5;
      return d
    }
    var LINES = {
      athena_blended: {
        label: "Athena Blended",
        brand: "Athena",
        kind: "athena",
        blurb: "Two-part liquid on Athena’s published weekly chart.",
        media: ["coco", "soil", "rockwool"],
        extras: [{
          k: "cleanse",
          key: "ath_cleanse",
          label: "Cleanse",
          on: true,
          chart: true,
          note: "Keeps drippers and root zone clear"
        }, {
          k: "fade",
          key: "ath_fade",
          label: "Fade",
          on: false,
          chart: false,
          note: "Nitrogen-free finish for the last two weeks"
        }]
      },
      athena_pro: {
        label: "Athena Pro Line",
        brand: "Athena",
        kind: "athena_pro",
        dosing: "stock",
        blurb: "Powder mixed into a stock concentrate, dosed to a target EC. Cheapest per litre at scale.",
        media: ["coco", "soil", "rockwool"],
        extras: [{
          k: "balance",
          key: "ath_pbal",
          label: "Pro Balance",
          on: true,
          chart: true,
          note: "Used as pH up. Athena publish no per-litre rate for it — you dose to pH — so the quantity here is an estimate at 0.15 g/L"
        }, {
          k: "cleanse",
          key: "ath_cleanse",
          label: "Cleanse",
          on: true,
          chart: true,
          note: "0.5 ml/L. Athena’s chart prints a 0.5–1.3 ml/L band; the low end is used here"
        }, {
          k: "fade",
          key: "ath_fade",
          label: "Fade",
          on: false,
          chart: false,
          note: "Replaces Core for the last two weeks at the same rate — Core out, Fade in. Athena say a resilient cultivar can run it for three"
        }]
      },
      canna_coco: {
        label: "CANNA Coco",
        brand: "CANNA",
        kind: "canna",
        chart: "coco",
        blurb: "One formulation for veg and flower, dosed up then tapered.",
        media: ["coco"],
        extras: [{
          k: "rhizo",
          key: "can_rhizo",
          label: "Rhizotonic",
          on: true,
          chart: true,
          note: "Root stimulator — heavy early, light later"
        }, {
          k: "zym",
          key: "can_zym",
          label: "CANNAZYM",
          on: true,
          chart: true,
          note: "Enzymes — double the rate on re-used substrate"
        }, {
          k: "boost",
          key: "can_boost",
          label: "Boost Accelerator",
          on: true,
          chart: true,
          note: "On the chart from veg II. The big-ticket line — untick to see the difference"
        }, {
          k: "pk",
          key: "can_pk",
          label: "PK 13/14",
          on: true,
          chart: true,
          note: "One week only, 3–4 weeks before harvest"
        }, {
          k: "calmag",
          key: "can_calmag",
          label: "CalMag Agent",
          on: false,
          chart: false,
          note: "Only if you are on RO or soft water"
        }, {
          k: "flush",
          key: "can_flush",
          label: "Flush",
          on: false,
          chart: false,
          note: "Final week clear-out"
        }]
      },
      canna_terra: {
        label: "CANNA Terra",
        brand: "CANNA",
        kind: "canna",
        chart: "terra",
        blurb: "Terra Vega through veg, Terra Flores through flower. Two bottles.",
        media: ["soil"],
        extras: [{
          k: "rhizo",
          key: "can_rhizo",
          label: "Rhizotonic",
          on: true,
          chart: true,
          note: "Root stimulator — heavy early, light later"
        }, {
          k: "zym",
          key: "can_zym",
          label: "CANNAZYM",
          on: true,
          chart: true,
          note: "Enzymes — double the rate on re-used substrate"
        }, {
          k: "boost",
          key: "can_boost",
          label: "Boost Accelerator",
          on: true,
          chart: true,
          note: "On the chart from veg II. The big-ticket line — untick to see the difference"
        }, {
          k: "pk",
          key: "can_pk",
          label: "PK 13/14",
          on: true,
          chart: true,
          note: "One week only, 3–4 weeks before harvest"
        }, {
          k: "calmag",
          key: "can_calmag",
          label: "CalMag Agent",
          on: false,
          chart: false,
          note: "Only if you are on RO or soft water"
        }, {
          k: "flush",
          key: "can_flush",
          label: "Flush",
          on: false,
          chart: false,
          note: "Final week clear-out"
        }]
      }
    };
    var SHOGUN_EXTRAS = [{
      k: "katana",
      key: "sho_katana",
      label: "Katana Roots",
      on: true,
      chart: true,
      note: "0.2 ml/L through veg and the first three weeks of flower"
    }, {
      k: "zenzym",
      key: "sho_zenzym",
      label: "Zenzym",
      on: true,
      chart: true,
      note: "2.5 ml/L, veg through flower week 7"
    }, {
      k: "sumo",
      key: "sho_sumo",
      label: "Sumo Active Boost",
      on: true,
      chart: true,
      note: "2 ml/L every week of flower. The big-ticket line — untick to see the difference"
    }, {
      k: "pk",
      key: "sho_pk",
      label: "PK Warrior 9/18",
      on: true,
      chart: true,
      note: "Mid-flower weeks 4–7, 0.5 ml/L (1.0 in the first)"
    }, {
      k: "si",
      key: "sho_si",
      label: "Silicon",
      on: false,
      chart: true,
      note: "1 ml/L, veg through flower week 7. Premix it in 5 L of water and pH to about 6.5 before it goes in the tank"
    }, {
      k: "calmag",
      key: "sho_calmag",
      label: "Calmag",
      on: false,
      chart: false,
      note: "0.5 ml/L on moderately hard water, 1 ml/L on RO or soft — double it if you filter. Always add it with Terra Light Mix"
    }, {
      k: "dragon",
      key: "sho_dragon",
      label: "Dragon Force",
      on: true,
      chart: true,
      note: "4 ml/L in the last feed week, once the base comes out"
    }];
    LINES.shogun_coco = {
      label: "SHOGUN Samurai Coco",
      brand: "SHOGUN",
      kind: "shogun",
      base: {
        veg: "sho_coco",
        flower: "sho_coco"
      },
      weeks: SHOGUN_COCO,
      blurb: "One A&B feed for the whole run, on SHOGUN’s printed LED chart.",
      media: ["coco"],
      extras: SHOGUN_EXTRAS
    };
    LINES.shogun_terra = {
      label: "SHOGUN Samurai Terra",
      brand: "SHOGUN",
      kind: "shogun",
      base: {
        veg: "sho_grow",
        flower: "sho_bloom"
      },
      weeks: SHOGUN_TERRA,
      blurb: "Terra Grow through veg, Terra Bloom through flower. Never mixed.",
      media: ["soil"],
      extras: SHOGUN_EXTRAS
    };
    LINES.shogun_hydro = {
      label: "SHOGUN Samurai Hydro",
      brand: "SHOGUN",
      kind: "shogun",
      base: {
        veg: "sho_hyd_grow",
        flower: "sho_hyd_bloom"
      },
      waterType: true,
      envelope: [1, 3],
      weeks: SHOGUN_HYDRO,
      fromCalculator: true,
      blurb: "Hydro Grow through veg, Hydro Bloom through flower. Never mixed.",
      media: ["coco", "rockwool"],
      extras: SHOGUN_EXTRAS
    };
    LINES.canna_hydro = {
      label: "CANNA Hydro",
      brand: "CANNA",
      kind: "canna",
      chart: "hydro",
      waterType: true,
      blurb: "Run-to-waste line for inert media. Hydro Vega then Hydro Flores.",
      media: ["coco", "rockwool"],
      extras: LINES.canna_coco.extras
    };
    LINES.canna_aqua = {
      label: "CANNA Aqua",
      brand: "CANNA",
      kind: "canna",
      chart: "aqua",
      blurb: "Recirculating line, A+B. Aqua Vega then Aqua Flores.",
      media: ["coco", "rockwool"],
      extras: LINES.canna_coco.extras
    };
    var G_GAL = 1 / GAL;

    function vb(g) {
      return g * G_GAL
    }
    var VBX = {
      repeat: {
        veg: 1,
        flower: 5
      },
      veg: [{
        ec: 2.25,
        d: {
          vbx_base: vb(8)
        }
      }, {
        ec: 2.25,
        d: {
          vbx_base: vb(8)
        }
      }],
      flower: [{
        ec: 2.25,
        d: {
          vbx_base: vb(8)
        }
      }, {
        ec: 2.25,
        d: {
          vbx_base: vb(8)
        }
      }, {
        ec: 2.25,
        d: {
          vbx_base: vb(8)
        }
      }, {
        ec: 2.25,
        d: {
          vbx_base: vb(7),
          vbx_sh: vb(1.5)
        }
      }, {
        ec: 2.25,
        d: {
          vbx_base: vb(7),
          vbx_sh: vb(1.5)
        }
      }, {
        ec: 2.25,
        d: {
          vbx_base: vb(7),
          vbx_sh: vb(1.5)
        }
      }, {
        ec: 1.35,
        d: {
          vbx_base: vb(3.5),
          vbx_sh: vb(2)
        }
      }, {
        ec: 1.05,
        d: {
          vbx_base: vb(1.5),
          vbx_sh: vb(2)
        }
      }]
    };
    LINES.vbx = {
      label: "VBX Craft (all-in-one)",
      brand: "Veg+Bloom",
      kind: "weekly",
      weeks: VBX,
      ph: "5.8 – 6.3 in coco, 5.5 – 6.0 in rockwool",
      ro: true,
      blurb: "One powder for the whole run, with SHINE through late flower.",
      media: ["coco", "rockwool"],
      extras: [{
        k: "shine",
        key: "vbx_shine",
        label: "SHINE Bloom Additive",
        on: true,
        chart: true,
        note: "From flower week 4. Comes out 3 days before harvest"
      }, {
        k: "clean",
        key: "vbx_clean",
        label: "CLEAN (dripper friendly)",
        on: false,
        chart: false,
        note: "Swaps both VBX and SHINE for the versions formulated not to clog emitters"
      }]
    };

    function vbShine(i) {
      if (i < 3) return 0;
      return i < 6 ? 1.5 : 2
    }

    function vbFlower(baseKey, base) {
      return base.map(function(g, i) {
        var d = {};
        d[baseKey] = vb(g);
        var sh = vbShine(i);
        if (sh) d.vbx_shine = vb(sh);
        return {
          ec: i < 3 ? 2.1 : i < 6 ? 2.25 : i === 6 ? 1.5 : 1.05,
          d: d
        }
      })
    }
    var VEGBLOOM = {
      repeat: {
        veg: 1,
        flower: 5
      },
      veg: [{
        ec: 2.1,
        d: {
          vb_base: vb(7)
        }
      }, {
        ec: 2.1,
        d: {
          vb_base: vb(7)
        }
      }],
      flower: vbFlower("vb_base", [7, 7, 7, 6, 6, 6, 3, 1.5])
    };
    var VEGBLOOM_DIRTY = {
      repeat: {
        veg: 2,
        flower: 5
      },
      veg: [{
        ec: 0,
        d: {}
      }, {
        ec: 0,
        d: {}
      }, {
        ec: 2.1,
        d: {
          vb_dirt: vb(7)
        }
      }],
      flower: vbFlower("vb_dirt", [7, 7, 7, 6, 6, 6, 3.5, 1.5])
    };
    var VB_SHINE_X = {
      k: "shine",
      key: "vbx_shine",
      label: "SHINE Bloom Additive",
      on: true,
      chart: true,
      note: "From flower week 4. Comes out 3 days before harvest"
    };
    LINES.vegbloom = {
      label: "Veg+Bloom",
      brand: "Veg+Bloom",
      kind: "weekly",
      weeks: VEGBLOOM,
      perLitre: true,
      ph: "5.8 – 6.3 in coco, 5.5 – 6.0 in rockwool",
      ro: true,
      waterType: true,
      blurb: "The 2026 chart: one base powder the whole way, with SHINE through late flower. Your water picks RO/Soft or Tap/Hard.",
      media: ["coco", "rockwool"],
      extras: [VB_SHINE_X]
    };
    LINES.vegbloom_dirty = {
      label: "Veg+Bloom Dirty (soil)",
      brand: "Veg+Bloom",
      kind: "weekly",
      weeks: VEGBLOOM_DIRTY,
      perLitre: true,
      ph: "6.0 – 6.5",
      ro: true,
      blurb: "For amended soil. Nothing for the first 20 days after transplant, because the soil is already feeding, then the same schedule as the main chart.",
      media: ["soil"],
      extras: [VB_SHINE_X]
    };
    LINES.vegbloom_dirty.chartNote = "Veg weeks 1 and 2 carry no feed. Hydroponic Research print those as zero because amended soil provides up to 20 days of nutrition after transplant.";
    var VBX_KEYS = {
      vbx_base: {
        craft: "vbx_craft",
        clean: "vbx_clean"
      },
      vbx_sh: {
        craft: "vbx_shine",
        clean: "vbx_shine_c"
      }
    };

    function mapWeeks(tbl, n, repeatIdx) {
      var L = tbl.length,
        out = [],
        i;
      if (!L) return [];
      if (repeatIdx == null || repeatIdx >= L - 1) {
        for (i = 0; i < n; i++) out.push(tbl[Math.min(i, L - 1)]);
        return out
      }
      var head = tbl.slice(0, repeatIdx + 1),
        tail = tbl.slice(repeatIdx + 1);
      if (n >= L) {
        out = head.slice();
        for (i = 0; i < n - L; i++) out.push(tbl[repeatIdx]);
        return out.concat(tail)
      }
      var keepTail = Math.min(tail.length, n - 1);
      return head.slice(0, n - keepTail).concat(tail.slice(tail.length - keepTail))
    }
    var FF_STOCK_G_PER_L = LB * 1e3 / GAL;

    function fg(g) {
      return g / GAL
    }

    function floraflexWeeks(vegBase, bloomBase, bloomLate, bulky) {
      var RD = fg(1),
        RD_FLUSH = fg(5),
        TILT = fg(4);
      var veg = [0, 1, 2, 3].map(function() {
        return {
          ec: 3,
          d: {
            ff_veg: fg(vegBase),
            ff_root: RD
          }
        }
      });
      var bloom = [];
      for (var i = 0; i < 5; i++) {
        bloom.push({
          ec: 3,
          d: {
            ff_bloom: fg(bloomBase),
            ff_bulky: fg(bulky),
            ff_root: RD
          }
        })
      }
      bloom.push({
        ec: 2,
        d: {
          ff_bloom: fg(bloomLate),
          ff_tilt: TILT,
          ff_root: RD
        }
      });
      bloom.push({
        ec: .8,
        d: {
          ff_tilt: TILT,
          ff_root: RD
        }
      });
      bloom.push({
        ec: 0,
        d: {
          ff_root: RD_FLUSH
        }
      });
      return {
        veg: veg,
        bloom: bloom,
        flower: bloom,
        repeat: {
          flower: 5
        }
      }
    }
    var FF_NO_CALMAG = floraflexWeeks(5, 4, 2, 2);
    var FF_WITH_CALMAG = floraflexWeeks(4.5, 3.5, 2, 1.75);

    function floraflexLine(label, blurb, dosing) {
      return {
        label: label,
        brand: "FloraFlex",
        kind: "weekly",
        perLitre: true,
        weeks: FF_NO_CALMAG,
        weeksAlt: FF_WITH_CALMAG,
        altKey: "ff_calmag",
        stockGPerL: FF_STOCK_G_PER_L,
        dosing: dosing,
        ph: "5.8 – 6.2",
        blurb: blurb,
        media: ["coco", "soil", "rockwool"],
        extras: [{
          k: "bulky",
          key: "ff_bulky",
          label: "Bulky B",
          on: true,
          chart: true,
          note: "Through the first five weeks of bloom"
        }, {
          k: "tilt",
          key: "ff_tilt",
          label: "Full Tilt",
          on: true,
          chart: true,
          note: "The last two feed weeks, once B1 and B2 come out"
        }, {
          k: "root",
          key: "ff_root",
          label: "Root Drip",
          on: true,
          chart: true,
          note: "0.26 ml/L every week, five times that in the flush week. Keeps drippers and root zone clean"
        }, {
          k: "folveg",
          key: "ff_folveg",
          label: "Veg Foliar",
          on: true,
          chart: true,
          note: "4 g per US gallon of spray, once a week through veg. A spray, so the amount follows leaf area not tank size — the working is shown above the chart"
        }, {
          k: "folbloom",
          key: "ff_folbloom",
          label: "Bloom Foliar",
          on: true,
          chart: true,
          note: "4 g per US gallon of spray, every 5–7 days for the first three weeks of bloom only. Once the flowers form you stop — water sitting in a bud invites mould"
        }, {
          k: "calmag",
          key: "ff_calmag",
          label: "I run a separate Cal/Mag",
          on: false,
          chart: false,
          note: "FloraFlex print a second schedule for growers adding Cal/Mag — same products, about 10% less of them. Ticking this switches to it. The Cal/Mag itself is not in the basket, as FloraFlex do not sell one here"
        }]
      }
    }
    var SPRAY_L_PER_M2 = .5;
    var BLOOM_FOLIAR_WEEKS = 3;
    var FOLIAR_G_PER_GAL = 4;

    function foliarNeed(canopyM2, sprays) {
      var litres = canopyM2 * SPRAY_L_PER_M2 * sprays;
      return {
        litres: litres,
        grams: litres * (FOLIAR_G_PER_GAL / GAL)
      }
    }
    LINES.floraflex_stock = floraflexLine("FloraFlex — stock tank", "Mix each powder at 1 lb per US gallon, then dose millilitres of that stock. The chart is in ml.", "stock");
    LINES.floraflex_dry = floraflexLine("FloraFlex — weighed dry", "Weigh the powder straight into each tank. The chart is in grams per litre.", "dry");
    var MONKEY = {
      veg: [{
        ec: 1.2,
        d: {
          mky_grow: 15,
          mky_root: 2
        }
      }, {
        ec: 1.3,
        d: {
          mky_grow: 15,
          mky_root: 2
        }
      }, {
        ec: 1.4,
        d: {
          mky_grow: 15,
          mky_root: 3
        }
      }, {
        ec: 1.5,
        d: {
          mky_grow: 15,
          mky_root: 3
        }
      }],
      flower: [{
        ec: 1.6,
        d: {
          mky_bloom: 20,
          mky_root: 3
        }
      }, {
        ec: 1.7,
        d: {
          mky_bloom: 20,
          mky_root: 3,
          mky_boost: 10
        }
      }, {
        ec: 1.8,
        d: {
          mky_bloom: 25,
          mky_root: 3,
          mky_boost: 20,
          mky_resin: 10
        }
      }, {
        ec: 1.9,
        d: {
          mky_bloom: 25,
          mky_root: 3,
          mky_boost: 20,
          mky_resin: 10,
          mky_pk: 2.5
        }
      }, {
        ec: 2,
        d: {
          mky_bloom: 27.5,
          mky_root: 3,
          mky_boost: 20,
          mky_resin: 10,
          mky_pk: 2.5
        }
      }, {
        ec: 2.1,
        d: {
          mky_bloom: 27.5,
          mky_boost: 20,
          mky_resin: 10,
          mky_pk: 5
        }
      }, {
        ec: 2.2,
        d: {
          mky_bloom: 30,
          mky_boost: 20,
          mky_resin: 10
        }
      }, {
        ec: 1.9,
        d: {
          mky_bloom: 30,
          mky_boost: 20,
          mky_resin: 10
        }
      }]
    };

    function bacWeeks(growKey, bloomKey, opts) {
      opts = opts || {};
      var veg = [{
        ec: 1.6,
        d: {
          bac_root: 1,
          bac_final: 6,
          bac_silica: 1
        }
      }, {
        ec: 1.6,
        d: {
          bac_root: 2,
          bac_silica: 1
        }
      }];
      var base = opts.base || [35, 35, 40, 40, 45, 35, 35, 35, 0];
      var vegBase = opts.vegBase || 30;
      veg.forEach(function(w) {
        if (vegBase) w.d[growKey] = vegBase
      });
      var ecs = [1.8, 1.8, 2.05, 2.05, 2.2, 1.6, 1.6, 1.6, 0];
      var sil = [1, 1, 2, 2, 2, 2, 3, 3, 3];
      var flower = base.map(function(v, i) {
        var d = {
          bac_bstim: 2,
          bac_silica: sil[i]
        };
        if (v) d[bloomKey] = v;
        if (i < 2) d.bac_root = 2;
        if (i === 0 || i === 4) d.bac_final = 6;
        if (opts.f1 && i >= 5 && i <= 7) d.bac_f1 = 25;
        if (opts.pk && opts.pk[i]) d.bac_pk = opts.pk[i];
        return {
          ec: ecs[i],
          d: d
        }
      });
      return {
        veg: veg,
        flower: flower
      }
    }
    var BAC_COCO = bacWeeks("bac_coco_g", "bac_coco_b", {
      f1: true
    });
    var BAC_HYDRO = bacWeeks("bac_hyd_g", "bac_hyd_b", {
      f1: true
    });
    var BAC_SOIL = bacWeeks("bac_soil_g", "bac_soil_b", {
      f1: true
    });
    var BAC_ORG = bacWeeks("bac_org_g", "bac_org_b", {
      vegBase: 15,
      base: [25, 25, 25, 25, 25, 25, 25, 25, 0],
      pk: [0, 15, 20, 25, 35, 35, 25, 0, 0]
    });

    function monkeyExtras(finisher) {
      return [{
        k: "root",
        key: "mky_root",
        label: "Root Shoot",
        on: true,
        chart: true,
        note: "2–3 ml/L through veg and into early flower"
      }, {
        k: "boost",
        key: "mky_boost",
        label: "Boost",
        on: true,
        chart: true,
        note: "From flower week 2. The big-ticket line"
      }, {
        k: "pk",
        key: "mky_pk",
        label: "PK 14/15",
        on: finisher === "pk",
        chart: true,
        note: finisher === "pk" ? "The finisher on this chart. Flower weeks 4 to 6" : "The other chart’s finisher. Ticking it here runs both, which Monkey do not print"
      }, {
        k: "resin",
        key: "mky_resin",
        label: "Resin",
        on: finisher === "resin",
        chart: true,
        note: finisher === "resin" ? "The finisher on this chart. 1 ml/L from flower week 3 to the end" : "The other chart’s finisher. Ticking it here runs both, which Monkey do not print"
      }, {
        k: "magcal",
        key: "mky_magcal",
        label: "Mag Cal",
        on: false,
        chart: false,
        note: "The chart says to use this on coco — rate not printed, modelled at 1 ml/L"
      }, {
        k: "zyme",
        key: "mky_zyme",
        label: "Ultra Zyme",
        on: false,
        chart: false,
        note: "Enzymes for re-used substrate"
      }]
    }
    var BAC_EXTRAS = [{
      k: "root",
      key: "bac_root",
      label: "Root Stimulator",
      on: true,
      chart: true,
      note: "Veg and the first two weeks of flower"
    }, {
      k: "bstim",
      key: "bac_bstim",
      label: "Bloom Stimulator",
      on: true,
      chart: true,
      note: "2 ml/L every week of flower"
    }, {
      k: "final",
      key: "bac_final",
      label: "Final Solution",
      on: true,
      chart: true,
      note: "Once a week, three weeks of the run"
    }, {
      k: "f1",
      key: "bac_f1",
      label: "F1 Extreme Booster",
      on: true,
      chart: true,
      note: "Flower weeks 6–8, adjust to EC 2.2"
    }, {
      k: "silica",
      key: "bac_silica",
      label: "Silica Power",
      on: false,
      chart: true,
      note: "Dissolve first, before anything else goes in the tank"
    }, {
      k: "calmag",
      key: "bac_calmag",
      label: "CalMag 2.0",
      on: false,
      chart: false,
      note: "1 ml/L with every watering, BAC’s own rate. Not stage-specific, so it runs flat for the whole cycle. Only if you are on RO or soft water"
    }];

    function monkeyLine(label, blurb, finisher) {
      return {
        label: label,
        brand: "MONKEY",
        kind: "weekly",
        weeks: MONKEY,
        ph: "5.5 – 6.5",
        blurb: blurb,
        media: ["coco", "soil", "rockwool"],
        extras: monkeyExtras(finisher)
      }
    }
    LINES.monkey_pk = monkeyLine("Monkey Nutrients — PK 14/15", "One chart for coco, soil and hydro. Grow then Bloom, finished on PK 14/15.", "pk");
    LINES.monkey_resin = monkeyLine("Monkey Nutrients — Resin", "The same chart finished on Resin instead of PK 14/15. Monkey print the two as alternatives.", "resin");
    LINES.bac_coco = {
      label: "BAC Coco",
      brand: "BAC",
      kind: "weekly",
      weeks: BAC_COCO,
      ph: "6.0",
      blurb: "Coco Grow A+B then Coco Bloom A+B.",
      media: ["coco"],
      extras: BAC_EXTRAS
    };
    LINES.bac_hydro = {
      label: "BAC Hydro",
      brand: "BAC",
      kind: "weekly",
      weeks: BAC_HYDRO,
      ph: "5.3 – 6.0",
      blurb: "Hydro Grow A+B then Hydro Bloom A+B, for inert media.",
      media: ["coco", "rockwool"],
      extras: BAC_EXTRAS
    };
    LINES.bac_soil = {
      label: "BAC Soil",
      brand: "BAC",
      kind: "weekly",
      weeks: BAC_SOIL,
      ph: "6.0",
      blurb: "One-component Soil Grow then Soil Bloom.",
      media: ["soil"],
      extras: BAC_EXTRAS
    };
    LINES.bac_organic = {
      label: "BAC Organic",
      brand: "BAC",
      kind: "weekly",
      weeks: BAC_ORG,
      ph: "6.0",
      blurb: "Organic Grow then Organic Bloom, with the Organic PK Booster.",
      media: ["soil"],
      extras: BAC_EXTRAS.filter(function(e) {
        return e.k !== "f1"
      }).concat([{
        k: "pk",
        key: "bac_pk",
        label: "Organic PK Booster",
        on: true,
        chart: true,
        note: "Ramps through mid-flower on the organic chart"
      }])
    };

    function dutchproWeeks(growKey, bloomKey, vegBase, flowerBase, vegEc, flowerEc) {
      var veg = [0, 1].map(function() {
        var d = {
          dp_silica: .4,
          dp_multi: 2,
          dp_root: 1
        };
        d[growKey] = vegBase;
        return {
          ec: vegEc,
          d: d
        }
      });
      var EXPLODE = [0, 0, .5, .5, 1, 1, 1.5, 1.5];
      var flower = EXPLODE.map(function(ex, i) {
        var d = {
          dp_silica: .4
        };
        d[bloomKey] = flowerBase;
        if (i % 2 === 0) d.dp_multi = 1;
        if (i < 2) d.dp_root = 1;
        if (ex) d.dp_explode = ex;
        return {
          ec: flowerEc,
          d: d
        }
      });
      return {
        veg: veg,
        flower: flower,
        repeat: {
          veg: 1,
          flower: 4
        }
      }
    }
    var DP_HC = dutchproWeeks("dp_hc_grow", "dp_hc_bloom", 3, 3, 1.9, 2.1);
    var DP_SO = dutchproWeeks("dp_so_grow", "dp_so_bloom", 3.75, 3.75, 1.75, 2.05);
    var DP_HC_S = dutchproWeeks("dp_hc_grow", "dp_hc_bloom", 2.75, 2.5, 2, 2.1);
    var DP_SO_S = dutchproWeeks("dp_so_grow", "dp_so_bloom", 2.25, 2.5, 1.75, 2.1);
    var DP_EXTRAS = [{
      k: "dpsilica",
      key: "dp_silica",
      label: "Silica (Von Liebig)",
      on: false,
      chart: true,
      note: "0.4 ml/L every week. Dutch Pro print it on the sheet as standard, but it is a silicate — leave it off if you already run one, or pick a different silicon in the step above"
    }, {
      k: "dpamino",
      key: "dp_amino",
      label: "Amino Strength",
      on: false,
      chart: true,
      note: "0.4 ml/L once a week. Printed under optional supplements — and Dutch Pro say to use it within 24 hours of mixing"
    }, {
      k: "dpcalmag",
      key: "dp_calmag",
      label: "Cal Mag",
      on: false,
      chart: true,
      note: "0.1–1 ml/L. On the sheet for CO2 above 500 ppm, and worth it on RO or very soft water"
    }, {
      k: "dpclean",
      key: "dp_clean",
      label: "Keep It Clean",
      on: false,
      chart: true,
      note: "0.1 ml/L every week including the flush — a drip-line cleaner, so only if you run drippers"
    }];

    function dutchproLine(label, blurb, weeks, weeksSoft, media, ph) {
      return {
        label: label,
        brand: "Dutch Pro",
        kind: "weekly",
        perLitre: true,
        waterType: true,
        weeks: weeks,
        weeksSoft: weeksSoft,
        blurb: blurb,
        media: media,
        ph: ph,
        extras: DP_EXTRAS.slice()
      }
    }
    LINES.dutchpro_hydro = dutchproLine("Dutch Pro Hydro/Coco", "The Hydro/Coco sheet — Grow A+B then Bloom A+B, with Silica, Take Root, Multi Total and Explode.", DP_HC, DP_HC_S, ["coco", "rockwool"], "5.8 – 6.2");
    LINES.dutchpro_soil = dutchproLine("Dutch Pro Soil", "The Soil sheet — a heavier base than Hydro/Coco, same additive rows.", DP_SO, DP_SO_S, ["soil"], "5.8 – 6.5");
    var HG_ADD = {
      hg_drip: [0, .1, .1, .1, .1, .1, .1, .1, .1, .1, .1],
      hg_roots: [.3, .3, .3, .3, .3, .3, 0, 0, 0, 0, 0],
      hg_amino: [0, .3, .5, .7, .7, .7, 0, 0, 0, 0, 0],
      hg_zen: [0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
      hg_algen: [0, .3, .3, .3, .3, .3, 0, 0, 0, 0, 0],
      hg_nitro: [0, .3, .3, .3, .5, .5, 0, 0, 0, 0, 0],
      hg_budxl: [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1],
      hg_topb: [0, 0, 0, 0, 0, 0, 0, 1.5, 0, 0, 0],
      hg_tops: [0, 0, 0, 0, 0, 0, 0, 0, .75, 1.5, 1.5]
    };
    var HG_SHOOT_G = [0, 0, 0, 0, 0, 0, 0, 0, .65, 1.3, 1.3];

    function hgWeeks(baseKey, base) {
      function cell(i) {
        var d = {};
        if (base[i]) d[baseKey] = base[i];
        Object.keys(HG_ADD).forEach(function(k) {
          if (HG_ADD[k][i]) d[k] = HG_ADD[k][i]
        });
        if (HG_SHOOT_G[i]) d.hg_shoot = HG_SHOOT_G[i];
        return {
          ec: 0,
          d: d
        }
      }
      var veg = [0, 1, 2].map(cell);
      var flower = [3, 4, 5, 6, 7, 8, 9, 10].map(cell);
      return {
        veg: veg,
        flower: flower,
        repeat: {
          veg: 2,
          flower: 4
        }
      }
    }
    var HG_EXTRAS = [{
      k: "hgdrip",
      key: "hg_drip",
      label: "Drip Clean",
      on: true,
      chart: true,
      note: "0.1 ml/L from veg week 2 to the end of the chart"
    }, {
      k: "hgroots",
      key: "hg_roots",
      label: "Roots Excelurator",
      on: true,
      chart: true,
      note: "0.3 ml/L from veg week 1 to flower week 3. Dilute it before it goes in the tank"
    }, {
      k: "hgamino",
      key: "hg_amino",
      label: "Amino Treatment",
      on: true,
      chart: true,
      note: "0.3 → 0.7 ml/L, veg week 2 to flower week 3"
    }, {
      k: "hgzen",
      key: "hg_zen",
      label: "Multi Zen",
      on: true,
      chart: true,
      note: "1 ml/L, veg week 2 to flower week 3"
    }, {
      k: "hgalgen",
      key: "hg_algen",
      label: "Algen Extract",
      on: false,
      chart: true,
      note: "0.3 ml/L, veg week 2 to flower week 3. H&G say it is not suitable for hydro or drip irrigation"
    }, {
      k: "hgnitro",
      key: "hg_nitro",
      label: "Nitrogen Boost",
      on: false,
      chart: true,
      note: "0.3 → 0.5 ml/L. On the sheet as “only required for longer veg times”"
    }, {
      k: "hgbudxl",
      key: "hg_budxl",
      label: "Bud-XL",
      on: true,
      chart: true,
      note: "1 ml/L, flower weeks 4 to 8"
    }, {
      k: "hgtopb",
      key: "hg_topb",
      label: "Top Booster",
      on: true,
      chart: true,
      note: "1.5 ml/L in flower week 5 only"
    }, {
      k: "hgtops",
      key: "hg_tops",
      label: "Top Shooter",
      on: true,
      chart: true,
      note: "The liquid finisher — 0.75 then 1.5 ml/L over the last three weeks. Start at half strength and build up"
    }, {
      k: "hgshoot",
      key: "hg_shoot",
      label: "Shooting Powder",
      on: false,
      chart: true,
      displaces: "hg_tops",
      note: "The powder finisher, and the same job as Top Shooter — 1 sachet per 100 L, then 2 sachets for the final fortnight. Ticking it takes Top Shooter out, so the total can go DOWN"
    }, {
      k: "hgmagic",
      key: "hg_magic",
      label: "Magic Green foliar",
      on: false,
      chart: true,
      note: "5 ml/L sprayed at veg week 3 and again at flower week 2"
    }];

    function hgLine(label, blurb, key, media, ph) {
      return {
        label: label,
        brand: "House & Garden",
        kind: "weekly",
        perLitre: true,
        noEc: true,
        weeks: hgWeeks(key, key === "hg_soil" ? [2, 2.5, 2.5, 3, 3.5, 4, 5, 4.5, 3, 3, 3] : [1, 1.5, 1.5, 2, 2, 2.5, 2.5, 2.5, 2, 2, 2]),
        blurb: blurb,
        media: media,
        ph: ph,
        extras: HG_EXTRAS.slice()
      }
    }
    LINES.hg_aqua = hgLine("H&G Aqua Flakes", "For recirculating systems, rockwool and inert peat mixes.", "hg_aqua", ["coco", "rockwool"], "5.7 – 5.9");
    LINES.hg_cocos = hgLine("H&G Cocos", "Built around the cation exchange of coir — the coco-specific base.", "hg_coco", ["coco"], "5.8 – 6.3");
    LINES.hg_hydro = hgLine("H&G Hydro", "The run-to-waste and hydro base.", "hg_hydro", ["coco", "rockwool"], "5.7 – 5.9");
    LINES.hg_soil = hgLine("H&G Soil", "A noticeably heavier base than the inert lines — soil only.", "hg_soil", ["soil"], "5.8 – 6.3");

    function biobizzWeeks(vegBase, flowerBase, growKey) {
      var HEAVEN = {
        veg: [2, 2],
        flower: [2, 2, 3, 4, 4, 5, 5, 5]
      };
      var BLOOM = [1, 2, 2, 3, 3, 4, 4, 4];
      var TOPMAX = [1, 1, 1, 1, 1, 4, 4, 4];
      var ALG = [1, 2, 2, 3, 3, 4, 4, 4];
      var CALMAG = [.5, .5, .5, .5, .5, .8, .8, .8];
      var veg = vegBase.map(function(v, i) {
        var d = {
          bb_heaven: HEAVEN.veg[i],
          bb_acti: HEAVEN.veg[i],
          bb_calmag: .5
        };
        if (i === 0) d.bb_root = 4;
        if (v) d[growKey] = v;
        return {
          ec: 0,
          d: d
        }
      });
      var flower = flowerBase.map(function(v, i) {
        var d = {
          bb_heaven: HEAVEN.flower[i],
          bb_acti: HEAVEN.flower[i],
          bb_bloom: BLOOM[i],
          bb_topmax: TOPMAX[i],
          bb_calmag: CALMAG[i]
        };
        if (v) d[growKey] = v;
        d.bb_alg = ALG[i];
        return {
          ec: 0,
          d: d
        }
      });
      return {
        veg: veg,
        flower: flower,
        repeat: {
          veg: 1,
          flower: 6
        }
      }
    }
    var BB_ALL_VEG = [0, 1],
      BB_ALL_FL = [1, 1, 1, 1, 1, 1, 1, 1];
    var BB_LIGHT_VEG = [0, 2],
      BB_LIGHT_FL = [2, 2, 3, 3, 4, 4, 4, 4];
    var BB_EXTRAS = [{
      k: "bbcalmag",
      key: "bb_calmag",
      label: "Cal-Mag",
      on: false,
      chart: true,
      note: "0.5 ml/L, rising to 0.8 for the last three weeks of flower. BioBizz publish a range for soil rather than a schedule row, 0.3–0.8 ml/L to prevent a deficiency, and that is what this is modelled on. Use it at every watering on RO or very soft water, or once a week if you see a deficiency"
    }, {
      k: "bbalg",
      key: "bb_alg",
      label: "Alg-A-Mic",
      on: false,
      chart: true,
      note: "1 → 4 ml/L through flower. On the Light-Mix / Coco-Mix sheet as standard; on All-Mix it is an addition"
    }];

    function biobizzLine(label, blurb, vegB, flB, useAlg, media) {
      var extras = BB_EXTRAS.map(function(e) {
        return e.k === "bbalg" ? {
          k: e.k,
          key: e.key,
          label: e.label,
          on: useAlg,
          chart: e.chart,
          note: e.note
        } : e
      }).concat([{
        k: "bbfish",
        key: "bb_fish",
        label: "Fish-Mix instead of Bio-Grow",
        on: false,
        chart: true,
        note: "BioBizz: “it is beneficial to replace Bio-Grow with Fish-Mix in the vegetative phase, but switch to Bio-Grow when you want to trigger flowering.” Ticking this swaps the whole grow row"
      }]);
      return {
        label: label,
        brand: "BioBizz",
        kind: "weekly",
        perLitre: true,
        noEc: true,
        weeks: biobizzWeeks(vegB, flB, "bb_grow"),
        weeksAlt: biobizzWeeks(vegB, flB, "bb_fish"),
        altKey: "bb_fish",
        blurb: blurb,
        media: media,
        ph: "6.2 – 6.5",
        extras: extras
      }
    }
    LINES.biobizz_allmix = biobizzLine("BioBizz All-Mix", "For pre-fertilised soil — the base runs light because the substrate is already fed.", BB_ALL_VEG, BB_ALL_FL, false, ["soil"]);
    LINES.biobizz_light = biobizzLine("BioBizz Light-Mix / Coco-Mix", "For unfertilised substrate and coco — roughly twice the base of the All-Mix sheet, plus Alg-A-Mic.", BB_LIGHT_VEG, BB_LIGHT_FL, true, ["coco", "soil"]);
    var ADDON_SPRAY_NOTE = "Sized from canopy area at 0.5 L of spray per m², which is a leaf-wet-not-dripping pass. That figure is ours, not the manufacturer’s.";

    function htWeeks(growKey, bloomKey, soft) {
      function ec(hard, sft) {
        return soft ? sft : hard
      }
      var veg = [{
        ec: ec(1.1, .9),
        d: {
          ht_root: 7.5,
          ht_bact: .2,
          ht_head: 8.5
        }
      }, {
        ec: ec(1.5, 1.3),
        d: {
          ht_root: 7.5,
          ht_bact: .2,
          ht_head: 7
        }
      }, {
        ec: ec(1.75, 1.55),
        d: {
          ht_root: 10,
          ht_bact: .2,
          ht_thc: .5
        }
      }];
      veg[2].d[growKey] = 3.5;
      veg[1].d[growKey] = 2;
      var flower = [{
        ec: ec(1.85, 1.65),
        d: {
          ht_root: 10,
          ht_bact: .2,
          ht_thc: .5
        }
      }, {
        ec: ec(1.95, 1.75),
        d: {
          ht_root: 8.5,
          ht_bact: .2,
          ht_thc: .5
        }
      }, {
        ec: ec(2.05, 1.85),
        d: {
          ht_root: 7.5,
          ht_bact: .2,
          ht_triplef: .5,
          ht_boost: .5
        }
      }, {
        ec: ec(2.15, 1.95),
        d: {
          ht_root: 5,
          ht_bact: .2,
          ht_triplef: .5,
          ht_boost: 1
        }
      }, {
        ec: ec(2.25, 2.05),
        d: {
          ht_root: 3,
          ht_bact: .2,
          ht_triplef: .5,
          ht_boost: 1.5
        }
      }, {
        ec: ec(2.05, 1.85),
        d: {
          ht_root: 2,
          ht_bact: .2,
          ht_triplef: .5,
          ht_boost: 1.5
        }
      }, {
        ec: ec(1.8, 1.6),
        d: {
          ht_bact: .2,
          ht_triplef: .5
        }
      }, {
        ec: ec(1.75, 1.35),
        d: {
          ht_bact: .2
        }
      }, {
        ec: ec(1.1, .6),
        d: {
          ht_flush: 7.5,
          ht_thc: .5
        }
      }];
      flower[0].d[growKey] = 3;
      flower[1].d[growKey] = 2;
      flower[1].d[bloomKey] = 1;
      flower[2].d[growKey] = 1;
      flower[2].d[bloomKey] = 3;
      flower[3].d[bloomKey] = 4;
      flower[4].d[bloomKey] = 4;
      flower[5].d[bloomKey] = 4;
      flower[6].d[bloomKey] = 3.5;
      flower[7].d[bloomKey] = 2.5;
      return {
        veg: veg,
        flower: flower,
        repeat: {
          veg: 2,
          flower: 4
        }
      }
    }
    var HT_EXTRAS = [{
      k: "hthead",
      key: "ht_head",
      label: "Head Start",
      on: false,
      chart: true,
      note: "7–10 ml/L for young plants and the first grow week. Skip it if your cuttings arrive already established"
    }, {
      k: "htflush",
      key: "ht_flush",
      label: "Flush",
      on: false,
      chart: true,
      note: "5–10 ml/L in the final week, with the feed out of the tank. Skip it if you finish on plain water"
    }];

    function hydrotopsLine(label, blurb, growKey, bloomKey, media, ph) {
      return {
        label: label,
        brand: "Hydrotops",
        kind: "weekly",
        perLitre: true,
        waterType: true,
        weeks: htWeeks(growKey, bloomKey, false),
        weeksSoft: htWeeks(growKey, bloomKey, true),
        softNote: "Hydrotops print one set of doses with two EC rows, one for soft water and one for hard. Switching the water type here switches which EC you are aiming at; the millilitres do not move.",
        base: {
          veg: growKey,
          flower: bloomKey
        },
        blurb: blurb,
        media: media,
        ph: ph,
        extras: HT_EXTRAS.slice()
      }
    }
    LINES.hydrotops_hydro = hydrotopsLine("Hydrotops Hydro", "Hydro Grow A+B then Hydro Bloom A+B, for inert media and recirculating systems.", "ht_hy_grow", "ht_hy_bloom", ["rockwool"], "6.0 – 6.3");
    LINES.hydrotops_coco = hydrotopsLine("Hydrotops Coco", "The coco edition of the same schedule - Coco Grow A+B then Coco Bloom A+B.", "ht_co_grow", "ht_co_bloom", ["coco"], "6.0 – 6.3");
    LINES.hydrotops_soil = hydrotopsLine("Hydrotops Solo (soil)", "Solo is a single bottle rather than an A+B, so the same chart is half the pouring.", "ht_so_grow", "ht_so_bloom", ["soil"], "6.0 – 6.3");
    var PLA_ADDITIVES_HAND = {
      pla_power_roots: [10, 10, 10, 10, 10, 0, 0, 0, 0, 0],
      pla_pure_zym: [10, 10, 10, 10, 10, 10, 0, 0, 0, 0],
      pla_green_sens: [0, 0, 0, 0, 0, 10, 10, 10, 10, 10],
      pla_sugar_royal: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
      pla_power_buds: [0, 0, 10, 10, 10, 10, 10, 10, 10, 10]
    };
    var PLA_ADDITIVES_SYS = {
      pla_hydro_roots: [10, 10, 10, 10, 10, 0, 0, 0, 0, 0],
      pla_green_sens: [0, 0, 0, 0, 0, 10, 10, 10, 10, 10],
      pla_power_buds: [0, 0, 10, 10, 10, 10, 10, 10, 10, 10]
    };
    var PLA_COCO_BASE = {
      pla_cocos_ab: [15, 20, 25, 30, 35, 35, 35, 35, 35, 35]
    };
    var PLA_LIGHT_BASE = {
      pla_terra_grow: [25, 50, 0, 0, 0, 0, 0, 0, 0, 0],
      pla_terra_bloom: [0, 0, 50, 50, 50, 40, 45, 50, 50, 50]
    };
    var PLA_GROW_BASE = {
      pla_terra_bloom: [0, 0, 0, 50, 50, 40, 45, 50, 50, 50]
    };
    var PLA_EC_COCO_HAND = [1.3, 1.5, 1.7, 1.9, 2.1, 2.5, 2.5, 2.5, 2.5, 2.5];
    var PLA_EC_COCO_SYS = [1.5, 1.7, 1.9, 2.1, 2.3, 2.5, 2.5, 2.5, 2.5, 2.5];
    var PLA_EC_LIGHT = [1, 1.6, 1.6, 1.6, 1.6, 1.8, 1.9, 2, 2, 2];
    var PLA_EC_GROW = [.6, .6, .6, 1.6, 1.6, 1.8, 1.9, 2, 2, 2];

    function plaWeeks(base, adds, ec) {
      var wk = [];
      for (var i = 0; i < 10; i++) {
        var d = {};
        Object.keys(base).forEach(function(k) {
          if (base[k][i]) d[k] = base[k][i]
        });
        Object.keys(adds).forEach(function(k) {
          if (adds[k][i]) d[k] = adds[k][i]
        });
        wk.push({
          ec: ec[i],
          d: d
        })
      }
      wk.push({
        ec: 0,
        d: {}
      });
      return {
        veg: wk.slice(0, 2),
        flower: wk.slice(2),
        repeat: {
          veg: 1,
          flower: 3
        }
      }
    }
    var PLA_ADD_ROWS = [{
      k: "plaroots",
      key: "pla_power_roots",
      label: "Power Roots",
      on: true,
      chart: true,
      note: "1 ml/L for the first five weeks"
    }, {
      k: "plahroots",
      key: "pla_hydro_roots",
      label: "Hydro Roots",
      on: true,
      chart: true,
      note: "1 ml/L for the first five weeks. The system-feeding equivalent of Power Roots"
    }, {
      k: "plazym",
      key: "pla_pure_zym",
      label: "Pure Zym",
      on: true,
      chart: true,
      note: "1 ml/L, weeks one to six"
    }, {
      k: "plagreen",
      key: "pla_green_sens",
      label: "Green Sensation",
      on: true,
      chart: true,
      note: "1 ml/L from week six to the end. The dearest bottle on the sheet by some distance"
    }, {
      k: "plasugar",
      key: "pla_sugar_royal",
      label: "Sugar Royal",
      on: true,
      chart: true,
      note: "1 ml/L every feeding week"
    }, {
      k: "plabuds",
      key: "pla_power_buds",
      label: "Power Buds",
      on: true,
      chart: true,
      note: "1 ml/L from week three to the end"
    }];

    function plaExtras(adds) {
      return PLA_ADD_ROWS.filter(function(e) {
        return adds[e.key]
      }).map(function(e) {
        return {
          k: e.k,
          key: e.key,
          label: e.label,
          on: e.on,
          chart: e.chart,
          note: e.note
        }
      })
    }
    var PLA_PER10 = " Plagron dose per 10 litres; the chart here is converted to millilitres per litre.";

    function plaLine(label, blurb, base, adds, ec, media) {
      return {
        label: label,
        brand: "Plagron",
        kind: "weekly",
        ecIncludesTap: true,
        weeks: plaWeeks(base, adds, ec),
        base: {
          veg: Object.keys(base)[0],
          flower: Object.keys(base)[0]
        },
        blurb: blurb + PLA_PER10,
        media: media,
        ph: "5.5 – 6.5",
        extras: plaExtras(adds)
      }
    }
    LINES.plagron_coco_hand = plaLine("Plagron 100% Coco — hand feeding", "Cocos A&B the whole way, ramping 1.5 to 3.5 ml/L, on the hand-feeding additive block.", PLA_COCO_BASE, PLA_ADDITIVES_HAND, PLA_EC_COCO_HAND, ["coco"]);
    LINES.plagron_coco_system = plaLine("Plagron 100% Coco — system feeding", "The same base on Plagron’s system-feeding block: Hydro Roots instead of Power Roots, and no Pure Zym or Sugar Royal. Their EC row runs higher from week one.", PLA_COCO_BASE, PLA_ADDITIVES_SYS, PLA_EC_COCO_SYS, ["coco"]);
    LINES.plagron_terra_light = plaLine("Plagron 100% Terra — Lightmix", "Terra Grow for the two grow weeks, then Terra Bloom for the rest. Lightmix is barely fertilised, so the feed starts in week one.", PLA_LIGHT_BASE, PLA_ADDITIVES_HAND, PLA_EC_LIGHT, ["soil"]);
    LINES.plagron_terra_grow = plaLine("Plagron 100% Terra — Growmix", "No Terra Grow at all and no base until week four: Growmix is pre-fertilised, so the sheet lets the soil do the early feeding and starts on an EC of 0.6.", PLA_GROW_BASE, PLA_ADDITIVES_HAND, PLA_EC_GROW, ["soil"]);
    var CH_VEG = [{
      ec: 0,
      d: {
        ch_upthrive: 1,
        ch_elan: 1,
        ch_spark: .5,
        ch_kickoff: 1
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 1,
        ch_elan: 1,
        ch_spark: 1,
        ch_kickoff: .5
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 1.5,
        ch_elan: 1.5,
        ch_spark: 1,
        ch_kickoff: .5
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 1.5,
        ch_elan: 2,
        ch_prosper: .5,
        ch_spark: 1.5,
        ch_kickoff: .5
      }
    }];
    var CH_FLOWER = [{
      ec: 0,
      d: {
        ch_upthrive: 2,
        ch_elan: 2.5,
        ch_prosper: 1,
        ch_spark: 2,
        ch_kickoff: .5
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 2,
        ch_elan: 2.5,
        ch_prosper: 2,
        ch_spark: 2.5,
        ch_kickoff: .5
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 1.5,
        ch_elan: 3,
        ch_prosper: 3,
        ch_spark: 3,
        ch_kickoff: .5
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 1.5,
        ch_elan: 3,
        ch_prosper: 3,
        ch_spark: 3,
        ch_kickoff: .5
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 1,
        ch_elan: 3.5,
        ch_prosper: 3,
        ch_spark: 4,
        ch_kickoff: .5
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 1,
        ch_elan: 4,
        ch_prosper: 4,
        ch_spark: 4,
        ch_kickoff: .5
      }
    }, {
      ec: 0,
      d: {
        ch_upthrive: 1,
        ch_elan: 5,
        ch_prosper: 4,
        ch_spark: 5
      }
    }, {
      ec: 0,
      d: {
        ch_elan: 3,
        ch_prosper: 3,
        ch_spark: 3
      }
    }, {
      ec: 0,
      d: {}
    }, {
      ec: 0,
      d: {}
    }];
    LINES.crazyhills = {
      label: "Crazy Hills",
      brand: "Crazy Hills",
      kind: "weekly",
      perLitre: true,
      noEc: true,
      weeks: {
        veg: CH_VEG,
        flower: CH_FLOWER,
        repeat: {
          veg: 2,
          flower: 3
        }
      },
      base: {
        veg: "ch_upthrive",
        flower: "ch_upthrive"
      },
      blurb: "A fully organic four-bottle program with a microbial inoculant, on one chart with no grower levels. Eight bloom weeks and an optional two-week finish.",
      media: ["coco", "soil"],
      ph: "Veg 5.8 – 6.2, bloom 6.0 – 6.5",
      extras: [{
        k: "chkick",
        key: "ch_kickoff",
        label: "Kick Off",
        on: true,
        chart: true,
        note: "1 g/L in the first week, then 0.5 g/L to the end of bloom week 6. A microbial inoculant rather than a feed, so it is the one row here you might reasonably run without"
      }]
    };
    var TA_TRI_HC = {
      ta_tri_grow: [.5, 1, 1.8, 2, .8],
      ta_tri_micro: [.5, 1, 1.2, 2, 1.6],
      ta_tri_bloom: [.5, 1, .6, 1.5, 2.4]
    };
    var TA_TRI_SO = {
      ta_tri_grow: [.2, .6, 1.5, 1.5, .7],
      ta_tri_micro: [.2, .6, 1, 1.5, 1.4],
      ta_tri_bloom: [.2, .6, .5, 1, 2.1]
    };
    var TA_DP_HC = {
      ta_dp_grow: [.5, 1.5, 3, 3, 1.5],
      ta_dp_bloom: [.5, 1, 1, 2.5, 3]
    };
    var TA_DP_SO = {
      ta_dp_grow: [.3, 1, 2.5, 2, 1],
      ta_dp_bloom: [.3, .5, .5, 2, 3]
    };
    var TA_DPC = {
      ta_dpc_grow: [.5, 1, 2.5, 3, 1.5],
      ta_dpc_bloom: [.5, 1, 1, 2, 3]
    };
    var TA_EXP_HC = {
      ta_proroots: [.2, .2, 0, 0, 0, 0],
      ta_rootboost: [5, 3, 0, 0, 0, 0],
      ta_fulvic: [2, 2, 2, 2, 0, 0],
      ta_seaweed: [0, 5, 5, 5, 5, 0],
      ta_probloom: [0, 0, 0, .2, .2, .2],
      ta_bloomboost: [0, 0, 0, 5, 5, 5]
    };
    var TA_EXP_SO = {
      ta_proroots: [.2, .2, 0, 0, 0, 0],
      ta_rootboost: [5, 3, 0, 0, 0, 0],
      ta_seaweed: [0, 5, 5, 5, 5, 0],
      ta_humic: [3, 4, 4, 4, 0, 0],
      ta_probloom: [0, 0, 0, .2, .2, .2],
      ta_bloomboost: [0, 0, 0, 5, 5, 5]
    };
    var TA_EC_HC = [.45, 1, 1.55, 1.9, 1.8, 2];
    var TA_EC_SO = [.35, .8, 1.35, 1.6, 1.5, 1.65];

    function taWeeks(base, exp, ripen, ec) {
      var stage = [{}, {}, {}, {}, {}, {}];
      Object.keys(base).forEach(function(k) {
        for (var i = 0; i < 5; i++)
          if (base[k][i]) stage[i][k] = base[k][i]
      });
      stage[5].ta_final = ripen;
      if (exp) Object.keys(exp).forEach(function(k) {
        for (var i = 0; i < 6; i++)
          if (exp[k][i]) stage[i][k] = exp[k][i]
      });
      return {
        veg: [0, 1, 2].map(function(i) {
          return {
            ec: ec[i],
            d: stage[i]
          }
        }),
        flower: [3, 4, 5].map(function(i) {
          return {
            ec: ec[i],
            d: stage[i]
          }
        }),
        repeat: {
          veg: 2,
          flower: 1
        }
      }
    }

    function taExtras(soil) {
      return [{
        k: "taroots",
        key: "ta_proroots",
        label: "Pro Roots",
        on: true,
        chart: true,
        note: "0.2 ml/L through the first two stages. Terra Aquatica print Pro Roots OR Root Booster, never both"
      }, {
        k: "tarootb",
        key: "ta_rootboost",
        label: "Root Booster",
        on: false,
        chart: true,
        displaces: "ta_proroots",
        note: "5 ml/L then 3 ml/L, the alternative to Pro Roots. Twenty-five times the dose, and a different bottle size to match — tick it and Pro Roots comes out"
      }, soil ? {
        k: "tahumic",
        key: "ta_humic",
        label: "Humic",
        on: true,
        chart: true,
        note: "3 ml/L at first roots, then 4 ml/L to the end of preflowering. The soil charts carry Humic where the hydro and coco ones carry Fulvic"
      } : {
        k: "tafulvic",
        key: "ta_fulvic",
        label: "Fulvic",
        on: true,
        chart: true,
        note: "2 ml/L from first roots to the end of preflowering. The hydro and coco charts carry Fulvic where the soil ones carry Humic"
      }, {
        k: "taseaweed",
        key: "ta_seaweed",
        label: "Seaweed",
        on: true,
        chart: true,
        note: "5 ml/L from the first true leaves right through flowering"
      }, {
        k: "tapbloom",
        key: "ta_probloom",
        label: "Pro Bloom",
        on: true,
        chart: true,
        note: "0.2 ml/L from preflowering through ripening. Pro Bloom OR Bloom Booster, never both"
      }, {
        k: "tabloomb",
        key: "ta_bloomboost",
        label: "Bloom Booster",
        on: false,
        chart: true,
        displaces: "ta_probloom",
        note: "5 ml/L from preflowering through ripening, the alternative to Pro Bloom — tick it and Pro Bloom comes out"
      }]
    }

    function taLine(label, blurb, base, exp, ripen, ec, media, soil) {
      var l = {
        label: label,
        brand: "Terra Aquatica",
        kind: "weekly",
        perLitre: true,
        weeks: taWeeks(base, exp, ripen, ec),
        blurb: blurb,
        media: media,
        extras: exp ? taExtras(soil) : []
      };
      var first = Object.keys(base)[0];
      l.base = {
        veg: first,
        flower: first
      };
      return l
    }
    var TA_EASY = " The Easy chart: the base bottles and nothing else.";
    var TA_EXP = " The Easy chart plus Terra Aquatica’s Expert band — a root stimulant, Fulvic or Humic, Seaweed and a bloom stimulant.";
    LINES.ta_tripart_hc_easy = taLine("TriPart Hydro/Coco — Easy", "Grow, Micro and Bloom mixed together every week, in the order they print them." + TA_EASY, TA_TRI_HC, null, 5, TA_EC_HC, ["coco", "rockwool"], false);
    LINES.ta_tripart_hc_exp = taLine("TriPart Hydro/Coco — Expert", "Grow, Micro and Bloom mixed together every week, in the order they print them." + TA_EXP, TA_TRI_HC, TA_EXP_HC, 5, TA_EC_HC, ["coco", "rockwool"], false);
    LINES.ta_tripart_soil_easy = taLine("TriPart Soil — Easy", "The same three bottles on the soil sheet, which runs lighter than the hydro one all the way through." + TA_EASY, TA_TRI_SO, null, 4, TA_EC_SO, ["soil"], true);
    LINES.ta_tripart_soil_exp = taLine("TriPart Soil — Expert", "The same three bottles on the soil sheet, which runs lighter than the hydro one all the way through." + TA_EXP, TA_TRI_SO, TA_EXP_SO, 4, TA_EC_SO, ["soil"], true);
    LINES.ta_dualpart_hydro_easy = taLine("DualPart Hydro — Easy", "Two bottles rather than three, run together the whole way. Terra Aquatica head this sheet Hydro/Coco; in coco their DualPart Coco chart is the one to run." + TA_EASY, TA_DP_HC, null, 5, TA_EC_HC, ["rockwool"], false);
    LINES.ta_dualpart_hydro_exp = taLine("DualPart Hydro — Expert", "Two bottles rather than three, run together the whole way. Terra Aquatica head this sheet Hydro/Coco; in coco their DualPart Coco chart is the one to run." + TA_EXP, TA_DP_HC, TA_EXP_HC, 5, TA_EC_HC, ["rockwool"], false);
    LINES.ta_dualpart_soil_easy = taLine("DualPart Soil — Easy", "The two-bottle range on the soil sheet, with Bloom held right back until preflowering." + TA_EASY, TA_DP_SO, null, 4, TA_EC_SO, ["soil"], true);
    LINES.ta_dualpart_soil_exp = taLine("DualPart Soil — Expert", "The two-bottle range on the soil sheet, with Bloom held right back until preflowering." + TA_EXP, TA_DP_SO, TA_EXP_SO, 4, TA_EC_SO, ["soil"], true);
    LINES.ta_dualpart_coco_easy = taLine("DualPart Coco — Easy", "Coco’s own bottles and its own chart, buffered for the medium rather than borrowed from the hydro sheet." + TA_EASY, TA_DPC, null, 5, TA_EC_HC, ["coco"], false);
    LINES.ta_dualpart_coco_exp = taLine("DualPart Coco — Expert", "Coco’s own bottles and its own chart, buffered for the medium rather than borrowed from the hydro sheet." + TA_EXP, TA_DPC, TA_EXP_HC, 5, TA_EC_HC, ["coco"], false);

    function anWeeks(vegKeys, flowerKeys, bigBudKey, advanced) {
      var veg = [1, 2, 3, 4].map(function(v, i) {
        var d = {
          an_b52: 2
        };
        vegKeys.forEach(function(k) {
          d[k] = v
        });
        if (i < 2) d.an_voodoo = 2;
        if (advanced) {
          d.an_rhino = 2;
          d.an_sensizym = 2;
          d.an_budcandy = 2;
          if (i < 2) {
            d.an_tarantula = 2;
            d.an_piranha = 2
          }
        }
        return {
          ec: 0,
          d: d
        }
      });
      var flower = [];
      for (var i = 0; i < 9; i++) {
        var d = {};
        flowerKeys.forEach(function(k) {
          d[k] = 4
        });
        if (i < 2) d.an_voodoo = 2;
        if (i >= 2) d.an_b52 = 2;
        if (i >= 1) d[bigBudKey] = 2;
        if (i >= 5) d.an_overdrive = 2;
        if (advanced) {
          d.an_sensizym = 2;
          d.an_budcandy = 2;
          if (i < 2) d.an_piranha = 2;
          if (i >= 2) d.an_terpenes = 2
        }
        flower.push({
          ec: 0,
          d: d
        })
      }
      if (advanced) flower.push({
        ec: 0,
        d: {
          an_flawless: 2
        }
      });
      return {
        veg: veg,
        flower: flower,
        repeat: {
          flower: 7
        }
      }
    }
    var AN_BEGINNER = [{
      k: "anb52",
      key: "an_b52",
      label: "B-52",
      on: true,
      chart: true,
      note: "2 ml/L through veg, and from flower week 3 to the end"
    }, {
      k: "anvoodoo",
      key: "an_voodoo",
      label: "Voodoo Juice",
      on: true,
      chart: true,
      note: "2 ml/L for the first two weeks of veg and the first two of flower — the two moments roots are being built"
    }, {
      k: "anover",
      key: "an_overdrive",
      label: "Overdrive",
      on: true,
      chart: true,
      note: "2 ml/L from flower week 6 to the end. The late-bloom finisher"
    }];
    var AN_ADVANCED = [{
      k: "antar",
      key: "an_tarantula",
      label: "Tarantula",
      on: true,
      chart: true,
      note: "2 ml/L, first two weeks of veg only"
    }, {
      k: "anpir",
      key: "an_piranha",
      label: "Piranha",
      on: true,
      chart: true,
      note: "2 ml/L, first two weeks of veg and the first two of flower"
    }, {
      k: "anrhino",
      key: "an_rhino",
      label: "Rhino Skin",
      on: false,
      chart: true,
      note: "2 ml/L through veg. A potassium silicate, so anything picked in the silicon step replaces it"
    }, {
      k: "anzym",
      key: "an_sensizym",
      label: "Sensizym",
      on: true,
      chart: true,
      note: "2 ml/L, veg to the end of flower"
    }, {
      k: "ancandy",
      key: "an_budcandy",
      label: "Bud Candy",
      on: true,
      chart: true,
      note: "2 ml/L, veg to the end of flower"
    }, {
      k: "anterp",
      key: "an_terpenes",
      label: "Tasty Terpenes",
      on: true,
      chart: true,
      note: "2 ml/L from flower week 3 to the end"
    }, {
      k: "anflaw",
      key: "an_flawless",
      label: "Flawless Finish",
      on: true,
      chart: true,
      note: "2 ml/L in the flush week, with the feed out of the tank"
    }];

    function anLine(label, blurb, vegKeys, flowerKeys, bigBudKey, advanced, media) {
      var bb = {
        k: "anbb",
        key: bigBudKey,
        label: CATALOG[bigBudKey].title.replace("AN ", ""),
        on: true,
        chart: true,
        note: "2 ml/L from flower week 2 to the end"
      };
      return {
        label: label,
        brand: "Advanced Nutrients",
        kind: "weekly",
        perLitre: true,
        noEc: true,
        weeks: anWeeks(vegKeys, flowerKeys, bigBudKey, advanced),
        base: vegKeys[0] === flowerKeys[0] ? null : {
          veg: vegKeys[0],
          flower: flowerKeys[0]
        },
        blurb: blurb,
        media: media,
        ph: "5.5 – 6.5",
        extras: AN_BEGINNER.slice(0, 2).concat([bb], AN_BEGINNER.slice(2), advanced ? AN_ADVANCED : [])
      }
    }
    var AN_PHP = " AN’s pH Perfect bases buffer the solution themselves, so there is no target EC printed and no pH adjusting on their instructions.";
    LINES.an_coco_beg = anLine("AN Coco Sensi — Beginner", "Coco Sensi Grow then Bloom A+B, with B-52, Voodoo Juice, COCO Big Bud and Overdrive." + AN_PHP, ["an_coco_grow"], ["an_coco_bloom"], "an_bigbud_coco", false, ["coco"]);
    LINES.an_coco_adv = anLine("AN Coco Sensi — Advanced", "The Beginner chart plus Tarantula, Piranha, Rhino Skin, Sensizym, Bud Candy, Tasty Terpenes and a Flawless Finish flush." + AN_PHP, ["an_coco_grow"], ["an_coco_bloom"], "an_bigbud_coco", true, ["coco"]);
    LINES.an_soil_beg = anLine("AN Sensi Soil — Beginner", "Sensi Grow then Bloom A+B, with B-52, Voodoo Juice, Big Bud and Overdrive." + AN_PHP, ["an_soil_grow"], ["an_soil_bloom"], "an_bigbud", false, ["soil"]);
    LINES.an_soil_adv = anLine("AN Sensi Soil — Advanced", "The Beginner chart plus Tarantula, Piranha, Rhino Skin, Sensizym, Bud Candy, Tasty Terpenes and a Flawless Finish flush." + AN_PHP, ["an_soil_grow"], ["an_soil_bloom"], "an_bigbud", true, ["soil"]);
    var AN_GMB = ["an_gmb_grow", "an_gmb_micro", "an_gmb_bloom"];
    LINES.an_3part_beg = anLine("AN 3-Part — Beginner", "Grow, Micro and Bloom together, veg to harvest. The same three bottles all the way through, so nothing is switched at the flip." + AN_PHP, AN_GMB, AN_GMB, "an_bigbud", false, ["coco", "soil", "rockwool"]);
    LINES.an_3part_adv = anLine("AN 3-Part — Advanced", "The Beginner chart plus Tarantula, Piranha, Rhino Skin, Sensizym, Bud Candy, Tasty Terpenes and a Flawless Finish flush." + AN_PHP, AN_GMB, AN_GMB, "an_bigbud", true, ["coco", "soil", "rockwool"]);

    function remoWeeks(vegRow, flowerBase, flowerLate) {
      var veg = vegRow.map(function(v) {
        return {
          ec: 0,
          d: {
            rm_micro: v,
            rm_grow: v,
            rm_velo: v,
            rm_magni: v
          }
        }
      });
      var flower = [];
      for (var i = 0; i < 7; i++) {
        var v = i < 4 ? flowerBase : flowerLate;
        var d = {
          rm_micro: v,
          rm_bloom: v,
          rm_velo: v,
          rm_candy: v,
          rm_astro: v
        };
        if (i < 5) d.rm_magni = 2;
        flower.push({
          ec: 0,
          d: d
        })
      }
      flower.push({
        ec: 0,
        d: {}
      });
      return {
        veg: veg,
        flower: flower,
        repeat: {
          flower: 6
        }
      }
    }

    function remoElementsWeeks() {
      var A = .525,
        B = .525;
      var veg = [0, 1, 2, 3].map(function() {
        return {
          ec: 1.7,
          d: {
            rm_el_a: A,
            rm_el_b: B
          }
        }
      });
      var flower = [];
      for (var i = 0; i < 7; i++) {
        flower.push({
          ec: i < 3 ? 2 : 2.3,
          d: {
            rm_el_a: A,
            rm_el_b: B,
            rm_el_boost: i < 3 ? .26 : .525
          }
        })
      }
      flower.push({
        ec: 0,
        d: {}
      });
      return {
        veg: veg,
        flower: flower,
        repeat: {
          flower: 6
        }
      }
    }
    var REMO_EXTRAS = [{
      k: "rmvelo",
      key: "rm_velo",
      label: "VeloKelp",
      on: true,
      chart: true,
      note: "Kelp extract. Every week of veg and the first seven of flower"
    }, {
      k: "rmmagni",
      key: "rm_magni",
      label: "MagNifiCal",
      on: true,
      chart: true,
      note: "Cal/Mag. Stops after flower week five on both charts"
    }, {
      k: "rmcandy",
      key: "rm_candy",
      label: "Nature's Candy",
      on: true,
      chart: true,
      note: "Carbohydrates and flavour, through flower"
    }, {
      k: "rmastro",
      key: "rm_astro",
      label: "AstroFlower",
      on: true,
      chart: true,
      note: "The flowering booster, through flower"
    }];
    var REMO_EL_EXTRAS = [{
      k: "rmboost",
      key: "rm_el_boost",
      label: "Supercharged Boost",
      on: true,
      chart: true,
      note: "26 g per 100 L for the first three weeks of flower, then 52.5 g. It is what takes the target EC from 2.0 to 2.3"
    }];

    function remoLine(label, blurb, weeks, media, noEc, extras) {
      return {
        label: label,
        brand: "Remo",
        kind: "weekly",
        perLitre: true,
        noEc: !!noEc,
        weeks: weeks,
        blurb: blurb,
        media: media,
        ph: "5.8 – 6.3",
        extras: extras.slice()
      }
    }
    LINES.remo_hydro = remoLine("Remo Hydro", "Remo's hydro chart: Micro and Grow, then Micro and Bloom, with VeloKelp, MagNifiCal, Nature's Candy and AstroFlower.", remoWeeks([1, 1, 1, 2], 2, 2), ["rockwool"], true, REMO_EXTRAS);
    LINES.remo_soil = remoLine("Remo Soil / Coco", "The soil and coco chart, a step heavier than the hydro one through veg and again over the last three weeks of flower.", remoWeeks([1, 2, 2, 2], 2, 3), ["coco", "soil"], true, REMO_EXTRAS);
    LINES.remo_elements = remoLine("Remo Elements (powder)", "The water-soluble range: Part A and Part B all the way through, with Supercharged Boost from the first week of flower. Dosed by weight, and the one Remo sheet that prints a target EC.", remoElementsWeeks(), ["coco", "soil", "rockwool"], false, REMO_EL_EXTRAS);
    var WATER_KEYS = {
      can_hyd_vega: {
        hard: "can_hyd_vega_h",
        soft: "can_hyd_vega_s"
      },
      can_hyd_flores: {
        hard: "can_hyd_flor_h",
        soft: "can_hyd_flor_s"
      },
      sho_hyd_grow: {
        hard: "sho_hyd_grow_h",
        soft: "sho_hyd_grow_s"
      },
      sho_hyd_bloom: {
        hard: "sho_hyd_bloom_h",
        soft: "sho_hyd_bloom_s"
      },
      dp_hc_grow: {
        hard: "dp_hc_grow_h",
        soft: "dp_hc_grow_s"
      },
      dp_hc_bloom: {
        hard: "dp_hc_bloom_h",
        soft: "dp_hc_bloom_s"
      },
      dp_so_grow: {
        hard: "dp_so_grow_h",
        soft: "dp_so_grow_s"
      },
      dp_so_bloom: {
        hard: "dp_so_bloom_h",
        soft: "dp_so_bloom_s"
      },
      ta_tri_micro: {
        hard: "ta_tri_micro_h",
        soft: "ta_tri_micro_s"
      },
      ta_dp_grow: {
        hard: "ta_dp_grow_h",
        soft: "ta_dp_grow_s"
      },
      vb_base: {
        hard: "vb_tap",
        soft: "vb_ro"
      },
      hth_base: {
        hard: "hth_tap",
        soft: "hth_ro"
      }
    };

    function resolveKey(k, water) {
      var m = WATER_KEYS[k];
      return m ? m[water] || m.hard : k
    }
    /* ==================================================================
       IONIC, the 2026 relaunch. Growth Technology.

       Four printed A4 schedules, all 4 grow + 9 bloom, all ml per litre,
       all pH 5.8–6.2 on every week. Transcribed in
       claude/ionic-2026-schedules.md; the PDFs are the source of truth.

       FOUR LINES, NOT TWO WITH A WATER TOGGLE. IONIC's hard water range is
       a different product (its own SKUs), a different EC band, and a
       different chart — hard water carries no Tonic at all and finishes on
       plain water. That is three differences, so it gets its own line
       rather than riding WATER_KEYS the way CANNA Hydro does.

       WHERE A RANGE IS PRINTED, THE MIDPOINT IS STORED. Root Boost, Flower
       Boost and some Tonic weeks print 0.5–1 ml/L, so they are held at
       0.75, which is the convention every other ranged chart in this
       engine already uses. Agreed with Steve 26 Sep 2026.

       EC is the midpoint of each printed band, same convention.
       ================================================================== */
    var ION_TIERS_BASE = function (a, b, c) {
      return [{ sku: a, t: "1L", size: 1, price: 14.28 },
              { sku: b, t: "5L", size: 5, price: 37.8 },
              { sku: c, t: "20L", size: 20, price: 87.96 }];
    };
    CATALOG.ion_hydro_g = { handle: "ionic-hydro-grow", title: "Ionic Hydro Grow", unit: "ml", tiers: ION_TIERS_BASE("13876", "13877", "13878") };
    CATALOG.ion_hydro_b = { handle: "ionic-hydro-bloom", title: "Ionic Hydro Bloom", unit: "ml", tiers: ION_TIERS_BASE("13879", "13880", "13881") };
    CATALOG.ion_hw_g = { handle: "ionic-hard-water-grow", title: "Ionic Hard Water Grow", unit: "ml", tiers: ION_TIERS_BASE("13882", "13883", "13884") };
    CATALOG.ion_hw_b = { handle: "ionic-hard-water-bloom", title: "Ionic Hard Water Bloom", unit: "ml", tiers: ION_TIERS_BASE("13885", "13886", "13887") };
    CATALOG.ion_coco_g = { handle: "ionic-coco-grow", title: "Ionic Coco Grow", unit: "ml", tiers: ION_TIERS_BASE("13888", "13889", "13890") };
    CATALOG.ion_coco_b = { handle: "ionic-coco-bloom", title: "Ionic Coco Bloom", unit: "ml", tiers: ION_TIERS_BASE("13891", "13892", "13893") };
    CATALOG.ion_soil_g = { handle: "ionic-soil-grow", title: "Ionic Soil Grow", unit: "ml", tiers: ION_TIERS_BASE("13870", "13871", "13872") };
    CATALOG.ion_soil_b = { handle: "ionic-soil-bloom", title: "Ionic Soil Bloom", unit: "ml", tiers: ION_TIERS_BASE("13873", "13874", "13875") };
    CATALOG.ion_tonic = {
      handle: "ionic-tonic", title: "Ionic Tonic", unit: "ml",
      tiers: [{ sku: "12965", t: "1L", size: 1, price: 21.6 },
              { sku: "12966", t: "5L", size: 5, price: 64.68 }]
    };
    CATALOG.ion_pk = {
      handle: "ionic-pk", title: "Ionic PK", unit: "ml",
      tiers: [{ sku: "12969", t: "1L", size: 1, price: 18 },
              { sku: "12970", t: "5L", size: 5, price: 65.64 },
              { sku: "12971", t: "20L", size: 20, price: 144.96 }]
    };
    CATALOG.ion_root = {
      handle: "ionic-root-boost", title: "Ionic Root Boost", unit: "ml",
      tiers: [{ sku: "13894", t: "300ml", size: 0.3, price: 48 },
              { sku: "13895", t: "1L", size: 1, price: 120 }]
    };
    CATALOG.ion_flower = {
      handle: "ionic-flower-boost", title: "Ionic Flower Boost", unit: "ml",
      tiers: [{ sku: "13896", t: "300ml", size: 0.3, price: 36 },
              { sku: "13897", t: "1L", size: 1, price: 93.6 }]
    };

    var ION_RANGE_MID = 0.75;

    /* rows: [growDose, bloomDose, tonic, pk, root, flower, ec] per week,
       0 meaning the row is absent that week. Written out longhand rather
       than generated, because these are transcriptions and a generator
       hides a mistake behind a clever line. */
    function ionWeeks(gKey, bKey, veg, flower) {
      function row(r) {
        var d = {};
        if (r.g) d[gKey] = r.g;
        if (r.b) d[bKey] = r.b;
        if (r.tonic) d.ion_tonic = r.tonic;
        if (r.pk) d.ion_pk = r.pk;
        if (r.root) d.ion_root = r.root;
        if (r.flower) d.ion_flower = r.flower;
        return { ec: r.ec, d: d };
      }
      return { veg: veg.map(row), flower: flower.map(row), repeat: { flower: 7 } };
    }

    var M = ION_RANGE_MID;

    var ION_COCO = ionWeeks("ion_coco_g", "ion_coco_b", [
      { g: 5, root: M, ec: 1.0 },
      { g: 5, root: M, ec: 1.0 },
      { g: 5, tonic: 1, root: M, ec: 1.4 },
      { g: 5, tonic: 1, root: M, ec: 1.4 }
    ], [
      { g: 5, tonic: 1, flower: M, ec: 1.4 },
      { b: 7, tonic: 1, flower: M, ec: 1.7 },
      { b: 7, tonic: 1, flower: M, ec: 1.7 },
      { b: 7, tonic: 1, pk: 1, flower: M, ec: 2.0 },
      { b: 7, tonic: 1, pk: 1, flower: M, ec: 2.0 },
      { b: 7, tonic: 1, pk: 1, ec: 2.0 },
      { b: 7, pk: 1, ec: 2.0 },
      { b: 7, pk: 1, ec: 2.0 },
      { b: 1, ec: 0 }
    ]);

    var ION_SOIL = ionWeeks("ion_soil_g", "ion_soil_b", [
      { g: 5, root: M, ec: 1.1 },
      { g: 5, root: M, ec: 1.1 },
      { g: 7, root: M, ec: 1.3 },
      { g: 7, root: M, ec: 1.3 }
    ], [
      { g: 7, flower: M, ec: 1.3 },
      { b: 7, tonic: 0.5, flower: M, ec: 1.5 },
      { b: 7, tonic: 0.5, flower: M, ec: 1.5 },
      { b: 7, tonic: 0.5, pk: 1, flower: M, ec: 1.9 },
      { b: 7, tonic: 0.5, pk: 1, flower: M, ec: 1.9 },
      { b: 7, tonic: 0.5, pk: 1, ec: 1.9 },
      { b: 7, pk: 1, ec: 1.9 },
      { b: 7, pk: 1, ec: 1.9 },
      { b: 1, ec: 0 }
    ]);

    var ION_HYDRO = ionWeeks("ion_hydro_g", "ion_hydro_b", [
      { g: 5, root: M, ec: 1.5 },
      { g: 5, root: M, ec: 1.5 },
      { g: 5, root: M, ec: 1.5 },
      { g: 6, root: M, ec: 1.9 }
    ], [
      { g: 6, flower: M, ec: 1.9 },
      { b: 6, tonic: 0.5, flower: M, ec: 1.9 },
      { b: 6, tonic: 0.5, flower: M, ec: 1.9 },
      { b: 5, tonic: 0.5, pk: 1, flower: M, ec: 2.1 },
      { b: 5, tonic: 0.5, pk: 1, flower: M, ec: 2.1 },
      { b: 5, tonic: 0.5, pk: 1, ec: 2.1 },
      { b: 5, pk: 1, ec: 2.1 },
      { b: 5, pk: 1, ec: 2.1 },
      { b: 1, ec: 2.1 }
    ]);

    /* Hard water carries NO Tonic on the printed chart, and finishes on
       plain water rather than a light feed. Both are deliberate: IONIC say
       to use Tonic on this range "only where there is a recognised need,
       0.5 ml per litre for one week", which is a remedy and not a schedule
       row, so it is a warning below rather than a dose here. */
    var ION_HW = ionWeeks("ion_hw_g", "ion_hw_b", [
      { g: 5, root: M, ec: 1.9 },
      { g: 5, root: M, ec: 1.9 },
      { g: 5, root: M, ec: 1.9 },
      { g: 6, root: M, ec: 2.3 }
    ], [
      { g: 6, flower: M, ec: 2.3 },
      { b: 6, flower: M, ec: 2.3 },
      { b: 6, flower: M, ec: 2.3 },
      { b: 5, pk: 1, flower: M, ec: 2.5 },
      { b: 5, pk: 1, flower: M, ec: 2.5 },
      { b: 5, pk: 1, ec: 2.5 },
      { b: 5, pk: 1, ec: 2.5 },
      { b: 5, pk: 1, ec: 2.5 },
      { ec: 0 }
    ]);

    function ionExtras(hasTonic) {
      var e = [{
        k: "root", key: "ion_root", label: "Root Boost", on: true, chart: true,
        note: "0.5–1 ml/L through grow. Priced at the 0.75 midpoint"
      }, {
        k: "flower", key: "ion_flower", label: "Flower Boost", on: true, chart: true,
        note: "0.5–1 ml/L from the first bloom week. Priced at the 0.75 midpoint"
      }, {
        k: "pk", key: "ion_pk", label: "PK 14/15", on: true, chart: true,
        note: "1 ml/L over the hungriest weeks"
      }];
      if (hasTonic) e.splice(2, 0, {
        k: "tonic", key: "ion_tonic", label: "Tonic", on: true, chart: true,
        note: "On the chart from grow week 3 on coco, from bloom week 2 on soil and hydro"
      });
      return e;
    }

    function ionLine(label, blurb, weeks, media, hasTonic) {
      var L = {
        label: label,
        brand: "IONIC",
        kind: "weekly",
        weeks: weeks,
        perLitre: true,
        ph: "5.8 – 6.2",
        blurb: blurb,
        media: media,
        extras: ionExtras(hasTonic)
      };
      L.chartNote = hasTonic ? "The last week is a light feed at 1 ml per litre rather than plain water. That is how IONIC print it." : "IONIC print no Tonic at all on the hard water chart, and the run finishes on plain water. They say to use Tonic on this range only where there is a recognised need, 0.5 ml per litre for a single week, which is a fix rather than part of the schedule.";
      return L;
    }

    LINES.ionic_coco = ionLine("IONIC Coco",
      "The coco chart. One bottle rather than an A and a B, and the switch to Bloom comes a week later than most.",
      ION_COCO, ["coco"], true);
    LINES.ionic_soil = ionLine("IONIC Soil",
      "The soil chart, on the humic-rich Soil Grow and Bloom. Tonic runs at half the coco rate and only in bloom.",
      ION_SOIL, ["soil"], true);
    LINES.ionic_hydro = ionLine("IONIC Hydro — soft / RO water",
      "The hydro chart for soft or RO water. On hard tap water use the Hard Water line instead, which is a different bottle and a different chart.",
      ION_HYDRO, ["rockwool"], true);
    LINES.ionic_hw = ionLine("IONIC Hydro — hard water",
      "Built for British hard water: it neutralises the bicarbonates that push pH up. No Tonic on this chart, and it finishes on plain water.",
      ION_HW, ["rockwool"], false);

    /* ==================================================================
       PLANT MAGIC, added 27 Sep 2026 from the four Essential PDFs (Old
       Timer, Coco, Hydro, Soil — plantmagic.co.uk, © 2023 Global Air
       Supplies Ltd). See the CATALOG comment above for the product-mapping
       rationale: Coco and Hydro onto the AB family, Soil onto Soil Grow +
       Soil Bloom, the Soil Bloom and Boost unarchives, and why Evolution
       2.0 is not modelled.

       All four charts are ml per litre, three grow weeks then nine bloom
       weeks, printed for both hard and soft British water on one EC row —
       no water-type toggle needed. Week 9 of bloom is a flush on all four,
       but they print it differently: Old Timer's own chart says "FLUSH
       WITH WATER ONLY" with no EC at all, so that one is stored as ec 0;
       Coco, Hydro and Soil still print an EC of 0.6 for the same week even
       though nothing is dosed, so that is what is stored for those three.

       Written out longhand rather than generated, because these are
       transcriptions and a generator hides a mistake behind a clever line. */
    function pmWeeks(gKey, bKey, pkKey, veg, flower) {
      function row(r) {
        var d = {};
        if (r.g) d[gKey] = r.g;
        if (r.b) d[bKey] = r.b;
        if (r.root) d.pm_root = r.root;
        if (r.magcal) d.pm_magcal = r.magcal;
        if (r.boost) d.pm_boost = r.boost;
        if (r.pk) d[pkKey] = r.pk;
        return { ec: r.ec, d: d };
      }
      return { veg: veg.map(row), flower: flower.map(row), repeat: { flower: 7 } };
    }

    var PM_OLDTIMER = pmWeeks("pm_ot_grow", "pm_ot_bloom", "pm_ot_pk", [
      { ec: 0.8 },
      { g: 2, ec: 1.0 },
      { g: 3, ec: 1.2 }
    ], [
      { g: 3, ec: 1.4 },
      { g: 4, ec: 1.4 },
      { b: 3, ec: 1.6 },
      { b: 4, pk: 1, ec: 1.6 },
      { b: 4, pk: 1.5, ec: 1.8 },
      { b: 4, pk: 2, ec: 2 },
      { b: 4, pk: 2, ec: 1.8 },
      { b: 3, pk: 2, ec: 0.6 },
      { ec: 0 }
    ]);

    var PM_COCO = pmWeeks("pm_coco_ab", "pm_coco_ab", "pm_pk1314", [
      { root: 2.5, ec: 0.8 },
      { g: 2, root: 2.5, ec: 1.0 },
      { g: 2, root: 2.5, ec: 1.2 }
    ], [
      { b: 3, root: 2.5, magcal: 0.5, boost: 2, ec: 1.4 },
      { b: 3, root: 2.5, magcal: 0.5, boost: 2, ec: 1.4 },
      { b: 4, magcal: 0.5, boost: 2, ec: 1.6 },
      { b: 4, magcal: 1, boost: 2, pk: 1, ec: 1.6 },
      { b: 4, magcal: 1, boost: 2, pk: 1.5, ec: 1.8 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 2 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 2.2 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 1.8 },
      { ec: 0.6 }
    ]);

    var PM_HYDRO = pmWeeks("pm_hydro_ab", "pm_hydro_ab", "pm_pk1314", [
      { root: 2.5, ec: 0.8 },
      { g: 2, root: 2.5, ec: 1.0 },
      { g: 3, root: 2.5, ec: 1.2 }
    ], [
      { b: 3, root: 2.5, magcal: 0.5, boost: 2, ec: 1.4 },
      { b: 3, root: 2.5, magcal: 0.5, boost: 2, ec: 1.4 },
      { b: 4, magcal: 0.5, boost: 2, ec: 1.6 },
      { b: 4, magcal: 1, boost: 2, pk: 1.5, ec: 1.6 },
      { b: 4, magcal: 1, boost: 2, pk: 1.5, ec: 1.8 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 2 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 2.2 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 1.8 },
      { ec: 0.6 }
    ]);

    var PM_SOIL = pmWeeks("pm_soil_grow", "pm_soil_bloom", "pm_pk1314", [
      { root: 2.5, ec: 0.8 },
      { g: 2, root: 2.5, ec: 1.0 },
      { g: 2, root: 2.5, ec: 1.2 }
    ], [
      { g: 3, root: 2.5, magcal: 0.5, boost: 2, ec: 1.4 },
      { b: 3, root: 2.5, magcal: 0.5, boost: 2, ec: 1.4 },
      { b: 4, magcal: 0.5, boost: 2, ec: 1.6 },
      { b: 4, magcal: 1, boost: 2, pk: 1.5, ec: 1.6 },
      { b: 4, magcal: 1, boost: 2, pk: 1.5, ec: 1.8 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 2 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 2.2 },
      { b: 4, magcal: 1, boost: 2, pk: 2, ec: 1.8 },
      { ec: 0.6 }
    ]);

    var PM_OT_EXTRAS = [{
      k: "pmotpk", key: "pm_ot_pk", label: "Old Timer PK 4/8", on: true, chart: true,
      note: "From bloom week 4 to week 8, ramping 1 → 2 ml/L"
    }];
    var PM_EXTRAS_STD = [{
      k: "pmroot", key: "pm_root", label: "Root Stimulant", on: true, chart: true,
      note: "2.5 ml/L through grow and the first two weeks of bloom"
    }, {
      k: "pmmagcal", key: "pm_magcal", label: "MAGNE Cal+", on: true, chart: true,
      note: "0.5 ml/L for the first three weeks of bloom, then 1 ml/L to the end"
    }, {
      k: "pmboost", key: "pm_boost", label: "Boost", on: true, chart: true,
      note: "2 ml/L every week of bloom except the flush. The big-ticket line — untick to see the difference"
    }, {
      k: "pmpk", key: "pm_pk1314", label: "PK 13/14", on: true, chart: true,
      note: "From bloom week 4 to week 8"
    }];
    var PM_EVO_NOTE = " Evolution 2.0 is on the printed chart too, but only as \"spray 1–2 times a week, as needed\" with no tank rate, so there is nothing to cost and it is left off here.";

    LINES.plant_magic_oldtimer = {
      label: "Plant Magic Old Timer (organic)",
      brand: "PLANT MAGIC",
      kind: "weekly",
      perLitre: true,
      weeks: PM_OLDTIMER,
      base: {
        veg: "pm_ot_grow",
        flower: "pm_ot_bloom"
      },
      blurb: "Plant Magic's organic range: Old Timer Organic Grow into Organic Bloom, finished on Old Timer PK 4/8.",
      media: ["soil"],
      extras: PM_OT_EXTRAS,
      chartNote: "Week 9 is printed as a flush with water only — no feed, and no EC printed for it either, unlike the other three Plant Magic charts."
    };
    LINES.plant_magic_coco = {
      label: "Plant Magic Coco",
      brand: "PLANT MAGIC",
      kind: "weekly",
      perLitre: true,
      weeks: PM_COCO,
      blurb: "One Coco A&B the whole way, with Root Stimulant, MAGNE Cal+, Boost and PK 13/14.",
      media: ["coco"],
      extras: PM_EXTRAS_STD,
      chartNote: "Week 9 of bloom is a flush — no feed, though the chart still prints an EC of 0.6 for it." + PM_EVO_NOTE
    };
    LINES.plant_magic_hydro = {
      label: "Plant Magic Hydro",
      brand: "PLANT MAGIC",
      kind: "weekly",
      perLitre: true,
      weeks: PM_HYDRO,
      blurb: "One Hydro A&B the whole way, for inert media and recirculating systems.",
      media: ["rockwool"],
      extras: PM_EXTRAS_STD,
      chartNote: "Week 9 of bloom is a flush — no feed, though the chart still prints an EC of 0.6 for it." + PM_EVO_NOTE
    };
    LINES.plant_magic_soil = {
      label: "Plant Magic Soil",
      brand: "PLANT MAGIC",
      kind: "weekly",
      perLitre: true,
      weeks: PM_SOIL,
      base: {
        veg: "pm_soil_grow",
        flower: "pm_soil_bloom"
      },
      blurb: "Soil Grow through veg and the first bloom week, then Soil Bloom for the rest.",
      media: ["soil"],
      extras: PM_EXTRAS_STD,
      chartNote: "Week 9 of bloom is a flush — no feed, though the chart still prints an EC of 0.6 for it." + PM_EVO_NOTE
    };

    /* EVERY BRAND MUST BE DEFINED ABOVE THIS LINE. What follows is the
       decoration pass: the organic flags, the silicate detection, Grow Genius,
       and the ADDONS loop that gives every line its silicon and pest-prevention
       options. A line added below here silently misses all of it, and the
       symptom is an empty "Silicon & pest prevention" step on the live page with
       nothing in the console. IONIC was added below it on 26 Sep 2026 and did
       exactly that. verify.js now asserts it, so the tests catch it rather than
       a customer. */
    Object.keys(LINES).forEach(function(k) {
      if (LINES[k].brand === "SHOGUN") LINES[k].ph = "5.5 – 6.5"
    });
    var ORGANIC_LINES = {
      biobizz_allmix: 1,
      biobizz_light: 1,
      bac_organic: 1,
      crazyhills: 1,
      plant_magic_oldtimer: 1
    };

    function formOf(lineKey, basket) {
      for (var i = 0; i < (basket || []).length; i++) {
        var p = CATALOG[basket[i].key];
        if (p && isBase(lineKey, basket[i].key) && p.unit === "g") return "powder"
      }
      return "liquid"
    }
    var SILICATES = ["sho_si", "bac_silica", "dp_silica", "mky_stress", "an_rhino"];

    function lineSilicate(L) {
      var hit = null;
      SILICATES.forEach(function(sk) {
        if (L.extras.some(function(e) {
            return e.key === sk
          })) hit = sk;
        if (!hit && L.weeks) {
          [].concat(L.weeks.veg || [], L.weeks.flower || []).forEach(function(w) {
            if (w.d[sk] !== undefined) hit = sk
          })
        }
      });
      return hit
    }
    Object.keys(LINES).forEach(function(k) {
      LINES[k].silicate = lineSilicate(LINES[k])
    });
    Object.keys(LINES).forEach(function(k) {
      if (LINES[k].extras.some(function(e) {
          return e.k === "gg"
        })) return;
      var hit = LINES[k].silicate;
      LINES[k].extras = LINES[k].extras.concat([{
        k: "gg",
        key: "gg_msa",
        label: "Grow Genius Mono Silicic Acid",
        on: false,
        chart: false,
        displaces: hit,
        note: hit ? "0.3 ml per 10 L, 40% mono-silicic acid — the plant takes it up as it is, where a " + "silicate has to convert first. Ticking this replaces " + CATALOG[hit].title + " so you are not buying silicon twice." : "0.3 ml per 10 L, 40% mono-silicic acid — goes with any feed. A little goes a very long way"
      }])
    });
    var ADDONS = [{
      group: "silicon",
      k: "sican",
      key: "si_canna",
      label: "CANNA Silica",
      tank: {
        mlPerL: 1.5,
        veg: true,
        flower: "all"
      },
      note: "1–2 ml/L, whole cycle. Lifts your base EC by 0.25–0.5 on its own, so read the meter after it goes in."
    }, {
      group: "silicon",
      k: "simills",
      key: "si_mills",
      label: "Mills Vitalize",
      tank: {
        mlPerL: .2,
        veg: true,
        flower: "all",
        taper: {
          weeks: 2,
          mlPerL: .1
        }
      },
      note: "Stabilised silicic acid. 0.2 ml/L, dropping to 0.1 for the last two weeks. No residue, so it doubles as a foliar."
    }, {
      group: "silicon",
      k: "sistress",
      key: "mky_stress",
      label: "Monkey Stress",
      tank: {
        mlPerL: .2,
        veg: true,
        flower: "all"
      },
      note: "Mono-silicic acid, 2 ml per 10 L, veg to harvest. A bottle goes a long way."
    }, {
      group: "silicon",
      k: "sigren",
      key: "si_grenade",
      label: "Grenade White MSA Max",
      tank: {
        mlPerL: .3,
        veg: true,
        flower: "all"
      },
      note: "0.2–0.4 ml/L, propagation to harvest. Stabilised MSA — usable the moment it hits the tank."
    }, {
      group: "silicon",
      k: "siamino",
      key: "hg_amino",
      label: "H&G Amino Treatment",
      tank: {
        mlPerL: .3,
        veg: true,
        flower: [1, 2]
      },
      note: "Not a silicon — an amino feed doing the same job from the other end. 0.3 ml/L, veg to flower week 2."
    }, {
      group: "ipm",
      k: "ipmath",
      key: "ipm_athena",
      label: "Athena IPW",
      spray: {
        mlPerL: 24,
        perWeek: 2,
        veg: true,
        flower: [1, 2, 3]
      },
      note: "24 ml/L, twice a week, veg to flower week 3. Lights off, both sides of the leaf. Mechanical, so nothing builds resistance to it. Athena also print a 32 ml/L three-times-a-week rate for a heavy infestation."
    }, {
      group: "ipm",
      k: "ipmevios",
      key: "ipm_evios",
      label: "Optic Foliar Evios + Transport",
      spray: {
        mlPerL: 10,
        perWeek: 1,
        veg: true,
        flower: "all"
      },
      note: "10 ml of each per litre, once a week. Do NOT pH it. No residue, leaf tops only — the one option safe in late flower."
    }, {
      group: "ipm",
      k: "ipmcure",
      key: "ipm_cure",
      label: "CANNA Cure Concentrate",
      spray: {
        mlPerL: 330,
        perWeek: 1,
        veg: true,
        flower: "all"
      },
      note: "330 ml per litre — CANNA’s own figure, far stronger than most, so budget for it. Once a week, growth to harvest. Water only, never H2O2."
    }];
    var ADDON_GROUPS = [{
      id: "silicon",
      label: "Silicon",
      single: true,
      hint: "Thicker cell walls: stronger stems, better stress and pest resistance. Five routes to the same job, so pick one — and it replaces any silicon your feed already carries."
    }, {
      id: "ipm",
      label: "Pest prevention",
      single: true,
      hint: "Pick one. These go on the leaf, so the amount comes from your canopy, not your tank."
    }];
    Object.keys(LINES).forEach(function(lk) {
      LINES[lk].extras.forEach(function(e) {
        if (e.k === "gg") e.group = "silicon"
      })
    });
    ADDONS.forEach(function(a) {
      Object.keys(LINES).forEach(function(lk) {
        var L = LINES[lk];
        if (L.extras.some(function(e) {
            return e.key === a.key
          })) return;
        var swap = a.group === "silicon" && a.key !== "hg_amino" ? L.silicate : null;
        L.extras = L.extras.concat([{
          k: a.k,
          key: a.key,
          label: a.label,
          note: a.note + (swap ? " Replaces " + CATALOG[swap].title + " on this feed." : ""),
          on: false,
          chart: false,
          group: a.group,
          displaces: swap,
          tank: a.tank,
          spray: a.spray
        }])
      })
    });
    LINES.hg_aqua.extras.concat(LINES.hg_cocos.extras, LINES.hg_hydro.extras, LINES.hg_soil.extras).forEach(function(e) {
      if (e.key === "hg_magic") e.spray = {
        mlPerL: 15 / GAL,
        perWeek: 1,
        veg: [2],
        flower: [2]
      }
    });

    function addonRate(spec, phase, idx, nFl, type) {
      var base = spec.byMedia && spec.byMedia[type] !== undefined ? spec.byMedia[type] : spec.mlPerL;
      if (phase === "veg") {
        if (spec.veg === true) return base;
        if (Array.isArray(spec.veg)) return spec.veg.indexOf(idx + 1) >= 0 ? base : 0;
        return 0
      }
      var f = spec.flower;
      if (!f) return 0;
      if (f === "all") {
        if (spec.taper && idx >= nFl - spec.taper.weeks) return spec.taper.mlPerL;
        return base
      }
      for (var i = 0; i < f.length; i++) {
        var at = f[i] > 0 ? f[i] - 1 : nFl + f[i];
        if (at === idx) return base
      }
      return 0
    }

    function addonSprayCount(spec, nVeg, nFl) {
      var per = spec.perWeek || 1,
        n = 0,
        i;
      if (spec.veg === true) n += nVeg * per;
      else if (Array.isArray(spec.veg)) spec.veg.forEach(function(w) {
        if (w <= nVeg) n += per
      });
      if (spec.flower === "all") n += nFl * per;
      else if (Array.isArray(spec.flower)) spec.flower.forEach(function(w) {
        var at = w > 0 ? w - 1 : nFl + w;
        if (at >= 0 && at < nFl) n += per
      });
      return Math.ceil(n - 1e-9)
    }
    var FADE_PRO_ML_PER_L = 5.1;
    var FLAT_RATE = {
      ath_fade: 3.4,
      can_calmag: 1,
      can_flush: 5,
      ath_pbal: .15,
      sho_si: .5,
      sho_calmag: .5,
      sho_dragon: 1,
      gg_msa: .03,
      bac_calmag: 1,
      hth_cal: 1.4
    };
    var FADE_WEEKS = 2;
    var PRO_CONCENTRATE_G_PER_L = 226;

    function brandsFor(type) {
      var out = [],
        seen = {};
      linesFor(type).forEach(function(k) {
        var b = LINES[k].brand;
        if (!seen[b]) {
          seen[b] = {
            brand: b,
            lines: []
          };
          out.push(seen[b])
        }
        seen[b].lines.push(k)
      });
      return out
    }

    function linesFor(type) {
      return Object.keys(LINES).filter(function(k) {
        return LINES[k].media.indexOf(type) >= 0
      })
    }
    var STRENGTHS = {
      light: {
        label: "Light",
        mult: .85,
        sub: "15% below the chart EC",
        subNoEc: "15% below the chart rate"
      },
      chart: {
        label: "Chart",
        mult: 1,
        sub: "The chart’s own target EC",
        subNoEc: "The chart’s own rates"
      },
      heavy: {
        label: "Heavy",
        mult: 1.15,
        sub: "15% above the chart EC",
        subNoEc: "15% above the chart rate"
      },
      xheavy: {
        label: "Extra Heavy",
        mult: 1.3,
        sub: "30% above the chart EC",
        subNoEc: "30% above the chart rate"
      }
    };
    var STAGE_SHOTS = {
      veg: .55,
      early: .8,
      peak: 1,
      late: .85
    };

    function hydrate(live) {
      var report = {
        matched: 0,
        missing: [],
        unavailable: []
      };
      if (!live || typeof live !== "object") return report;
      var bySku = {};
      Object.keys(live).forEach(function(h) {
        (live[h].variants || []).forEach(function(v) {
          if (v.sku) bySku[String(v.sku)] = {
            v: v,
            handle: h,
            product: live[h]
          }
        })
      });
      Object.keys(CATALOG).forEach(function(key) {
        var prod = CATALOG[key],
          any = false;
        prod.tiers.forEach(function(t) {
          var hit = bySku[String(t.sku)];
          if (!hit) {
            t.available = false;
            t.missing = true;
            report.missing.push(prod.handle + " / " + t.sku);
            return
          }
          t.missing = false;
          t.variantId = hit.v.id;
          if (typeof hit.v.price === "number") t.price = hit.v.price;
          t.available = hit.v.available !== false;
          if (!t.available) report.unavailable.push(prod.title + " — " + t.t);
          else {
            any = true;
            report.matched++
          }
        });
        prod.url = live[prod.handle] && live[prod.handle].url || "/products/" + prod.handle;
        prod.img = live[prod.handle] && live[prod.handle].img || null;
        prod.available = any
      });
      return report
    }

    function requiredHandles() {
      return Object.keys(CATALOG).map(function(k) {
        return CATALOG[k].handle
      }).filter(function(h, i, a) {
        return a.indexOf(h) === i
      })
    }

    function packFor(prod, need, ignoreStock) {
      if (!(need > 0) || !isFinite(need)) return {
        lines: [],
        total: 0,
        cost: 0
      };
      var tiers = prod.tiers.filter(function(t) {
        return ignoreStock || t.available !== false
      }).sort(function(a, b) {
        return a.size - b.size
      });
      if (!tiers.length) return {
        lines: [],
        total: 0,
        cost: 0
      };
      var U = 1e3;
      var target = Math.ceil(need * U - 1e-6);
      var sizes = tiers.map(function(t) {
        return Math.max(1, Math.floor(t.size * U))
      });
      var step = sizes.reduce(function(a, b) {
        while (b) {
          var t = a % b;
          a = b;
          b = t
        }
        return a
      }, target);
      if (step > 1) {
        target = Math.ceil(target / step);
        sizes = sizes.map(function(v) {
          return v / step
        })
      }
      for (var guard = 0; target > 4e5 && guard < 40; guard++) {
        U /= 10;
        target = Math.ceil(target / 10);
        sizes = sizes.map(function(v) {
          return Math.max(1, Math.floor(v / 10))
        })
      }
      if (!isFinite(target) || target > 4e5) return {
        lines: [],
        total: 0,
        cost: 0
      };
      var cost = new Float64Array(target + 1);
      var tot = new Float64Array(target + 1);
      var pick = new Int32Array(target + 1);
      for (var v = 1; v <= target; v++) {
        cost[v] = Infinity;
        pick[v] = -1
      }
      for (v = 1; v <= target; v++) {
        for (var i = 0; i < sizes.length; i++) {
          var prev = v - sizes[i];
          if (prev < 0) prev = 0;
          if (cost[prev] === Infinity) continue;
          var c = cost[prev] + tiers[i].price;
          var tt = tot[prev] + sizes[i];
          if (c < cost[v] - 1e-9 || Math.abs(c - cost[v]) < 1e-9 && tt < tot[v]) {
            cost[v] = c;
            tot[v] = tt;
            pick[v] = i
          }
        }
      }
      if (pick[target] < 0) return {
        lines: [],
        total: 0,
        cost: 0
      };
      var counts = new Array(tiers.length).fill(0);
      for (v = target; v > 0;) {
        var k = pick[v];
        if (k < 0) break;
        counts[k]++;
        v -= sizes[k];
        if (v < 0) v = 0
      }
      var out = [],
        total = 0,
        spend = 0;
      for (i = 0; i < tiers.length; i++)
        if (counts[i]) {
          out.push({
            tier: tiers[i],
            qty: counts[i]
          });
          total += counts[i] * tiers[i].size;
          spend += counts[i] * tiers[i].price
        } return {
        lines: out,
        total: total,
        cost: spend
      }
    }
    var BASE_ALWAYS = {
      vbx_craft: 1,
      vbx_clean: 1
    };

    function isBase(lineKey, productKey) {
      if (BASE_ALWAYS[productKey]) return true;
      var ex = (LINES[lineKey] || {}).extras || [];
      for (var i = 0; i < ex.length; i++)
        if (ex[i].key === productKey) return false;
      return true
    }
    Object.keys(LINES).forEach(function(k) {
      LINES[k].organic = !!ORGANIC_LINES[k]
    });

    function dedupe(list) {
      var seen = {},
        out = [];
      list.forEach(function(w) {
        if (!seen[w.text]) {
          seen[w.text] = 1;
          out.push(w)
        }
      });
      return out
    }
    var LIMITS = {
      plants: {
        min: 1,
        max: 2e3
      },
      tank: {
        min: 1,
        max: 2e4
      },
      vegWeeks: {
        min: 0,
        max: 16
      },
      flowerWeeks: {
        min: 1,
        max: 24
      },
      litresPerDay: {
        min: 0,
        max: 200
      },
      potLitres: {
        min: .5,
        max: 500
      },
      runs: {
        min: 1,
        max: 5
      },
      resWeeks: {
        min: 0,
        max: 12
      }
    };
    var IRRIGATION = {
      waste: {
        label: "Run to waste",
        sub: "Drip or hand fed. What runs out of the pot goes down the drain."
      },
      recirc: {
        label: "Recirculating",
        sub: "RDWC, NFT, flood and drain. It goes back to the tank and gets changed now and then."
      },
      gravity: {
        label: "Gravity fed",
        sub: "AutoPot or capillary. No runoff at all, they drink what you mix."
      }
    };

    function clamp(v, dflt, lim) {
      var n = +v;
      if (!isFinite(n)) return dflt;
      n = Math.floor(n);
      return n < lim.min ? lim.min : n > lim.max ? lim.max : n
    }

    function clampNum(v, dflt, lim) {
      var n = +v;
      if (!isFinite(n)) return dflt;
      return n < lim.min ? lim.min : n > lim.max ? lim.max : n
    }

    function compute(inp) {
      var type = MEDIA_TYPES[inp.mediaType] ? inp.mediaType : "coco";
      var mt = MEDIA_TYPES[type];
      var size = sizeOf(type, inp.size, inp.potLitres);
      var valid = linesFor(type);
      var lineK = valid.indexOf(inp.line) >= 0 ? inp.line : valid[0];
      var line = LINES[lineK];
      var plants = clamp(inp.plants, 9, LIMITS.plants);
      var tank = clamp(inp.tank, 100, LIMITS.tank);
      var nVeg = clamp(inp.vegWeeks, 4, LIMITS.vegWeeks);
      var nFl = clamp(inp.flowerWeeks, 9, LIMITS.flowerWeeks);
      var irrig = IRRIGATION[inp.irrigation] ? inp.irrigation : "waste";
      var resWks = clamp(inp.resWeeks, 0, LIMITS.resWeeks);
      var stren = +inp.strength || 1;

      function amt(k, v) {
        return isBase(lineK, k) ? v * stren : v
      }
      var on = inp.extras || {};
      var water = inp.water === "soft" ? "soft" : "hard";
      var style = STYLES[inp.style] ? inp.style : "standard";
      var peakAuto = size.litres * mt.daily * STYLES[style].mult;
      var lpd = +inp.litresPerDay;
      var override = isFinite(lpd) && lpd > 0 ? Math.min(lpd, LIMITS.litresPerDay.max) : null;
      var peakBase = override || peakAuto;

      function declares(key) {
        for (var i = 0; i < line.extras.length; i++)
          if (line.extras[i].key === key) return true;
        return false
      }

      function offers(key) {
        return declares(key) && active(key)
      }

      function active(key) {
        for (var i = 0; i < line.extras.length; i++) {
          var e = line.extras[i];
          if (e.key === key) return on[e.k] === undefined ? e.on : !!on[e.k]
        }
        return true
      }
      var weeks = [],
        need = {},
        totalWater = 0,
        peakDaily = 0,
        usesFade = false,
        dumped = 0;
      var table = line.weeksSoft && water === "soft" ? line.weeksSoft : line.weeksAlt && line.altKey && active(line.altKey) ? line.weeksAlt : line.weeks;
      var rep = table && table.repeat || {};
      var swaps = {};
      line.extras.forEach(function(e) {
        if (e.displaces && offers(e.key)) swaps[e.displaces] = e.label
      });
      var vegMap = table ? mapWeeks(table.veg, Math.max(nVeg, 1), rep.veg) : [];
      var flowerMap = table ? mapWeeks(table.flower, nFl, rep.flower) : [];
      var total = nVeg + nFl;
      for (var w = 0; w < total; w++) {
        var isVeg = w < nVeg,
          idx = isVeg ? w : w - nVeg;
        var stage = isVeg ? "veg" : idx <= 1 ? "early" : idx >= nFl - 2 ? "late" : "peak";
        var dailyL = peakBase * STAGE_SHOTS[stage] * plants,
          weekL = dailyL * 7;
        if (irrig === "recirc" && resWks > 0 && w > 0 && w % resWks === 0) {
          weekL += tank;
          dumped += tank
        }
        totalWater += weekL;
        if (dailyL > peakDaily) peakDaily = dailyL;
        var dose = {},
          ec = 0,
          label;
        if (line.kind === "athena" || line.kind === "athena_pro") {
          label = (isVeg ? "Veg W" : "Fl W") + (idx + 1);
          if (line.kind === "athena") {
            var fadeTail = active("ath_fade") && !isVeg && idx >= nFl - FADE_WEEKS;
            var src = isVeg ? ATH_VEG[Math.min(idx, ATH_VEG.length - 1)] : fadeTail ? ATH_FLOWER_FADE[Math.min(idx - (nFl - FADE_WEEKS), ATH_FLOWER_FADE.length - 1)] : ATH_FLOWER[Math.min(idx, ATH_FLOWER.length - 1)];
            ec = src.ec * stren;
            Object.keys(src.d).forEach(function(k) {
              if (!active(k)) return;
              dose[k] = amt(k, src.d[k] / 10)
            })
          } else {
            ec = PRO_EC * stren;
            var pd = proDose(ec);
            dose.ath_core = pd.core;
            dose[isVeg ? "ath_pgrow" : "ath_pbloom"] = pd.gb;
            if (active("ath_cleanse")) dose.ath_cleanse = .5
          }
          if (active("ath_pbal") && line.kind === "athena_pro") dose.ath_pbal = FLAT_RATE.ath_pbal;
          if (active("ath_fade") && !isVeg && idx >= nFl - FADE_WEEKS) {
            usesFade = true;
            if (line.kind === "athena_pro") {
              dose.ath_fade = FADE_PRO_ML_PER_L;
              delete dose.ath_core
            }
          }
        } else if (line.kind === "weekly") {
          var mapped = isVeg ? vegMap : flowerMap;
          var src = mapped[idx] || mapped[mapped.length - 1];
          ec = src.ec * stren;
          label = (isVeg ? "Veg W" : "Fl W") + (idx + 1);
          Object.keys(src.d).forEach(function(k) {
            var real = VBX_KEYS[k] ? VBX_KEYS[k][on.clean ? "clean" : "craft"] : k;
            var v = VBX_KEYS[k] || line.perLitre ? src.d[k] : src.d[k] / 10;
            real = resolveKey(real, water);
            if (!active(real)) return;
            if (k === "vbx_sh" && !offers("vbx_shine")) return;
            dose[real] = amt(real, v)
          });
          if (offers("mky_magcal") && type === "coco") dose.mky_magcal = 1;
          if (offers("mky_zyme")) dose.mky_zyme = 2;
          if (offers("dp_amino")) dose.dp_amino = .4;
          if (offers("dp_calmag")) dose.dp_calmag = .5;
          if (offers("dp_clean")) dose.dp_clean = .1;
          if (offers("bac_calmag")) dose.bac_calmag = FLAT_RATE.bac_calmag;
          if (line.brand === "House & Garden" && !offers("hg_shoot")) delete dose.hg_shoot
        } else if (line.kind === "shogun") {
          label = (isVeg ? "Veg W" : "Fl W") + (idx + 1);
          if (line.weeks) {
            var ss = (isVeg ? vegMap : flowerMap)[idx];
            ec = ss.ec * stren;
            Object.keys(ss.d).forEach(function(k) {
              if (!active(k)) return;
              dose[resolveKey(k, water)] = amt(resolveKey(k, water), ss.d[k])
            })
          } else {
            ec = 0;
            var sd = shogunDose(isVeg, idx, nVeg, nFl, line.base, line.envelope);
            Object.keys(sd).forEach(function(k) {
              if (!active(k)) return;
              dose[resolveKey(k, water)] = amt(resolveKey(k, water), sd[k])
            });
            if (offers("sho_si") && !(!isVeg && idx === nFl - 1)) dose.sho_si = SHOGUN_ADD.si;
            if (active("sho_dragon") && !isVeg && idx === nFl - 1) {
              dose.sho_dragon = SHOGUN_ADD.dragon
            }
          }
          if (offers("sho_calmag") && !(!isVeg && idx === nFl - 1)) {
            dose.sho_calmag = FLAT_RATE.sho_calmag
          }
        } else {
          var ph = cannaPhase(isVeg, idx, nVeg, nFl);
          var c = CANNA[line.chart][ph];
          ec = c.ec * stren;
          label = (isVeg ? "Veg W" : "Fl W") + (idx + 1);
          Object.keys(c.d).forEach(function(k) {
            if (!active(k)) return;
            dose[resolveKey(k, water)] = amt(resolveKey(k, water), c.d[k] / 10)
          });
          if (offers("can_calmag")) dose.can_calmag = FLAT_RATE.can_calmag;
          if (active("can_flush") && ph === "gen4") dose.can_flush = FLAT_RATE.can_flush
        }
        if (offers("gg_msa")) dose.gg_msa = FLAT_RATE.gg_msa;
        Object.keys(swaps).forEach(function(k) {
          delete dose[k]
        });
        Object.keys(dose).forEach(function(k) {
          need[k] = (need[k] || 0) + dose[k] * weekL
        });
        weeks.push({
          label: label,
          stage: stage,
          phase: isVeg ? "veg" : "flower",
          idx: idx,
          ec: +ec.toFixed(2),
          dailyL: dailyL,
          weekL: weekL,
          dose: dose,
          perTank: Object.keys(dose).reduce(function(o, k) {
            o[k] = dose[k] * tank;
            return o
          }, {}),
          conc: Object.keys(dose).reduce(function(o, k) {
            if (CATALOG[k] && CATALOG[k].unit === "g") o[k] = dose[k] / (line.stockGPerL || PRO_CONCENTRATE_G_PER_L) * 1e3;
            return o
          }, {})
        })
      }
      /* There was a block here that forced PK and Resin apart on a line keyed
         "monkey". No such line exists: Monkey is monkey_pk and monkey_resin, and
         has been since the two charts were split. So it never ran once, and the
         per-line extras defaults have been doing the job instead — pk on and
         resin off on one line, the reverse on the other. Removed rather than
         repaired, because a customer who deliberately ticks the other finisher
         should get what the checkbox says they will get, plus a warning. The
         warning is further down. */
      var addonSprays = [];
      line.extras.forEach(function(e) {
        if (!offers(e.key)) return;
        if (e.tank) {
          weeks.forEach(function(w) {
            var v = addonRate(e.tank, w.phase, w.idx, nFl, type);
            if (!v) return;
            w.dose[e.key] = v;
            w.perTank[e.key] = v * tank;
            need[e.key] = (need[e.key] || 0) + v * w.weekL
          })
        }
        if (e.spray) {
          var n = addonSprayCount(e.spray, nVeg, nFl);
          if (!n) return;
          var litres = canopyFor(size) * plants * SPRAY_L_PER_M2 * n;
          need[e.key] = (need[e.key] || 0) + litres * e.spray.mlPerL;
          addonSprays.push({
            key: e.key,
            title: CATALOG[e.key].title,
            sprays: n,
            litres: litres,
            mlPerL: e.spray.mlPerL
          })
        }
      });
      var foliar = null;
      if (offers("ff_folveg") || offers("ff_folbloom")) {
        var canopy = canopyFor(size) * plants;
        foliar = {
          canopy: canopy,
          perM2: SPRAY_L_PER_M2,
          gPerGal: FOLIAR_G_PER_GAL,
          vegSprays: 0,
          bloomSprays: 0,
          vegL: 0,
          bloomL: 0
        };
        if (offers("ff_folveg") && nVeg > 0) {
          foliar.vegSprays = nVeg;
          var fv = foliarNeed(canopy, nVeg);
          foliar.vegL = fv.litres;
          need.ff_folveg = (need.ff_folveg || 0) + fv.grams
        }
        if (offers("ff_folbloom") && nFl > 0) {
          foliar.bloomSprays = Math.min(nFl, BLOOM_FOLIAR_WEEKS);
          var fb = foliarNeed(canopy, foliar.bloomSprays);
          foliar.bloomL = fb.litres;
          need.ff_folbloom = (need.ff_folbloom || 0) + fb.grams
        }
      }
      var runs = clamp(inp.runs, 1, LIMITS.runs);
      if (runs > 1) Object.keys(need).forEach(function(k) {
        need[k] *= runs
      });
      var basket = [],
        grand = 0,
        warn = [];
      Object.keys(need).forEach(function(k) {
        var prod = CATALOG[k];
        if (!prod) return;
        var qty = need[k] / 1e3;
        var pack = packFor(prod, qty);
        if (!pack.lines.length) {
          if (qty > 0 && prod.tiers.length && prod.tiers.every(function(t) {
              return t.available === false
            })) {
            var gone = prod.tiers.every(function(t) {
              return t.missing
            });
            warn.push({
              level: "bad",
              text: gone ? prod.title + " is not reachable from this page yet, so nothing has been added for it. " + "It needs adding to the Feed Calculator Parts collection — please let us know." : prod.title + " is ticked, but every size is out of stock, " + "so nothing has been added for it. Untick it or come back when it is in."
            })
          }
          return
        }
        grand += pack.cost;
        var bits = [];
        var amt = prod.unit === "g" ? qty * 1e3 < 100 ? (qty * 1e3).toFixed(1) + " g" : Math.round(qty * 1e3) + " g" : qty < 1 ? Math.round(qty * 1e3) + " ml" : qty.toFixed(2) + " L";
        var ideal = packFor(prod, qty, true);
        if (ideal.cost > 0 && ideal.cost < pack.cost - 1e-9) {
          var gone = prod.tiers.filter(function(t) {
            return t.available === false
          }).map(function(t) {
            return t.t
          });
          bits.push("The " + (gone.length ? gone.join(" and ") : "smaller size") + " is out of stock, so this is the smallest we can ship")
        }
        var cyc = qty > 0 ? pack.total * runs / qty : 0;
        if (cyc >= 5) {
          bits.push("Only " + amt + " needed — this pack is about " + Math.round(cyc) + " cycles’ worth")
        }
        var why = bits.length ? bits.join(". ") : null;
        /* THE TWO RATES. A run total on its own mixes up two different things:
           how dear the product is, and how well the pack sizes happen to fit
           this grow. A brand whose smallest bottle is 5 L when you need 2.15 L
           is being charged for 2.85 L it will never open, and on the total that
           reads as an expensive feed rather than an awkward one.

             rateBought  what a litre costs in the sizes actually bought
             usedValue   what the part you will actually pour is worth
             unusedCost  what stays in the bottle at the end

           usedValue + unusedCost is always exactly the price paid, which is what
           makes the pair readable. There WAS a third figure here, cost per litre
           of the portion used, and it was dropped on 27 Sep 2026 after Steve saw
           it on the live page: FloraFlex Bloom Foliar came out at £5,678/kg on a
           £9 bag, because the run uses 1.6 g of a 454 g bag. Arithmetically
           correct, useless to a customer, and alarming. A number nobody can act
           on is worse than no number.

           The packaging penalty runs from about 5% on CANNA Coco to over 40% on
           some lines. Measured 27 Sep 2026.

           Units follow the product: ml products are held in litres, so the rate
           is per litre; g products are held in kilos, so it is per kilo. On an
           A+B the tier is a pair, so a litre means a litre of each part. */
        var rateBought = pack.total > 0 ? pack.cost / pack.total : 0;
        basket.push({
          key: k,
          title: prod.title,
          handle: prod.handle,
          url: prod.url || "/products/" + prod.handle,
          unit: prod.unit,
          ab: !!prod.ab,
          need: qty,
          lines: pack.lines,
          covers: pack.total,
          cost: pack.cost,
          rateBought: rateBought,
          rateUnit: prod.unit === "g" ? "kg" : "L",
          usedValue: qty * rateBought,
          usedPc: pack.total > 0 ? qty / pack.total * 100 : 0,
          unused: Math.max(0, pack.total - qty),
          unusedCost: Math.max(0, pack.cost - qty * rateBought),
          why: why
        })
      });
      var short = Object.keys(need).filter(function(k) {
        return CATALOG[k] && need[k] > 0 && !basket.some(function(b) {
          return b.key === k
        })
      });
      if (short.length) warn.unshift({
        level: "bad",
        text: "Out of stock right now, so not in the total: " + short.map(function(k) {
          return CATALOG[k].title
        }).join(", ") + "."
      });
      var refill = peakDaily > 0 ? tank / peakDaily : Infinity;
      warn.push({
        level: "info",
        text: "Target pH " + (line.ph || mt.ph) + "."
      });
      if (line.ecIncludesTap) warn.push({
        level: "info",
        text: "Plagron’s EC figures already include the tap water, which they take as 0.4 mS/cm. So this is what the meter should read with the feed in, not what the feed adds on top — the opposite of how most sheets are written. They also cap the mixed solution at 3.0 mS/cm."
      });
      if (line.ro) warn.push({
        level: "info",
        text: "This chart is written for RO water at 0.0 starting EC. Your tap water’s own EC counts towards the targets below, so on tap water you need less nutrient than the ml/L says — mix to the EC."
      });
      if (line.brand === "Veg+Bloom" && line.weeks && (nVeg > line.weeks.veg.length || nFl > line.weeks.flower.length)) {
        var rw = line.weeks.repeat || {};
        var vgW = Math.min(rw.veg == null ? line.weeks.veg.length - 1 : rw.veg, line.weeks.veg.length - 1) + 1;
        var flW = Math.min(rw.flower == null ? line.weeks.flower.length - 1 : rw.flower, line.weeks.flower.length - 1) + 1;
        warn.push({
          level: "info",
          text: "Longer than the printed chart, so extra weeks repeat veg week " + vgW + " and flower week " + flW + " as Hydroponic Research instruct — the taper stays at the end."
        })
      }
      if (line.brand === "FloraFlex") {
        warn.push({
          level: "info",
          text: line.dosing === "stock" ? "Mix each powder separately at 1 lb per US gallon of water — that is 119.8 g per litre — and the chart below is the ml of that stock to add. The shopping list is still the dry powder." : "The chart below is grams of dry powder per litre of feed, weighed straight in. If you would rather run a stock tank, pick the stock tank option instead — same products, same total."
        });
        warn.push({
          level: "info",
          text: "V1 and V2 are one bundle, and so are B1 and B2 — a “1 lb” is a pound of both parts."
        });
        if (foliar) {
          var f1 = function(n) {
            return n < 10 ? n.toFixed(2) : Math.round(n)
          };
          warn.push({
            level: "info",
            text: "Foliar is a spray, so the amount follows leaf area, not tank size. Working: " + plants + " plants × " + Math.round(canopyFor(size) * 100) / 100 + " m² canopy each = " + foliar.canopy.toFixed(2) + " m², × " + SPRAY_L_PER_M2 + " L per m² a spray = " + (foliar.canopy * SPRAY_L_PER_M2).toFixed(2) + " L each time. " + foliar.vegSprays + " veg sprays and " + foliar.bloomSprays + " bloom sprays, at FloraFlex’s " + FOLIAR_G_PER_GAL + " g per US gallon (" + (FOLIAR_G_PER_GAL / GAL).toFixed(2) + " g/L)."
          });
          if (foliar.bloomSprays) warn.push({
            level: "info",
            text: "Bloom Foliar is costed for the first three weeks of bloom only. Same 5–7 day cadence as veg — days 1, 7 and 14 — then it stops, because once the flowers form water sitting in a bud invites mould. FloraFlex print a zero from bloom week 4 for the same reason."
          });
          warn.push({
            level: "info",
            text: "The 0.5 L per m² is ours — nobody publishes it. It is a moderate spray that wets both sides of the leaf; a heavy drench is nearer 1.0 and a light mist 0.2. It barely changes what you buy: a 1 lb bag makes 428 L of spray, which is many cycles at this size."
          })
        }
        if (nFl > line.weeks.flower.length) warn.push({
          level: "info",
          text: "Longer than the printed eight weeks of bloom, so extra weeks repeat week 6 exactly as FloraFlex instruct — which means a longer run on Full Tilt, with the flush still last."
        })
      }
      if (line.brand === "MONKEY" && offers("mky_pk") && offers("mky_resin")) warn.push({
        level: "bad",
        text: "PK 14/15 and Resin are two versions of the same finish, not a pair. You have both ticked, so this basket is paying for two of them. Monkey print them as alternatives — untick whichever you are not running."
      });
      if (line.brand === "MONKEY" && type === "coco") warn.push({
        level: "info",
        text: "On coco Monkey also call for Mag Cal. It is in the list above rather than on by default, because their chart names it without printing a rate."
      });
      if (line.brand === "BAC") warn.push({
        level: "info",
        text: "BAC print one base product running veg to flower; the shop stocks separate Grow and Bloom, so Grow is used through veg and Bloom through flower at the chart’s rates."
      });
      if (line.kind === "athena") warn.push({
        level: "info",
        text: "A+B is one line: a “1 Gallon” is a gallon of A and a gallon of B."
      });
      if (lineK === "canna_coco") warn.push({
        level: "info",
        text: "CANNA Coco is ramped, not flat. The 40 ml/10 L on the bottle is the peak rate, not every week."
      });
      if (line.brand === "SHOGUN" && line.fromCalculator) warn.push({
        level: "info",
        text: "SHOGUN publish no printed sheet for Samurai Hydro, so these come from their own feedchart calculator on standard feeding. They run a little lighter than the printed Coco and Terra sheet."
      });
      if (line.brand === "SHOGUN" && line.weeks && !line.fromCalculator) warn.push({
        level: "info",
        text: "From SHOGUN’s printed LED chart. They publish EC as a band, not a number — the target shown is the middle of it, and the strength buttons move across it. Their own online calculator aims lower, nearer the Light setting."
      });
      if (line.brand === "SHOGUN") warn.push({
        level: "info",
        text: "Feed strength moves the base feed only. SHOGUN hold every additive at the same rate on Light, Standard and Heavy, and so does this chart."
      });
      if (line.brand === "SHOGUN") warn.push({
        level: "info",
        text: "The chart assumes moderately hard water at about EC 0.4, which already covers your calcium and magnesium. On RO or soft water add CalMag at 0.5–1 ml/L, and always add it with Terra Light Mix."
      });
      if (stren > 1.001) {
        var peakEc = 0;
        weeks.forEach(function(w) {
          if (w.ec > peakEc) peakEc = w.ec
        });
        var pct = Math.round((stren - 1) * 100);
        warn.push({
          level: peakEc >= 3 ? "bad" : "info",
          text: line.noEc ? "Feed strength here is a multiplier on the base feed, nothing more. " + pct + "% above the chart, with every additive held at its printed rate. " + line.brand + " publish no target EC for this schedule, so there is no EC to aim at — " + "watch the plant and the runoff instead, and go up in steps." : "Feed strength is an EC setting, not a bigger dose of everything. This is " + pct + "% above the chart, so the base feed and the target EC both move by that much and the " + "additives do not move at all." + (peakEc >= 3 ? " It peaks at EC " + peakEc.toFixed(1) + " — over 3.0. Only go there on hard water, " + "a strong root system and good runoff, and check runoff EC every feed." : " Mix to the EC row and stop there, whatever the millilitres say.")
        })
      }
      if (line.brand === "BioBizz") warn.push({
        level: "info",
        text: "BioBizz publish no EC for this schedule, and would not want one — an organic feed’s conductivity says very little about what the plant can actually take up. Their only published number is an acidity band of 6.2–6.5, ideally held at 6.2–6.3. Water two to three times a week, and do not water to run-off."
      });
      if (line.brand === "BioBizz") warn.push({
        level: "info",
        text: "Their own advice is to be modest: “a plant will not die from too little nutrient, but it won’t survive an overdose.” The printed schedule also ends with two weeks of plain water before harvest, which is not shown here because this calculator prices feed weeks only."
      });
      if (line.brand === "BioBizz") warn.push({
        level: "info",
        text: "Alg-A-Mic, Acti-Vera and Fish-Mix can also go on as a foliar, one to three times a week up to the second week of flower — 1–2 ml/L of each, or a maximum of 1 ml/L each if you spray all three. That is not priced here; it comes out of the same bottles."
      });
      if (line.brand === "Dutch Pro") warn.push({
        level: "info",
        text: 'Dutch Pro print the base as a range with an EC band beside it — "min 2.5, max 3.5 ml, EC 1.8–2.4" — and tell you to keep adding base until you reach your EC. The midpoint of their range is shown; the EC row is the number to hit.'
      });
      if (line.brand === "Dutch Pro") warn.push({
        level: "info",
        text: "Dutch Pro also print a weekly Leaf Green foliar through veg and the first two weeks of flower. It is not priced here because the sheet gives no rate for it — follow the bottle."
      });
      if (line.brand === "House & Garden") warn.push({
        level: "info",
        text: "The House & Garden 8 Week chart is printed per US gallon of RO water; every figure here is converted to per litre. They publish no EC on it at all — only an acidity band — so no target EC is shown rather than one being invented."
      });
      if (line.brand === "House & Garden" && offers("hg_shoot")) warn.push({
        level: "info",
        text: "Shooting Powder replaces Top Shooter — H&G print CHOOSE ONE above the pair — so ticking it takes Top Shooter out of the basket and the total can go DOWN. One 65 g sachet per 100 L in the first of the last three weeks, two per 100 L for the final fortnight."
      });
      if (line.brand === "House & Garden" && offers("hg_shoot")) warn.push({
        level: "bad",
        text: "Shooting Powder needs your base nutrient EC brought DOWN to 1.2 before it goes in, landing you at 1.8–2.2 overall. Do not run it alongside PK 13/14 or another PK booster, and start at half strength on the first week. It is for healthy, established plants only."
      });
      if (offers("ipm_cure")) warn.push({
        level: "info",
        text: "CANNA Cure Concentrate is costed at a 1:20 dilution. Our listing does not print the figure for the concentrate, so check the bottle before you mix."
      });
      if (offers("hd_bomb")) warn.push({
        level: "bad",
        text: "Flower Bomb contains plant growth regulators. PAYDAY, Diamond Density and OG Rapid in the same group are sold as the natural alternative. Whichever you pick, run one — stacking hardeners is how you get rock-hard, harsh flower."
      });
      var hardOn = ["hd_payday", "hd_diamond", "hd_ograpid", "hd_bomb"].filter(function(k) {
        return offers(k)
      });
      if (hardOn.length > 1) warn.push({
        level: "bad",
        text: "You have " + hardOn.length + " flower hardeners ticked. They all do the same job in the same weeks; pick one."
      });
      var siOn = ["gg_msa", "si_canna", "si_mills", "mky_stress", "si_grenade"].filter(function(k) {
        return offers(k)
      });
      if (siOn.length > 1) warn.push({
        level: "info",
        text: "More than one silicon is ticked. They are different routes to the same job, so you are paying twice — unless one of them is already on your feed’s own chart."
      });
      if (offers("si_canna")) warn.push({
        level: "info",
        text: "CANNA Silica lifts your base EC by 0.25–0.5 on its own. Add it before the base, then bring the base up to the target EC rather than on top of it."
      });
      if (line.base && line.base.veg !== line.base.flower) warn.push({
        level: "info",
        text: "Grow and Bloom are never mixed in the same solution — it is a straight switch at 12/12."
      });
      if (line.chartNote) warn.push({
        level: "info",
        text: line.chartNote
      });
      if (line.waterType && !line.weeksSoft) warn.push({
        level: "info",
        text: "Hard and soft water versions are the same dose in a different formulation, so this only changes which bottle you buy."
      });
      if (line.weeksSoft) warn.push({
        level: "info",
        text: line.softNote || "Dutch Pro publish a separate RO/soft-water sheet, and it is not just a different bottle — the soft-water base runs lighter for the same EC targets, because the water is contributing nothing of its own. Switching the water type here switches the whole chart."
      });
      if (line.kind === "athena_pro") warn.push({
        level: "info",
        text: "Pro Line is a stock-tank system: mix each powder into water at Athena’s recommended 226 g per litre to make a concentrate, then dose the ml/L shown. The shopping list is the dry powder you need. Their program runs a flat EC 3.0 from veg week 1 to harvest — it is not a ramp."
      });
      Object.keys(swaps).forEach(function(k) {
        warn.push({
          level: "info",
          text: swaps[k] + " replaces " + CATALOG[k].title + " rather than running alongside it — the same job twice is money for nothing — so " + CATALOG[k].title + " has left the chart and the basket."
        })
      });
      if (usesFade) warn.push({
        level: "info",
        text: "Fade replaces Core for the last " + FADE_WEEKS + " weeks — Core out, Fade in. Bloom keeps running alongside it."
      });
      if (irrig === "recirc" && dumped > 0) {
        var changes = Math.round(dumped / tank);
        warn.push({
          level: "info",
          text: changes + " reservoir change" + (changes === 1 ? "" : "s") + " over the cycle, so " + Math.round(dumped) + " L of mixed feed goes down the drain on top of " + "what the plants drink. That is counted in the basket."
        });
        if (dumped > (totalWater - dumped) * 3) warn.push({
          level: "warn",
          text: "Your reservoir changes account for more than three quarters of the feed in this basket. " + "Worth checking the tank size and how often you really dump it."
        });
        warn.push({
          level: "info",
          text: "These figures remake the whole tank at the chart’s own strength, which is how flood and " + "drain, NFT and most drip-to-tank rooms run. If you are in true DWC or RDWC, treat them as " + "the outside estimate: roots sitting in the solution means a lower EC than the printed chart, " + "and you top up against a meter rather than remaking the lot."
        })
      }
      if (irrig === "gravity") warn.push({
        level: "info",
        text: "Nothing runs out of the pot on a gravity-fed system, so you get through less than a run-to-waste " + "grower does. These figures do not yet take that off, so treat them as the outside estimate."
      });
      if (inp.litresPerDay > 0) warn.push({
        level: "info",
        text: "Using your own figure of " + peakBase.toFixed(2) + " L per plant per day at peak instead of the calculated " + peakAuto.toFixed(2) + " L."
      });
      /* What the feed you will actually pour is worth, at the rate you paid for
         it. Everything above that figure is packaging. Derived from the basket
         itself so it cannot disagree with the rows on screen. */
      var useValue = 0;
      basket.forEach(function(b) {
        useValue += b.usedValue
      });
      var unusedCost = grand - useValue;
      return {
        type: type,
        mediaType: mt,
        size: size,
        line: line,
        lineKey: lineK,
        validLines: valid,
        plants: plants,
        tank: tank,
        water: water,
        style: style,
        usesFade: usesFade,
        peakAuto: peakAuto,
        peakBase: peakBase,
        overridden: !!override,
        peakDaily: peakDaily,
        refillDays: refill,
        totalWater: totalWater,
        weeks: weeks,
        need: need,
        basket: basket,
        grand: grand,
        useValue: useValue,
        unusedCost: unusedCost,
        unusedPc: grand > 0 ? (grand - useValue) / grand * 100 : 0,
        warn: dedupe(warn),
        cycleWeeks: total,
        runs: runs,
        perRun: grand / runs,
        irrigation: irrig,
        resWeeks: resWks,
        dumped: dumped,
        foliar: foliar,
        sprays: addonSprays
      }
    }


    function fmtMin(m) {
      if (!isFinite(m) || m <= 0) return "—";
      var s = Math.round(m * 60);
      return s < 60 ? s + " sec" : Math.floor(s / 60) + " min " + s % 60 + " sec"
    }
    return {
      CATALOG: CATALOG,
      MEDIA_TYPES: MEDIA_TYPES,
      SIZES: SIZES,
      LINES: LINES,
      STYLES: STYLES,
      STRENGTHS: STRENGTHS,
      IRRIGATION: IRRIGATION,
      isBase: isBase,
      CANOPY: CANOPY,
      LIMITS: LIMITS,
      ADDON_GROUPS: ADDON_GROUPS,
      ADDONS: ADDONS,
      addonRate: addonRate,
      addonSprayCount: addonSprayCount,
      SPRAY_L_PER_M2: SPRAY_L_PER_M2,
      foliarNeed: foliarNeed,
      VBX: VBX,
      MONKEY: MONKEY,
      mapWeeks: mapWeeks,
      EC_TABLE: EC_TABLE,
      PRO_EC: PRO_EC,
      proDose: proDose,
      PRO_CONCENTRATE_G_PER_L: PRO_CONCENTRATE_G_PER_L,
      CANNA: CANNA,
      FABRIC: FABRIC,
      proDose: proDose,
      packFor: packFor,
      compute: compute,
      fmtMin: fmtMin,
      sizesFor: sizesFor,
      sizeOf: sizeOf,
      linesFor: linesFor,
      canopyFor: canopyFor,
      CUSTOM_SIZE: CUSTOM_SIZE,
      hydrate: hydrate,
      requiredHandles: requiredHandles,
      brandsFor: brandsFor,
      formOf: formOf,
      ORGANIC_LINES: ORGANIC_LINES,
      GAL: GAL,
      LB: LB
    }
  });

  function FC_INIT(FC) {
    var SECTION_ID = FC.sectionId;
    var FT_OFFSET = FC.headerOffset;
    /* A section built against a different asset is the one new way this
       arrangement can break, so it says so rather than half-working. */
    if (FC.build && FC.build !== FC_BUILD && window.console && console.error) console.error('[feed calculator] the section and the script are different builds. ' + 'Section: ' + FC.build + '. Script: ' + FC_BUILD + '. Paste both files.');
    (function() {
      "use strict";
      var E = NUTRI;
      window.E = E;
      var ROOT = document.getElementById("fc-" + SECTION_ID);
      var $ = function(k) {
        return ROOT.querySelector('[data-ff="' + k + '"]')
      };
      var st = {
        type: "coco",
        size: "qf3",
        potLitres: 11,
        line: null,
        brand: null,
        units: "litre",
        water: "hard",
        style: "standard",
        strength: "chart",
        extras: {},
        skip: {},
        sort: "price",
        filter: "all",
        runs: 1,
        irrigation: "waste",
        resWeeks: 3
      };

      function picked() {
        return !!st.line
      }
      var TRACK_SEEN = {};
      var GA_Q = [],
        GA_READY = false,
        GA_TIMER = null,
        GA_GAVE_UP = false;
      var GA_WAIT_MS = 2e4,
        GA_POLL_MS = 200;

      function gaUp() {
        return typeof window.gtag === "function" && !!window.google_tag_data
      }

      function gaFlush() {
        GA_READY = true;
        while (GA_Q.length) {
          var e = GA_Q.shift();
          try {
            window.gtag("event", e[0], e[1])
          } catch (x) {}
        }
      }

      function sendGa(name, params) {
        if (GA_READY || gaUp()) {
          if (!GA_READY) GA_READY = true;
          try {
            window.gtag("event", name, params)
          } catch (x) {}
          return
        }
        if (GA_GAVE_UP) return;
        if (GA_Q.length < 60) GA_Q.push([name, params]);
        if (GA_TIMER) return;
        var waited = 0;
        GA_TIMER = setInterval(function() {
          waited += GA_POLL_MS;
          if (gaUp()) {
            clearInterval(GA_TIMER);
            GA_TIMER = null;
            gaFlush();
            return
          }
          if (waited >= GA_WAIT_MS) {
            clearInterval(GA_TIMER);
            GA_TIMER = null;
            GA_GAVE_UP = true;
            GA_Q.length = 0
          }
        }, GA_POLL_MS)
      }
      window.__gaState = function() {
        return {
          ready: GA_READY,
          gaveUp: GA_GAVE_UP,
          queued: GA_Q.length,
          gtag: typeof window.gtag,
          tagLoaded: !!window.google_tag_data
        }
      };

      function trackCtx() {
        return {
          fc_media: st.type,
          fc_size: st.size === E.CUSTOM_SIZE ? String(st.potLitres) + "L" : st.size,
          fc_plants: +$("plants").value || 1,
          fc_weeks: (+$("veg").value || 0) + (+$("flower").value || 0),
          fc_runs: st.runs,
          fc_irrig: st.irrigation,
          fc_brand: st.brand || "(none)",
          fc_line: st.line || "(none)"
        }
      }

      function track(name, params) {
        try {
          var p = params || {},
            k, d = {
              event: name
            };
          var c = trackCtx();
          for (k in c)
            if (Object.prototype.hasOwnProperty.call(c, k) && p[k] === undefined) p[k] = c[k];
          if (typeof FC_BUILD === "string") p.fc_build = FC_BUILD;
          sendGa(name, p);
          if (window.dataLayer && typeof window.dataLayer.push === "function") {
            for (k in p)
              if (Object.prototype.hasOwnProperty.call(p, k)) d[k] = p[k];
            window.dataLayer.push(d)
          }
          document.dispatchEvent(new CustomEvent("fc:track", {
            bubbles: true,
            detail: {
              name: name,
              params: p
            }
          }))
        } catch (e) {}
      }

      function trackOnce(name, params) {
        if (TRACK_SEEN[name]) return;
        TRACK_SEEN[name] = 1;
        track(name, params)
      }
      window.__track = track;

      function lineOrStandIn() {
        return st.line || E.linesFor(st.type)[0]
      }
      var TICK = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6.3l2.6 2.6L10 3.4" ' + 'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      (function() {
        var v = $("veg"),
          f = $("flower");
        for (var i = 0; i <= 8; i++) {
          var o = document.createElement("option");
          o.value = i;
          o.textContent = i + " week" + (i === 1 ? "" : "s");
          if (i === 4) o.selected = true;
          v.appendChild(o)
        }
        for (var j = 4; j <= 14; j++) {
          var p = document.createElement("option");
          p.value = j;
          p.textContent = j + " weeks";
          if (j === 9) p.selected = true;
          f.appendChild(p)
        }
        var GLYPH = {
          style: function(k, i) {
            return '<span class="drops" aria-hidden="true">' + new Array(i + 2).join("💧") + "</span>"
          },
          strength: function(k, i, n) {
            var h = [];
            for (var j = 0; j < n; j++) h.push('<i class="' + (j <= i ? "f" : "") + '" style="height:' + (6 + j * 4) + 'px"></i>');
            return '<span class="bars" aria-hidden="true">' + h.join("") + "</span>"
          }
        };

        function togs(host, table, noEc) {
          var keys = Object.keys(table);
          $(host).innerHTML = keys.map(function(k, i) {
            var o = table[k];
            return '<button type="button" class="tog" data-v="' + k + '">' + (GLYPH[host] ? GLYPH[host](k, i, keys.length) : "") + "<b>" + o.label + '</b><span class="sub">' + (noEc && o.subNoEc ? o.subNoEc : o.sub) + "</span></button>"
          }).join("")
        }
        togs("style", E.STYLES);
        togs("strength", E.STRENGTHS);
        window.__togs = togs
      })();
      var MEDIA_ICON = {
        coco: '<svg class="ico" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 12h20l-2 14a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2z"/><path d="M11 12c0-4 2-7 5-8 3 1 5 4 5 8"/><path d="M12.5 18h7M11.5 22h9"/></svg>',
        soil: '<svg class="ico" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 20V9"/><path d="M16 13c-4 0-6-2-6-5 3 0 6 1 6 5z"/><path d="M16 11c0-3 2-5 5-5 0 3-2 5-5 5z"/><path d="M5 22h22l-1.5 6h-19z"/><path d="M9 25.5h2.5M14.5 25.5h3M20.5 25.5h2.5"/></svg>',
        rockwool: '<svg class="ico" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="10" width="20" height="16" rx="1.5"/><path d="M6 15.5h20M6 21h20M13 10v16M20 10v16"/><path d="M16 10V5.5"/><path d="M16 7.5c-2.4 0-3.8-1.3-3.8-3.3 2.4 0 3.8 1.3 3.8 3.3z"/></svg>'
      };

      function buildTypes() {
        $("type").innerHTML = Object.keys(E.MEDIA_TYPES).map(function(k) {
          var m = E.MEDIA_TYPES[k];
          return '<button type="button" class="tog" data-v="' + k + '" aria-pressed="' + (k === st.type) + '">' + (MEDIA_ICON[k] || "") + "<b>" + m.label + "</b><span>" + m.sub + "</span></button>"
        }).join("")
      }

      function buildIrrig() {
        $("irrig").innerHTML = Object.keys(E.IRRIGATION).map(function(k) {
          var m = E.IRRIGATION[k];
          return '<button type="button" class="tog" data-v="' + k + '" aria-pressed="' + (k === st.irrigation) + '">' + "<b>" + m.label + "</b><span>" + m.sub + "</span></button>"
        }).join("");
        $("resWrap").hidden = st.irrigation !== "recirc";
        setSel("resweeks", String(st.resWeeks))
      }

      function buildSizes() {
        var list = E.sizesFor(st.type);
        if (st.size !== E.CUSTOM_SIZE && !list.some(function(s) {
            return s.k === st.size
          })) st.size = list[0].k;
        $("size").innerHTML = list.map(function(s) {
          var sub = s.label.indexOf(s.litres + " L") >= 0 ? "" : "<small>" + s.litres + " L</small>";
          return '<button type="button" class="chip" data-v="' + s.k + '" aria-pressed="' + (s.k === st.size) + '">' + s.label + sub + "</button>"
        }).join("") + '<button type="button" class="chip" data-v="' + E.CUSTOM_SIZE + '" aria-pressed="' + (st.size === E.CUSTOM_SIZE) + '">Other size<small>type it</small></button>';
        var custom = st.size === E.CUSTOM_SIZE;
        $("potWrap").hidden = !custom;
        if (custom && $("pot").value === "") $("pot").value = String(st.potLitres)
      }

      function lineInfo() {
        var out = {};
        E.linesFor(st.type).forEach(function(k) {
          try {
            var r = E.compute({
              mediaType: st.type,
              size: st.size,
              potLitres: st.potLitres,
              line: k,
              water: st.water,
              style: st.style,
              plants: +$("plants").value || 1,
              tank: +$("tank").value || 1,
              litresPerDay: +$("lpd").value || 0,
              irrigation: st.irrigation,
              resWeeks: st.resWeeks,
              strength: E.STRENGTHS[st.strength].mult,
              vegWeeks: +$("veg").value,
              flowerWeeks: +$("flower").value,
              extras: st.extras,
              runs: st.runs
            });
            var img = null;
            r.basket.forEach(function(b) {
              if (!img && E.isBase(k, b.key) && E.CATALOG[b.key] && E.CATALOG[b.key].img) img = E.CATALOG[b.key].img
            });
            var mix = 0;
            r.weeks.forEach(function(w) {
              mix = Math.max(mix, Object.keys(w.dose).length)
            });
            var one = r.grand;
            if (st.runs > 1) {
              try {
                one = E.compute({
                  mediaType: st.type,
                  size: st.size,
                  potLitres: st.potLitres,
                  line: k,
                  water: st.water,
                  style: st.style,
                  plants: +$("plants").value || 1,
                  tank: +$("tank").value || 1,
                  litresPerDay: +$("lpd").value || 0,
                  irrigation: st.irrigation,
                  resWeeks: st.resWeeks,
                  strength: E.STRENGTHS[st.strength].mult,
                  vegWeeks: +$("veg").value,
                  flowerWeeks: +$("flower").value,
                  extras: st.extras,
                  runs: 1
                }).grand
              } catch (e) {
                one = r.grand / st.runs
              }
            }
            out[k] = {
              total: r.grand / st.runs,
              spend: r.grand,
              one: one,
              img: img,
              mix: mix,
              weeks: r.cycleWeeks,
              form: E.formOf(k, r.basket),
              useValue: r.useValue / st.runs,
              unusedPc: r.unusedPc
            }
          } catch (e) {
            out[k] = {
              useValue: null,
              unusedPc: null,
              total: null,
              spend: null,
              one: null,
              img: null,
              mix: 0,
              weeks: 0,
              form: "liquid"
            }
          }
        });
        return out
      }

      function buildBrands() {
        var groups = E.brandsFor(st.type);
        var info = lineInfo();

        function px2(k) {
          return (info[k] || {}).total
        }

        function money2(v) {
          return v ? "£" + v.toFixed(2) : ""
        }

        function money0(v) {
          return v ? "£" + Math.round(v) : ""
        }

        function ord(n) {
          var t = n % 100,
            u = n % 10;
          return n + (t >= 11 && t <= 13 ? "th" : u === 1 ? "st" : u === 2 ? "nd" : u === 3 ? "rd" : "th")
        }
        if (st.brand && !groups.some(function(g) {
            return g.brand === st.brand
          })) {
          st.brand = null;
          st.line = null
        }
        var group = st.brand ? groups.filter(function(g) {
          return g.brand === st.brand
        })[0] : null;

        function rank(k) {
          var v = px2(k);
          return v === null || v === undefined ? Infinity : v
        }

        function mixOf(k) {
          return (info[k] || {}).mix || 99
        }
        groups.forEach(function(g) {
          g.lines.sort(function(a, b) {
            return st.sort === "use" ? useRank(a) - useRank(b) || rank(a) - rank(b) : rank(a) - rank(b)
          })
        });
        var NOT_IT = {
          organic: "not organic",
          powder: "not a powder",
          liquid: "a powder"
        };

        function matches(k) {
          if (st.filter === "organic") return E.LINES[k].organic;
          if (st.filter === "powder") return (info[k] || {}).form === "powder";
          if (st.filter === "liquid") return (info[k] || {}).form !== "powder";
          return true
        }

        function repLine(g) {
          for (var i = 0; i < g.lines.length; i++)
            if (matches(g.lines[i])) return g.lines[i];
          return null
        }

        function shownLine(g) {
          return repLine(g) || g.lines[0]
        }

        function oneRunBest(g, kept) {
          var best = null;
          g.lines.forEach(function(k) {
            if (!kept && !matches(k)) return;
            var v = (info[k] || {}).one;
            if (v && (best === null || v < best)) best = v
          });
          return best
        }
        /* Sorting on what the run actually consumes rather than what it costs.
           The two differ by the packaging penalty, and on coco that reorders
           eleven of the thirty-five lines by two places or more. Monkey Resin
           moves nine. Measured 27 Sep 2026. */
        function useRank(k) {
          var v = (info[k] || {}).useValue;
          return v === null || v === undefined ? Infinity : v
        }
        var SORTS = {
          price: function(a, b) {
            return rank(shownLine(a)) - rank(shownLine(b))
          },
          use: function(a, b) {
            return useRank(shownLine(a)) - useRank(shownLine(b)) || rank(shownLine(a)) - rank(shownLine(b))
          },
          mix: function(a, b) {
            return mixOf(shownLine(a)) - mixOf(shownLine(b)) || rank(shownLine(a)) - rank(shownLine(b))
          },
          name: function(a, b) {
            return a.brand.localeCompare(b.brand)
          }
        };
        groups.sort(SORTS[st.sort] || SORTS.price);
        var wasRank = {};
        if (st.runs > 1 && st.sort === "price") {
          groups.slice().sort(function(a, b) {
            var ao = (info[shownLine(a)] || {}).one,
              bo = (info[shownLine(b)] || {}).one;
            return (ao === undefined || ao === null ? Infinity : ao) - (bo === undefined || bo === null ? Infinity : bo)
          }).forEach(function(g, i) {
            wasRank[g.brand] = i
          })
        }
        var shown = groups.filter(function(g) {
          return !!repLine(g)
        });
        var keptGroup = group && !shown.some(function(g) {
          return g.brand === st.brand
        }) ? group : null;
        if (group && group.lines.indexOf(st.line) < 0) st.line = group.lines[0];
        $("lineHint").textContent = st.brand ? "Suitable for " + E.MEDIA_TYPES[st.type].label.toLowerCase() + "." : "Every brand priced for your grow. Nothing is in the basket until you pick one.";
        Array.prototype.forEach.call($("bsort").querySelectorAll("button"), function(b) {
          b.setAttribute("aria-pressed", String(b.dataset.v === st.sort))
        });
        Array.prototype.forEach.call($("bfilter").querySelectorAll("button"), function(b) {
          b.setAttribute("aria-pressed", String(b.dataset.v === st.filter))
        });
        Array.prototype.forEach.call($("bruns").querySelectorAll("button"), function(b) {
          b.setAttribute("aria-pressed", String(+b.dataset.v === st.runs))
        });
        var multi = !!group && group.lines.length > 1;
        $("lineHome").appendChild($("lineWrap"));
        $("lineWrap").style.display = multi ? "" : "none";
        var runLbl = st.runs > 1 ? "Per run" : "The run";
        var head = '<div class="bhead"><span>Feed</span><span>' + runLbl + "</span><span>You&rsquo;ll use</span>" + "<span>In the mix</span><span>Left over</span><span>&nbsp;</span></div>";

        function row(g, gi, kept) {
          var k = repLine(g) || g.lines[0],
            d = info[k] || {};
          var best = d.total,
            wk = best && d.weeks ? best / d.weeks : null;
          var organic = E.LINES[k].organic;
          var lowMix = d.mix && d.mix <= 3 ? " mix--low" : "";
          var reach = kept || st.filter === "all" ? g.lines.length : g.lines.filter(matches).length;
          var many = reach > 1 ? '<span class="why">' + reach + " lines</span>" : "";
          var climb = "";
          if (!kept && wasRank[g.brand] !== undefined) {
            var from = wasRank[g.brand];
            climb = '<span class="why climb">' + (gi + 1) + " of " + shown.length + (from !== gi ? " · was " + ord(from + 1) : "") + "</span>"
          }
          var oneBest = oneRunBest(g, kept);
          var was = st.runs > 1 && oneBest && best && best < oneBest - .005 ? '<span class="was">' + money0(oneBest) + "</span>" : "";
          var open = multi && g.brand === st.brand;
          return '<div class="bgrp" data-bi="' + gi + '">' + '<button type="button" class="brow' + (open ? " brow--open" : "") + '" data-v="' + g.brand + '" aria-pressed="' + (g.brand === st.brand) + '">' + '<span class="c-name"><span class="nm">' + g.brand + "</span>" + many + climb + "</span>" + '<span class="num" data-l="' + (st.runs > 1 ? "per run" : "run") + '">' + (best ? (reach > 1 ? "from " : "") + money0(best) : "—") + was + "</span>" + '<span class="num" data-l="you&rsquo;ll use">' + (d.useValue ? money0(d.useValue) : "—") + "</span>" + '<span class="mix' + lowMix + '" data-l="in the mix">' + (d.mix || "—") + "</span>" + '<span class="num waste' + (d.unusedPc >= 25 ? " waste--hi" : "") + '" data-l="left over">' + (d.unusedPc == null ? "—" : Math.round(d.unusedPc) + "%") + "</span>" + '<span class="btags">' + (organic ? '<span class="tag tag--org">Organic</span>' : '<span class="tag">Mineral</span>') + ' <span class="tag">' + (d.form === "powder" ? "Powder" : "Liquid") + "</span>" + "</span></button></div>"
        }
        var html = shown.length ? head + shown.map(function(g, gi) {
          return row(g, gi, false)
        }).join("") : '<p class="bnone">No ' + st.filter + " feed is listed for " + E.MEDIA_TYPES[st.type].label.toLowerCase() + ". Switch back to <b>All</b>.</p>";
        if (keptGroup) {
          html += '<div class="bkept"><b>' + keptGroup.brand + " is still your feed.</b> It is " + (NOT_IT[st.filter] || "not in that group") + ", so it is not in the list above.</div>" + row(keptGroup, shown.length, true)
        }
        $("brand").innerHTML = html;
        var sl = $("saveline");
        var selD = st.runs > 1 && st.brand && st.line ? info[st.line] || {} : null;
        if (st.runs < 2) {
          sl.hidden = true;
          sl.innerHTML = ""
        } else if (selD && selD.one && selD.spend) {
          var selSave = selD.one * st.runs - selD.spend;
          var selBr = E.LINES[st.line].brand || "",
            selLb = E.LINES[st.line].label;
          var selNm = selBr && selLb.indexOf(selBr) !== 0 ? selBr + " " + selLb : selLb;
          sl.hidden = false;
          sl.innerHTML = selSave > .5 ? "<b>" + selNm + " for " + st.runs + " runs saves " + money0(selSave) + ".</b> " + money2(selD.total) + " a run instead of " + money2(selD.one) + '.<span class="sub">Same feed, same chart. You are ' + "buying it in bigger bottles and fewer of them.</span>" : "<b>" + selNm + " costs the same either way at " + st.runs + " runs.</b> " + money2(selD.total) + " a run whether you buy " + 'it now or a run at a time.<span class="sub">Its pack sizes happen to ' + "land on this volume. Other feeds here do save, and the struck-through " + "prices show which.</span>"
        } else {
          var lo = Infinity,
            hi = -Infinity,
            bigBrand = null,
            bigOne = 0,
            bigNow = 0;
          shown.concat(keptGroup ? [keptGroup] : []).forEach(function(g) {
            var dd = info[repLine(g) || g.lines[0]] || {};
            var ob = oneRunBest(g, g === keptGroup);
            if (!ob || !dd.spend) return;
            var save = ob * st.runs - dd.spend;
            if (!(save > 0)) return;
            if (save < lo) lo = save;
            if (save > hi) {
              hi = save;
              bigBrand = g.brand;
              bigOne = ob;
              bigNow = dd.total
            }
          });
          if (!bigBrand) {
            sl.hidden = true;
            sl.innerHTML = ""
          } else {
            sl.hidden = false;
            sl.innerHTML = "<b>Buying for " + st.runs + " runs saves between " + money0(lo) + " and " + money0(hi) + " in total, depending on the feed.</b> Biggest on " + bigBrand + ": " + money2(bigNow) + " a run instead of " + money2(bigOne) + '.<span class="sub">Struck-through prices below are what each feed costs ' + "bought one run at a time. Nothing about how you feed changes, only how " + "much you buy at once.</span>"
          }
        }
        $("lineLbl").textContent = "Which " + (st.brand || "") + " line";
        $("line").innerHTML = !group ? "" : group.lines.map(function(k) {
          var l = E.LINES[k];
          var li = (info[k] || {}).img;
          return '<button type="button" class="tog" data-v="' + k + '" aria-pressed="' + (k === st.line) + '">' + (li ? '<img class="thumb" src="' + li + '" alt="" loading="lazy">' : "") + '<b><span class="px">' + money2(px2(k)) + "</span>" + l.label + "</b><span>" + l.blurb + "</span></button>"
        }).join("");
        if (multi) {
          var gi = -1;
          (keptGroup ? shown.concat([keptGroup]) : shown).forEach(function(g, i) {
            if (g.brand === st.brand) gi = i
          });
          var slot = gi < 0 ? null : $("brand").querySelector('.bgrp[data-bi="' + gi + '"]');
          if (slot) slot.appendChild($("lineWrap"));
          else $("lineWrap").style.display = "none"
        }
      }

      function buildExtras() {
        var groups = E.ADDON_GROUPS;
        var all = E.LINES[lineOrStandIn()].extras;
        if (!picked()) $("extras").innerHTML = "";
        var ex = all.filter(function(e) {
          return !e.group
        });
        if (!picked()) ex = [];

        function isOn(e) {
          return st.extras[e.k] === undefined ? e.on : st.extras[e.k]
        }
        var dead = {};
        all.forEach(function(e) {
          if (e.displaces && isOn(e)) dead[e.displaces] = e.label
        });
        groups.forEach(function(g) {
          var items = all.filter(function(e) {
            return e.group === g.id
          });
          $("grpCard-" + g.id).style.display = items.length ? "" : "none";
          $("grpHint-" + g.id).textContent = g.hint;
          $("grp-" + g.id).innerHTML = items.map(row).join("");
          $("grp-" + g.id).setAttribute("role", g.single ? "radiogroup" : "group")
        });

        function row(e) {
          var on = isOn(e),
            by = dead[e.key];
          var img = (E.CATALOG[e.key] || {}).img;
          return '<button type="button" class="optrow' + (by ? " supers" : "") + '" data-x="' + e.k + '" aria-pressed="' + on + '">' + '<span class="optrow-box">' + TICK + "</span>" + (img ? '<img class="thumb" src="' + img + '" alt="" loading="lazy">' : "") + "<span><b>" + e.label + (by ? '<span class="opt-tag">replaced by ' + by + "</span>" : e.chart ? '<span class="opt-tag">on the chart</span>' : "") + "</b>" + "<span>" + e.note + "</span></span></button>"
        }
        if (picked()) {
          $("extras").innerHTML = ex.length ? ex.map(row).join("") : '<p class="note" style="margin:0">There is nothing optional on this chart — it is the base ' + "bottles and nothing else. The silicon and pest-prevention steps still apply, and they are " + "coming up.</p>";
          var hint = $("extras").closest(".card").querySelector(".hint");
          if (hint) hint.hidden = !ex.length
        }
      }

      function pick(host, cb) {
        $(host).addEventListener("click", function(e) {
          var b = e.target.closest("[data-v]");
          if (!b) return;
          cb(b.dataset.v)
        })
      }
      pick("type", function(v) {
        st.type = v;
        st.skip = {};
        buildTypes();
        buildIrrig();
        buildSizes();
        buildBrands();
        buildExtras();
        render()
      });
      pick("size", function(v) {
        st.size = v;
        buildSizes();
        render()
      });
      $("pot").addEventListener("input", function() {
        var n = parseFloat($("pot").value);
        if (isFinite(n)) {
          st.potLitres = n;
          render()
        }
      });
      $("pot").addEventListener("change", function() {
        var lim = E.LIMITS.potLitres,
          n = parseFloat($("pot").value);
        if (!isFinite(n)) n = 11;
        var c = Math.min(lim.max, Math.max(lim.min, n));
        st.potLitres = c;
        if (String(c) !== $("pot").value) {
          $("pot").value = String(c)
        }
        render()
      });

      function keepBrandFree() {
        var keep = {};
        E.LINES[lineOrStandIn()].extras.forEach(function(e) {
          if (e.group && st.extras[e.k] !== undefined) keep[e.k] = st.extras[e.k]
        });
        st.extras = keep
      }
      $("brand").addEventListener("click", function(e) {
        var b = e.target.closest(".brow");
        if (!b) return;
        st.brand = b.dataset.v;
        keepBrandFree();
        st.skip = {};
        buildBrands();
        buildExtras();
        render();
        track("fc_brand", {
          fc_brand: st.brand
        })
      });
      pick("line", function(v) {
        st.line = v;
        keepBrandFree();
        st.skip = {};
        buildBrands();
        buildExtras();
        render();
        track("fc_line", {
          fc_line: v,
          fc_line_label: (E.LINES[v] || {}).label || v
        })
      });
      pick("irrig", function(v) {
        if (!E.IRRIGATION[v]) return;
        st.irrigation = v;
        buildIrrig();
        buildBrands();
        render();
        track("fc_irrigation", {
          fc_irrig: v,
          fc_res_weeks: st.resWeeks
        })
      });
      $("resweeks").addEventListener("change", function() {
        st.resWeeks = Math.max(0, Math.min(12, parseInt(this.value, 10) || 0));
        buildBrands();
        render()
      });
      pick("bsort", function(v) {
        st.sort = v;
        buildBrands();
        track("fc_sort", {
          fc_sort: v
        })
      });
      pick("bfilter", function(v) {
        st.filter = v;
        buildBrands();
        track("fc_filter", {
          fc_filter: v
        })
      });
      pick("bruns", function(v) {
        st.runs = Math.max(1, Math.min(5, +v || 1));
        buildBrands();
        render();
        track("fc_runs", {
          fc_runs: st.runs
        })
      });
      pick("style", function(v) {
        st.style = v;
        $("lpd").value = "";
        render()
      });
      pick("water", function(v) {
        st.water = v;
        render()
      });
      pick("strength", function(v) {
        st.strength = v;
        render()
      });
      pick("units", function(v) {
        st.units = v;
        Array.prototype.forEach.call($("units").querySelectorAll("button"), function(x) {
          x.setAttribute("aria-pressed", String(x.dataset.v === v))
        });
        render()
      });

      function onExtraClick(e) {
        var b = e.target.closest("[data-x]");
        if (!b) return;
        var k = b.dataset.x,
          turningOn = b.getAttribute("aria-pressed") !== "true";
        var all = E.LINES[lineOrStandIn()].extras,
          me = null;
        all.forEach(function(x) {
          if (x.k === k) me = x
        });
        var grp = me && E.ADDON_GROUPS.filter(function(g) {
          return g.id === me.group
        })[0];
        if (turningOn && grp && grp.single) {
          all.forEach(function(x) {
            if (x.group === grp.id && x.k !== k) st.extras[x.k] = false
          })
        }
        st.extras[k] = turningOn;
        buildExtras();
        render()
      }
      $("extras").addEventListener("click", onExtraClick);
      E.ADDON_GROUPS.forEach(function(g) {
        $("grp-" + g.id).addEventListener("click", onExtraClick)
      });
      $("bom").addEventListener("change", function(e) {
        if (!e.target.dataset.k) return;
        st.skip[e.target.dataset.k] = !e.target.checked;
        render()
      });
      $("pminus").addEventListener("click", function() {
        $("plants").value = Math.max(1, (+$("plants").value || 1) - 1);
        render()
      });
      $("pplus").addEventListener("click", function() {
        $("plants").value = Math.min(2e3, (+$("plants").value || 1) + 1);
        render()
      });
      $("lpdreset").addEventListener("click", function() {
        $("lpd").value = "";
        render()
      });
      $("print").addEventListener("click", function() {
        track("fc_print");
        window.print()
      });
      $("totop").addEventListener("click", function() {
        ROOT.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion:reduce)").matches ? "auto" : "smooth",
          block: "start"
        })
      });
      ["plants", "tank", "veg", "flower", "lpd"].forEach(function(k) {
        $(k).addEventListener("input", render)
      });
      ["plants", "tank", "lpd"].forEach(function(k) {
        var lim = E.LIMITS[k === "lpd" ? "litresPerDay" : k];
        $(k).addEventListener("change", function() {
          var raw = $(k).value;
          if (raw === "") return;
          var n = parseFloat(raw);
          if (!isFinite(n)) {
            $(k).value = "";
            render();
            return
          }
          var c = Math.min(lim.max, Math.max(lim.min, n));
          if (String(c) !== raw) {
            $(k).value = String(c);
            render()
          }
        })
      });
      var lastGrand = null,
        deltaTimer = null,
        bumpTimer = null;
      var emailChart = null;
      var money = function(n) {
        return "£" + n.toFixed(2)
      };
      var MIXKIT_SMALL = {
        title: "Athena Pro Line 1 Gallon Mixing Kit",
        price: 95,
        pouch: "2 lb pouches",
        handle: "athena-pro-line-1-gallon-mixing-kit-2lb-pouches"
      };
      var MIXKIT_BIG = {
        title: "Athena Pro Line 2.5 Gallon Mixing Kit",
        price: 189,
        pouch: "5 lb pouches",
        handle: "athena-pro-line-2-5-gallon-mixing-kit-for-5-lb-core-grow-bloom-pouches"
      };
      var PRO_BASE_KEYS = ["ath_core", "ath_pgrow", "ath_pbloom", "ath_pbal"];
      var num = function(n, dp) {
        return n.toLocaleString("en-GB", {
          minimumFractionDigits: dp || 0,
          maximumFractionDigits: dp || 0
        })
      };
      var short = function(t, brand) {
        if (!brand) return t;
        var initials = brand.split(/\s+/).filter(function(w) {
          return /^[A-Za-z&]/.test(w)
        }).map(function(w) {
          return w === "&" ? "&" : w[0]
        }).join("");
        var tries = [brand, initials].filter(function(x) {
          return x && x.length > 1
        });
        for (var i = 0; i < tries.length; i++) {
          var pat = new RegExp("^" + tries[i].replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\b[\\s\\-]*", "i");
          if (pat.test(t)) {
            var cut = t.replace(pat, "").trim();
            if (cut.length) return cut
          }
        }
        return t
      };

      function render() {
        var chosen = picked();
        var r = E.compute({
          mediaType: st.type,
          size: st.size,
          potLitres: st.potLitres,
          line: lineOrStandIn(),
          water: st.water,
          style: st.style,
          plants: +$("plants").value || 1,
          tank: +$("tank").value || 1,
          litresPerDay: +$("lpd").value || 0,
          irrigation: st.irrigation,
          resWeeks: st.resWeeks,
          strength: E.STRENGTHS[st.strength].mult,
          vegWeeks: +$("veg").value,
          flowerWeeks: +$("flower").value,
          extras: st.extras,
          runs: st.runs
        });
        $("waterWrap").style.display = chosen && r.line.waterType ? "" : "none";
        $("ecrule").style.display = chosen ? "" : "none";
        $("unitsRow").style.display = chosen ? "" : "none";
        Array.prototype.forEach.call($("water").querySelectorAll("button"), function(b) {
          b.setAttribute("aria-pressed", String(b.dataset.v === st.water))
        });
        Array.prototype.forEach.call($("style").querySelectorAll("button"), function(b) {
          b.setAttribute("aria-pressed", String(b.dataset.v === st.style))
        });
        var noEc = !!(chosen && r.line.noEc);
        if ($("strength").dataset.mode !== (noEc ? "rate" : "ec")) {
          window.__togs("strength", E.STRENGTHS, noEc);
          $("strength").dataset.mode = noEc ? "rate" : "ec"
        }
        $("strengthNote").innerHTML = noEc ? "<b>" + r.line.brand + " print no target EC</b>, so this is a plain multiplier on the base feed." : "<b>Mix to the EC row, not the millilitres.</b> This moves the base feed and the target EC " + "together; additives stay at their printed rate.";
        Array.prototype.forEach.call($("strength").querySelectorAll("button"), function(b) {
          b.setAttribute("aria-pressed", String(b.dataset.v === st.strength))
        });
        $("lpd").placeholder = r.peakAuto.toFixed(2);
        $("lpdNote").innerHTML = r.overridden ? "Using <b>" + r.peakBase.toFixed(2) + " L</b> instead of the calculated " + r.peakAuto.toFixed(2) + " L." : "Calculated <b>" + r.peakAuto.toFixed(2) + " L</b> per plant per day at peak, from " + (/^(8|11|18|8\d)($|[^\d])/.test(String(r.size.litres)) ? "an " : "a ") + r.size.litres + " L " + r.mediaType.label.toLowerCase() + " on a " + E.STYLES[st.style].label.toLowerCase() + " schedule. Type your own if you know it.";
        $("tankWrap").style.display = st.units === "tank" ? "" : "none";
        if (chosen && r.sprays && r.sprays.length) {
          $("sprayNote").style.display = "";
          $("sprayNote").innerHTML = "<b>How the spray quantities are worked out</b><br>" + "Canopy " + (E.CANOPY[r.size.k] || .25).toFixed(2) + " m² a plant × " + (+$("plants").value || 1) + " plants = " + ((E.CANOPY[r.size.k] || .25) * (+$("plants").value || 1)).toFixed(2) + " m², × " + E.SPRAY_L_PER_M2 + " L per m² a pass. " + r.sprays.map(function(sp) {
            return short(sp.title, r.line.brand) + ": " + sp.sprays + " passes = " + sp.litres.toFixed(1) + " L of spray at " + (sp.mlPerL < 1 ? sp.mlPerL.toFixed(2) : sp.mlPerL) + " ml/L"
          }).join(". ") + "."
        } else {
          $("sprayNote").style.display = "none"
        }
        var swapW = (chosen ? r.warn : []).filter(function(w) {
          return / replaces /.test(w.text)
        });
        var msg = $("swapMsg");
        if (swapW.length) {
          var html = '<span class="swapmsg-i">i</span><span><b>One of these is now doing the other’s ' + "job</b>" + swapW.map(function(w) {
            return w.text
          }).join(" ") + "</span>";
          if (msg.innerHTML !== html) {
            msg.innerHTML = html;
            msg.classList.remove("flash");
            void msg.offsetWidth;
            msg.classList.add("flash")
          }
          msg.style.display = ""
        } else {
          msg.style.display = "none";
          msg.innerHTML = ""
        }
        $("warns").innerHTML = (chosen ? r.warn : []).map(function(w) {
          return '<div class="warn ' + (w.level === "bad" ? "bad" : w.level === "info" ? "info" : "") + '">' + w.text + "</div>"
        }).join("");
        var keys = [];
        r.weeks.forEach(function(w) {
          Object.keys(w.dose).forEach(function(k) {
            if (keys.indexOf(k) < 0) keys.push(k)
          })
        });
        var order = ["ath_grow", "ath_bloom", "ath_pgrow", "ath_pbloom", "ath_core", "can_coco", "can_vega", "can_flores", "can_hyd_vega_h", "can_hyd_vega_s", "can_hyd_flor_h", "can_hyd_flor_s", "can_aqua_vega", "can_aqua_flor", "sho_coco", "sho_grow", "sho_bloom", "sho_hyd_grow_h", "sho_hyd_grow_s", "sho_hyd_bloom_h", "sho_hyd_bloom_s", "ath_pk", "can_pk", "sho_pk", "ath_camg", "can_calmag", "sho_calmag", "can_rhizo", "sho_katana", "can_zym", "sho_zenzym", "can_boost", "sho_sumo", "sho_si", "ath_pbal", "ath_cleanse", "ath_fade", "can_flush", "sho_dragon", "gg_msa", "ion_hydro_g", "ion_hw_g", "ion_coco_g", "ion_soil_g", "ion_hydro_b", "ion_hw_b", "ion_coco_b", "ion_soil_b", "ion_pk", "ion_tonic", "ion_root", "ion_flower"];
        keys.sort(function(a, b) {
          return order.indexOf(a) - order.indexOf(b)
        });
        var perTank = st.units === "tank";
        if (!chosen) {
          $("chartSub").textContent = "Pick a brand in step 4 and the whole chart appears here.";
          $("chart").innerHTML = '<tbody><tr><td class="nochart">No feed chosen yet, so there is nothing ' + "to chart and nothing in the basket. Steps 1 to 3 are already set — choose a brand in " + "step 4 and the week-by-week doses, the target EC and the price of the run all fill in." + "</td></tr></tbody>"
        } else {
          $("chartSub").textContent = perTank ? "What to add to your " + num(r.tank) + " L tank, week by week." : "Dose per litre of water, week by week.";
          var h = '<thead><tr><th class="rowh"></th>' + r.weeks.map(function(w) {
            return '<th><span class="stg ' + w.stage + '">' + w.stage + "</span></th>"
          }).join("") + '</tr><tr><th class="rowh">Week</th>' + r.weeks.map(function(w) {
            return '<th><span class="wk-l">' + w.label + '</span><span class="wk-s">' + (w.phase === "veg" ? "V" : "F") + (w.idx + 1) + "</span></th>"
          }).join("") + "</tr></thead><tbody>";
          keys.forEach(function(k) {
            var p = E.CATALOG[k];
            if (!p) return;
            var rowUnit = r.line.dosing === "stock" && p.unit === "g" ? "ml" : p.unit === "g" ? "g" : "ml";
            h += '<tr><td class="rowh" data-unit="' + rowUnit + '">' + short(p.title, r.line.brand) + "</td>";
            r.weeks.forEach(function(w) {
              var conc = r.line.dosing === "stock" && p.unit === "g";
              var v = conc ? perTank ? (w.conc[k] || 0) * r.tank / 1e3 * 1e3 : w.conc[k] || 0 : perTank ? w.perTank[k] || 0 : w.dose[k] || 0;
              if (conc && perTank) v = (w.conc[k] || 0) * r.tank;
              if (!v) {
                h += '<td class="zero">·</td>';
                return
              }
              h += "<td>" + (perTank ? num(v, v < 10 ? 1 : 0) : v.toFixed(2)) + '<span class="uu"> ' + (conc ? "ml" : p.unit === "g" ? "g" : "ml") + "</span></td>"
            });
            h += "</tr>"
          });
          if (!r.line.noEc) {
            h += '<tr class="ecrow"><td class="rowh">Target EC <span class="uu">incl. water</span></td>' + r.weeks.map(function(w) {
              return '<td class="' + (w.ec >= 2.4 ? "hot" : "") + '">' + (w.ec ? w.ec.toFixed(1) : "—") + "</td>"
            }).join("") + "</tr>"
          }
          h += '<tr class="ecrow"><td class="rowh">Litres / day</td>' + r.weeks.map(function(w) {
            return "<td>" + num(w.dailyL, 1) + "</td>"
          }).join("") + "</tr></tbody>";
          $("chart").innerHTML = h;
          emailChart = {
            columns: keys.map(function(k) {
              var p = E.CATALOG[k];
              return p ? short(p.title, r.line.brand) : k
            }).filter(Boolean),
            units: keys.map(function(k) {
              var p = E.CATALOG[k];
              if (!p) return "ml";
              return r.line.dosing === "stock" && p.unit === "g" ? "ml" : p.unit === "g" ? "g" : "ml"
            }),
            hasEc: !r.line.noEc,
            rows: r.weeks.map(function(w) {
              return {
                week: w.label,
                stage: w.stage,
                cells: keys.map(function(k) {
                  var p = E.CATALOG[k];
                  if (!p) return "";
                  var conc = r.line.dosing === "stock" && p.unit === "g";
                  var v = conc ? w.conc[k] || 0 : w.dose[k] || 0;
                  return v ? v.toFixed(2) : ""
                }),
                ec: !r.line.noEc && w.ec ? w.ec.toFixed(1) : ""
              }
            })
          }
        }
        var lines = chosen ? r.basket.slice() : [];

        function on(k, optional) {
          return st.skip[k] === undefined ? !optional : !st.skip[k]
        }

        function base(l) {
          return E.isBase(r.lineKey, l.key)
        }
        var groups = [
          ["Base feed", lines.filter(base)],
          ["Additives", lines.filter(function(l) {
            return !base(l)
          })]
        ];
        var bom = "",
          count = 0,
          grand = 0;
        groups.forEach(function(g) {
          if (!g[1].length) return;
          bom += '<tr class="grouphead"><td colspan="4">' + g[0] + "</td></tr>";
          g[1].forEach(function(b) {
            var isOn = on(b.key, b.optional);
            if (isOn) {
              grand += b.cost;
              count++
            }
            var need = b.unit === "ea" ? "" : '<div class="pwhy">' + (b.unit === "g" ? num(b.need, 2) + " kg" : num(b.need, 2) + " L") + (st.runs > 1 ? " needed for " + st.runs + " runs" : " needed for the run") + "</div>";
            /* The two rates. What a litre costs in the sizes you have to buy, and
               what it costs once the bit left in the bottle is counted in. The
               second is always the higher of the two, and the gap is what the
               pack sizes are costing you rather than the feed. */
            var rate = "";
            if (b.rateBought > 0) {
              var per = "/" + b.rateUnit + (b.ab ? " of each part" : "");
              rate = '<div class="prate">' + money(b.rateBought) + per + ' as bought · <b>' +
                money(b.usedValue) + '</b> of it gets used (' + Math.round(b.usedPc) + '%)' +
                (b.unusedCost >= 0.5 ? ' · ' + money(b.unusedCost) + " left over" : "") +
                "</div>"
            }
            bom += '<tr class="item' + (isOn ? "" : " off") + '">' + '<td class="c-chk"><input type="checkbox" data-k="' + b.key + '"' + (isOn ? " checked" : "") + ' aria-label="Include ' + b.title + '"></td>' + '<td><div class="pname">' + b.title + "</div>" + '<div class="pvar">' + b.lines.map(function(l) {
              return l.qty + " × " + l.tier.t
            }).join("  +  ") + "</div>" + (b.why ? '<div class="pwhy">' + b.why + "</div>" : need) + rate + "</td>" + '<td class="c-qty">' + b.lines.reduce(function(a, l) {
              return a + l.qty
            }, 0) + "</td>" + '<td class="c-price">' + money(b.cost) + "</td></tr>"
          })
        });
        $("bom").innerHTML = bom || '<tr class="item"><td class="nochart">' + (chosen ? "Nothing to buy yet." : "Your basket is empty. Choose a brand in step 4 and everything the chart calls " + "for lands here, priced for the whole run.") + "</td></tr>";
        var setup = [r.mediaType.label, r.size.label, (+$("plants").value || 1) + " plant" + ((+$("plants").value || 1) === 1 ? "" : "s"), chosen ? r.line.label : "no feed chosen yet", E.STYLES[st.style].label + " watering", r.cycleWeeks + " week cycle", E.STRENGTHS[st.strength].label + " strength"].concat(st.irrigation !== "waste" ? [E.IRRIGATION[st.irrigation].label.toLowerCase()] : []).concat(st.runs > 1 ? ["buying for " + st.runs + " runs"] : []).join(" · ");
        $("lineCount").textContent = count + " item" + (count === 1 ? "" : "s");
        $("cycleLbl").textContent = setup;
        $("floatSub").textContent = $("floatSubS").textContent = "Guide price · " + setup;
        $("printHead").innerHTML = "<h2>" + (chosen ? r.line.label : "Feed chart") + "</h2><p>" + setup + "</p>";
        var rs = $("runSave");
        if (!chosen || st.runs < 2 || !(grand > 0)) {
          rs.hidden = true;
          rs.innerHTML = ""
        } else {
          var oneRun = null;
          try {
            oneRun = E.compute({
              mediaType: st.type,
              size: st.size,
              potLitres: st.potLitres,
              line: lineOrStandIn(),
              water: st.water,
              style: st.style,
              plants: +$("plants").value || 1,
              tank: +$("tank").value || 1,
              litresPerDay: +$("lpd").value || 0,
              irrigation: st.irrigation,
              resWeeks: st.resWeeks,
              strength: E.STRENGTHS[st.strength].mult,
              vegWeeks: +$("veg").value,
              flowerWeeks: +$("flower").value,
              extras: st.extras,
              runs: 1
            }).grand
          } catch (e) {
            oneRun = null
          }
          var wouldBe = oneRun === null ? null : oneRun * st.runs;
          var saved = wouldBe === null ? 0 : wouldBe - grand;
          if (!(saved > .5)) {
            rs.hidden = true;
            rs.innerHTML = ""
          } else {
            var pct = Math.round(saved / wouldBe * 100);
            rs.hidden = false;
            rs.innerHTML = "<b>This basket works out " + pct + "% cheaper per run than buying " + st.runs + " separate cycles.</b> " + money(saved) + " less, with the feed for all " + st.runs + ' runs already in it.<span class="sub">Untick something and the figure ' + "moves with it, because it is measured against the basket you are buying rather " + "than the one the calculator started with.</span>"
          }
        }
        /* The packaging line. Says out loud what the two rates on each row add up
           to: how much of this basket is product that stays in the bottle. Only
           shown when it is worth saying. */
        (function () {
          var el = $("leftover");
          if (!el) return;
          var unused = chosen ? r.unusedCost : 0;
          if (!chosen || !(unused >= 1) || !(grand > 0)) {
            el.hidden = true;
            el.innerHTML = "";
            return
          }
          el.hidden = false;
          el.innerHTML = "<b>" + money(unused) + " of this is feed you will not open.</b> " +
            "The smallest sizes " + r.line.brand + " sell do not divide neatly into what your grow " +
            "needs, so " + Math.round(r.unusedPc) + "% of the total is what stays in the bottles at the end. " +
            "Every feed has some of this. It runs from about 5% to over 40% depending on the brand, " +
            "and the <b>left over</b> column back on the feed list shows it for all of them." +
            '<span class="sub">Not a fault, and not wasted if you run again — the leftovers carry ' +
            "over. Buying for more than one run is what makes them disappear.</span>"
        })();
        $("noteSpan").textContent = st.runs > 1 ? st.runs + " full cycles" : "a full cycle";
        (function() {
          var el = $("accNote");
          if (st.line !== "athena_pro") {
            el.hidden = true;
            el.innerHTML = "";
            return
          }
          var big = 0;
          lines.forEach(function(b) {
            if (PRO_BASE_KEYS.indexOf(b.key) < 0 || !on(b.key, b.optional)) return;
            b.lines.forEach(function(l) {
              if (l.tier.size > big) big = l.tier.size
            })
          });
          if (!big) {
            el.hidden = true;
            el.innerHTML = "";
            return
          }
          var k = big > 1 ? MIXKIT_BIG : MIXKIT_SMALL;
          el.hidden = false;
          el.innerHTML = "<b>Pro is a powder, so you need something to mix it in.</b>" + "<p>It gets made up into a stock concentrate first rather than going " + "straight in the tank. For the " + k.pouch + " above that is the " + '<a href="/products/' + k.handle + '" target="_blank" rel="noopener">' + k.title + "</a>, about £" + k.price + ". One does you, however many runs " + "you are buying for." + '<span class="sub">Not in the total above and not added with the basket. ' + "It is kit rather than feed, you buy it once, and counting it against Athena " + "would make Pro look dearer than it is next to brands that need no jug.</span></p>"
        })();
        if (st.irrigation === "recirc") {
          $("resNote").textContent = r.dumped > 0 ? Math.round(r.dumped / (+$("tank").value || 1)) + " changes over a " + r.cycleWeeks + " week cycle, so " + Math.round(r.dumped) + " L of mixed feed down the drain on top of what " + "the plants drink. Your tank size drives this, and it is set on the previous screen." : "Topping up only, so nothing is thrown away and this costs you nothing extra."
        }
        $("ftLblL").textContent = st.runs > 1 ? "Everything for " + st.runs + " runs" : "Everything for the run";
        $("ftLblS").textContent = st.runs > 1 ? st.runs + " runs" : "Run total";
        $("total2").textContent = money(grand);
        $("total3").textContent = money(grand);
        var ft = $("total3"),
          d = $("delta");
        var moved = lastGrand !== null && Math.abs(grand - lastGrand) > .005;
        if (moved) {
          var diff = grand - lastGrand;
          d.textContent = (diff > 0 ? "+" : "−") + money(Math.abs(diff));
          d.className = "ft-delta show " + (diff > 0 ? "up" : "down");
          clearTimeout(deltaTimer);
          deltaTimer = setTimeout(function() {
            d.className = "ft-delta"
          }, 2600);
          ft.classList.remove("bump");
          void ft.offsetWidth;
          ft.classList.add("bump");
          clearTimeout(bumpTimer);
          bumpTimer = setTimeout(function() {
            ft.classList.remove("bump")
          }, 600)
        } else {
          clearTimeout(deltaTimer);
          d.className = "ft-delta";
          d.textContent = ""
        }
        lastGrand = grand;
        $("add2").disabled = $("add3").disabled = !count;
        $("keep").style.display = picked() ? "" : "none";
        $("save").style.display = picked() ? "" : "none";
        writeUrl();
        window.__payload = lines.filter(function(b) {
          return on(b.key, b.optional)
        }).reduce(function(a, b) {
          b.lines.forEach(function(l) {
            a.push({
              sku: l.tier.sku,
              variantId: l.tier.variantId,
              title: b.title + " " + l.tier.t,
              qty: l.qty
            })
          });
          return a
        }, [])
      }

      function add() {
        var byId = {},
          order = [];
        (window.__payload || []).forEach(function(it) {
          if (!it.variantId) return;
          if (byId[it.variantId] == null) {
            byId[it.variantId] = 0;
            order.push(it.variantId)
          }
          byId[it.variantId] += it.qty
        });
        var payload = order.map(function(id) {
          return {
            id: parseInt(id, 10),
            quantity: byId[id]
          }
        });
        if (!payload.length) return;
        var b1 = $("add2"),
          b2 = $("add3"),
          msg = $("addMsg");
        b1.disabled = b2.disabled = true;
        msg.className = "addmsg";
        msg.style.display = "";
        msg.textContent = "Adding " + payload.length + " items…";
        var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
        fetch(root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: payload
          })
        }).then(function(r) {
          return r.json().then(function(d) {
            return {
              ok: r.ok,
              d: d
            }
          })
        }).then(function(r) {
          if (!r.ok) throw new Error(r.d.description || r.d.message || "Could not add to basket");
          b1.disabled = b2.disabled = false;
          msg.className = "addmsg";
          msg.innerHTML = "<b>Added to your basket.</b> Your chart is still here, so you can " + "untick anything you already have, or try another feed and add that instead." + '<br><a href="' + root + 'cart">Go to my basket →</a>';
          try {
            document.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true
            }))
          } catch (e) {}
        }).catch(function(err) {
          b1.disabled = b2.disabled = false;
          msg.className = "addmsg bad";
          msg.textContent = err.message + " — try unticking anything that is out of stock."
        })
      }
      $("add2").addEventListener("click", add);
      $("add3").addEventListener("click", function() {
        if ($("add3").dataset.mode === "go") return goStep(STEPS.indexOf("result"));
        add()
      });
      ["add2", "add3"].forEach(function(k) {
        $(k).addEventListener("click", function() {
          if (k === "add3" && $("add3").dataset.mode === "go") return;
          var p = window.__payload || [];
          if (!p.length) return;
          track("fc_add_to_cart", {
            fc_lines: p.length,
            fc_units: p.reduce(function(n, it) {
              return n + (it.qty || 0)
            }, 0),
            fc_value: Math.round((lastGrand || 0) * 100) / 100,
            fc_where: k === "add2" ? "basket" : "bar"
          })
        })
      });
      var FT_OFFSET_OVERRIDE = typeof FT_OFFSET === "number" && FT_OFFSET > 0 ? FT_OFFSET : 0;
      var ftHeaderEl = null,
        ftHeaderRO = null,
        ftLastTop = -1;

      function ftMeasureTop() {
        if (FT_OFFSET_OVERRIDE) return FT_OFFSET_OVERRIDE;
        var barEl = $("float");
        var seen = [];
        if (document.elementsFromPoint) {
          var cx = Math.round((window.innerWidth || 800) / 2);
          [1, 4].forEach(function(y) {
            var stack;
            try {
              stack = document.elementsFromPoint(cx, y) || []
            } catch (e) {
              return
            }
            for (var i = 0; i < stack.length; i++) seen.push(stack[i])
          })
        }
        var nodes = document.querySelectorAll('header, sticky-header, [role="banner"], .header, #header, .site-header, ' + ".shopify-section-group-header-group, .shopify-section__header, " + '#shopify-section-header, [id^="shopify-section-sections--"]');
        for (var j = 0; j < nodes.length && j < 40; j++) seen.push(nodes[j]);
        var lowest = 0;
        ftHeaderEl = null;
        for (var k = 0; k < seen.length; k++) {
          var el = seen[k],
            cs;
          if (!el || el.nodeType !== 1) continue;
          if (barEl && (el === barEl || barEl.contains(el))) continue;
          try {
            cs = window.getComputedStyle(el)
          } catch (e) {
            continue
          }
          if (cs.position !== "fixed" && cs.position !== "sticky") continue;
          if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") continue;
          var r = el.getBoundingClientRect();
          if (r.top <= 2 && r.height > 8 && r.height <= 260 && r.bottom > lowest) {
            lowest = r.bottom;
            ftHeaderEl = el
          }
        }
        return Math.round(lowest)
      }

      function ftPlace() {
        var t = ftMeasureTop();
        if (ftHeaderEl && typeof ResizeObserver !== "undefined" && ftHeaderRO !== ftHeaderEl) {
          ftHeaderRO = ftHeaderEl;
          try {
            new ResizeObserver(function() {
              ftLastTop = -1;
              ftPlace()
            }).observe(ftHeaderEl)
          } catch (e) {}
        }
        if (t === ftLastTop) return;
        ftLastTop = t;
        document.documentElement.style.setProperty("--ft-top", t + "px")
      }(function() {
        var bar = $("float"),
          cta = $("add2"),
          host = ROOT,
          queued = false,
          shown = null;
        if (!bar || !cta || !host) return;

        function apply() {
          queued = false;
          ftPlace();
          var on = !cta.disabled;
          host.style.paddingTop = on ? (bar.offsetHeight || 0) + "px" : "0px";
          if (on === shown) return;
          shown = on;
          bar.classList.toggle("on", on);
          bar.setAttribute("aria-hidden", String(!on));
          if (on) bar.removeAttribute("inert");
          else bar.setAttribute("inert", "");
          host.style.paddingBottom = ""
        }

        function reserve() {
          if (!cta.disabled) host.style.paddingTop = (bar.offsetHeight || 0) + "px"
        }
        addEventListener("beforeprint", function() {
          host.style.paddingTop = ""
        });
        addEventListener("afterprint", reserve);
        if (window.matchMedia) {
          try {
            window.matchMedia("print").addEventListener("change", function(e) {
              if (e.matches) host.style.paddingTop = "";
              else reserve()
            })
          } catch (e) {}
        }

        function queue() {
          if (!queued) {
            queued = true;
            requestAnimationFrame(apply)
          }
        }
        addEventListener("scroll", queue, {
          passive: true
        });
        addEventListener("resize", queue);
        if (typeof MutationObserver !== "undefined") {
          try {
            new MutationObserver(function() {
              ftLastTop = -1;
              queue()
            }).observe(document.body, {
              childList: true
            })
          } catch (e) {}
        }
        addEventListener("load", function() {
          ftLastTop = -1;
          queue()
        });
        [120, 500, 1500].forEach(function(ms) {
          setTimeout(function() {
            ftLastTop = -1;
            queue()
          }, ms)
        });
        window.__ftApply = apply;
        reserve();
        apply();
        addEventListener("resize", reserve);
        if (typeof ResizeObserver !== "undefined") {
          try {
            new ResizeObserver(reserve).observe(bar)
          } catch (e) {}
        }
      })();
      var STEPS = ["setup", "water", "cycle", "feed", "addons", "result"];
      var stepIx = 0;

      function stepPanel(id) {
        return $("wz-" + id)
      }

      function goStep(n, opts) {
        opts = opts || {};
        n = Math.max(0, Math.min(STEPS.length - 1, n));
        var changed = n !== stepIx;
        stepIx = n;
        STEPS.forEach(function(id, i) {
          var el = stepPanel(id);
          el.classList.toggle("on", i === n);
          el.setAttribute("aria-hidden", String(i !== n))
        });
        if (STEPS[n] === "feed") buildBrands();
        drawCrumbs();
        $("wzBack").disabled = n === 0;
        $("wzBack").textContent = n === STEPS.length - 1 ? "← Change feed" : "← Back";
        $("wzNext").classList.toggle("gone", n === STEPS.length - 1);
        $("wzNext").textContent = n === STEPS.length - 2 ? "My chart →" : "Next →";
        $("wzCount").textContent = "Step " + (n + 1) + " of " + STEPS.length;
        $("foot").style.display = STEPS[n] === "result" ? "" : "none";
        $("ffbHead").style.display = n === 0 ? "" : "none";
        $("add3").dataset.mode = STEPS[n] === "result" ? "add" : "go";
        if (changed && !opts.quiet) {
          track("fc_step", {
            fc_step: STEPS[n],
            fc_step_no: n + 1
          });
          trackOnce("fc_reached_" + STEPS[n], {
            fc_step: STEPS[n],
            fc_step_no: n + 1
          })
        }
        if (changed && !opts.quiet) {
          var host = $("wzBar");
          var ftEl = $("float");
          var ftH = ftEl && ftEl.classList.contains("on") ? Math.round(ftEl.getBoundingClientRect().height) : 0;
          var y = host.getBoundingClientRect().top + (window.pageYOffset || 0) - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--ft-top")) || 0) - ftH - 12;
          y = Math.max(0, y);
          if (Math.abs((window.pageYOffset || 0) - y) > 6) window.scrollTo({
            top: y,
            behavior: window.matchMedia("(prefers-reduced-motion:reduce)").matches ? "auto" : "smooth"
          })
        }
      }

      function drawCrumbs() {
        $("wzBar").innerHTML = STEPS.map(function(id, i) {
          var t = stepPanel(id).dataset.title;
          return '<button type="button" class="wz-crumb' + (i === stepIx ? " now" : i < stepIx ? " done" : "") + '" data-s="' + i + '" role="tab" aria-selected="' + (i === stepIx) + '"><i></i><span>' + t + "</span></button>"
        }).join("")
      }
      $("wzBar").addEventListener("click", function(e) {
        var b = e.target.closest("[data-s]");
        if (!b) return;
        goStep(+b.dataset.s)
      });
      $("wzBack").addEventListener("click", function() {
        goStep(stepIx - 1)
      });
      $("wzChange").addEventListener("click", function() {
        goStep(STEPS.indexOf("feed"))
      });
      $("wzNext").addEventListener("click", function() {
        goStep(stepIx + 1)
      });
      window.__reveal = function(key) {
        var el = $(key);
        if (!el) return false;
        var panel = el.closest(".wz");
        if (panel) goStep(STEPS.indexOf(panel.dataset.ff.replace("wz-", "")), {
          quiet: true
        });
        return true
      };
      window.__goto = function(id) {
        goStep(STEPS.indexOf(id), {
          quiet: true
        })
      };
      window.__step = function() {
        return STEPS[stepIx]
      };
      window.__lineBrand = function() {
        var l = E.LINES[st.line];
        return l ? l.brand || null : null
      };
      window.__lineLabel = function() {
        var l = E.LINES[st.line];
        return l ? l.label || null : null
      };
      window.__clearFeed = function() {
        st.brand = null;
        st.line = null;
        buildBrands();
        render()
      };
      var SHARE_ORDER = [{
        k: "type",
        get: function() {
          return st.type
        },
        set: function(v) {
          if (E.MEDIA_TYPES[v]) st.type = v
        }
      }, {
        k: "size",
        get: function() {
          return st.size
        },
        set: function(v) {
          st.size = v
        }
      }, {
        k: "line",
        get: function() {
          return st.line || ""
        },
        set: function(v) {
          if (v && E.LINES[v]) {
            st.line = v;
            st.brand = E.LINES[v].brand
          }
        }
      }, {
        k: "units",
        get: function() {
          return st.units
        },
        set: function(v) {
          if (v === "litre" || v === "tank") st.units = v
        }
      }, {
        k: "water",
        get: function() {
          return st.water
        },
        set: function(v) {
          if (v === "hard" || v === "soft") st.water = v
        }
      }, {
        k: "style",
        get: function() {
          return st.style
        },
        set: function(v) {
          if (E.STYLES && E.STYLES[v]) st.style = v
        }
      }, {
        k: "strength",
        get: function() {
          return st.strength
        },
        set: function(v) {
          if (E.STRENGTHS[v]) st.strength = v
        }
      }, {
        k: "plants",
        get: function() {
          return $("plants").value
        },
        set: function(v) {
          setNum("plants", v, 1, 2e3)
        }
      }, {
        k: "tank",
        get: function() {
          return $("tank").value
        },
        set: function(v) {
          setNum("tank", v, 1, 2e4)
        }
      }, {
        k: "lpd",
        get: function() {
          return $("lpd").value
        },
        set: function(v) {
          setNum("lpd", v, 0, 200, true)
        }
      }, {
        k: "mixkit",
        get: function() {
          return ""
        },
        set: function() {}
      }, {
        k: "veg",
        get: function() {
          return $("veg").value
        },
        set: function(v) {
          setSel("veg", v)
        }
      }, {
        k: "flower",
        get: function() {
          return $("flower").value
        },
        set: function(v) {
          setSel("flower", v)
        }
      }, {
        k: "sort",
        get: function() {
          return st.sort
        },
        set: function(v) {
          if (v === "price" || v === "mix" || v === "name") st.sort = v
        }
      }, {
        k: "filter",
        get: function() {
          return st.filter
        },
        set: function(v) {
          if (v === "all" || v === "organic" || v === "powder" || v === "liquid") st.filter = v
        }
      }, {
        k: "pot",
        get: function() {
          return st.size === E.CUSTOM_SIZE ? String(st.potLitres) : ""
        },
        set: function(v) {
          var n = parseFloat(v),
            l = E.LIMITS.potLitres;
          if (isFinite(n) && n >= l.min && n <= l.max) {
            st.potLitres = n;
            $("pot").value = String(n)
          }
        }
      }, {
        k: "runs",
        get: function() {
          return st.runs > 1 ? String(st.runs) : ""
        },
        set: function(v) {
          var n = parseInt(v, 10);
          st.runs = n >= 1 && n <= 5 ? n : 1
        }
      }, {
        k: "irrig",
        get: function() {
          return st.irrigation === "waste" ? "" : st.irrigation
        },
        set: function(v) {
          if (E.IRRIGATION[v]) st.irrigation = v
        }
      }, {
        k: "resw",
        get: function() {
          return st.irrigation === "recirc" ? String(st.resWeeks) : ""
        },
        set: function(v) {
          var n = parseInt(v, 10);
          if (n >= 0 && n <= 12) st.resWeeks = n
        }
      }];

      function setNum(key, v, lo, hi, blankOk) {
        if (v === "" || v == null) {
          if (blankOk) $(key).value = "";
          return
        }
        var n = parseFloat(v);
        if (!isFinite(n) || n < lo || n > hi) return;
        $(key).value = String(n)
      }

      function setSel(key, v) {
        var el = $(key);
        for (var i = 0; i < el.options.length; i++)
          if (el.options[i].value === String(v)) {
            el.value = String(v);
            return
          }
      }

      function shareExtras() {
        var on = [],
          off = [];
        Object.keys(st.extras).forEach(function(k) {
          (st.extras[k] ? on : off).push(k)
        });
        var skip = Object.keys(st.skip || {}).filter(function(k) {
          return st.skip[k]
        });
        var out = "";
        if (off.length) out += "~x" + off.sort().join(".");
        if (on.length) out += "~o" + on.sort().join(".");
        if (skip.length) out += "~s" + skip.sort().join(".");
        return out
      }

      function serialise() {
        return SHARE_ORDER.map(function(f) {
          return String(f.get() == null ? "" : f.get())
        }).join("~") + shareExtras()
      }

      function restore(str) {
        if (!str) return false;
        var parts = String(str).split("~");
        var tail = [];
        while (parts.length && /^[xos]/.test(parts[parts.length - 1]) && !/^\d/.test(parts[parts.length - 1])) tail.unshift(parts.pop());
        SHARE_ORDER.forEach(function(f, i) {
          if (parts[i] !== undefined && parts[i] !== "") {
            try {
              f.set(parts[i])
            } catch (e) {}
          }
        });
        tail.forEach(function(t) {
          var kind = t.charAt(0),
            keys = t.slice(1).split(".").filter(Boolean);
          keys.forEach(function(k) {
            if (kind === "x") st.extras[k] = false;
            else if (kind === "o") st.extras[k] = true;
            else if (kind === "s") st.skip[k] = true
          })
        });
        return true
      }
      var shareLast = "";

      function writeUrl() {
        if (!window.history || !history.replaceState) return;
        if (!picked()) return;
        var b = serialise();
        if (b === shareLast) return;
        shareLast = b;
        try {
          var u = new URL(window.location.href);
          u.searchParams.set("b", b);
          u.searchParams.delete("feed");
          var href = u.toString().replace(/%7E/g, "~");
          history.replaceState(null, "", href);
          if ($("keepUrl")) $("keepUrl").value = href
        } catch (e) {}
      }
      $("keepCopy").addEventListener("click", function() {
        var el = $("keepUrl"),
          btn = $("keepCopy");
        track("fc_copy_link");
        el.select();

        function done() {
          btn.textContent = "Copied";
          setTimeout(function() {
            btn.textContent = "Copy link"
          }, 1600)
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(el.value).then(done, function() {
            try {
              document.execCommand("copy");
              done()
            } catch (e) {}
          })
        } else {
          try {
            document.execCommand("copy");
            done()
          } catch (e) {}
        }
      });
      var KLAVIYO_COMPANY = "Tt9YzJ";
      var KLAVIYO_LIST = "SXnsvn";
      var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      (function() {
        var form = $("saveForm"),
          input = $("saveEmail"),
          btn = $("saveBtn"),
          note = $("saveNote"),
          box = $("saveOptIn"),
          optLabel = $("saveOptLabel");
        if (!form) return;

        function say(msg, bad) {
          note.textContent = msg;
          note.className = "save-note" + (bad ? " bad" : "")
        }
        if (box) box.addEventListener("change", function() {
          if (box.checked) optLabel.className = "save-opt"
        });
        input.addEventListener("input", function() {
          input.classList.remove("bad")
        });
        form.addEventListener("submit", function(ev) {
          ev.preventDefault();
          var email = String(input.value || "").trim();
          if (!EMAIL_RE.test(email)) {
            input.classList.add("bad");
            say("That does not look like an email address. Have another go.", true);
            input.focus();
            return
          }
          if (!picked()) {
            say("Pick a feed first, then there is a chart to send.", true);
            return
          }
          if (!(box && box.checked)) {
            optLabel.className = "save-opt bad";
            say("Tick the box above and we can send it over.", true);
            if (box && box.focus) box.focus();
            return
          }
          try {
            window.klaviyo = window.klaviyo || [];
            window.klaviyo.push(["identify", {
              $email: email
            }])
          } catch (e) {}
          var fired = false;

          function fire() {
            if (fired) return;
            fired = true;
            track("fc_saved", {
              fc_opted_in: 1
            });
            try {
              window.klaviyo = window.klaviyo || [];
              window.klaviyo.push(["track", "Asked Us To Email A Feed Chart", {
                brand: st.brand || "",
                line: (E.LINES[st.line] || {}).label || "",
                medium: E.MEDIA_TYPES[st.type] ? E.MEDIA_TYPES[st.type].label : st.type,
                potSize: function() {
                  var s = E.sizeOf(st.type, st.size, st.potLitres);
                  return s ? s.label : ""
                }(),
                plants: +$("plants").value || 1,
                vegWeeks: +$("veg").value || 0,
                flowerWeeks: +$("flower").value || 0,
                totalWeeks: (+$("veg").value || 0) + (+$("flower").value || 0),
                runs: st.runs,
                irrigation: st.irrigation,
                total: Math.round((lastGrand || 0) * 100) / 100,
                currency: "GBP",
                url: window.location.href,
                chart: emailChart || null,
                build: typeof FC_BUILD === "string" ? FC_BUILD : ""
              }])
            } catch (e) {}
          }
          setTimeout(fire, 2500);
          try {
            fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY, {
              method: "POST",
              headers: {
                "content-type": "application/json",
                revision: "2024-10-15"
              },
              body: JSON.stringify({
                data: {
                  type: "subscription",
                  attributes: {
                    custom_source: "Feed Chart Calculator",
                    profile: {
                      data: {
                        type: "profile",
                        attributes: {
                          email: email,
                          subscriptions: {
                            email: {
                              marketing: {
                                consent: "SUBSCRIBED"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  relationships: {
                    list: {
                      data: {
                        type: "list",
                        id: KLAVIYO_LIST
                      }
                    }
                  }
                }
              })
            }).then(fire, fire)
          } catch (e) {
            fire()
          }
          btn.textContent = "On its way";
          btn.classList.add("done");
          input.disabled = true;
          optLabel.hidden = true;
          say("Sent to " + email + ". The link in it reopens this exact chart.")
        })
      })();
      try {
        var raw = document.querySelector('[data-fc-catalog="' + SECTION_ID + '"]');
        if (raw) {
          var rep = E.hydrate(JSON.parse(raw.textContent));
          if (rep && rep.missing && rep.missing.length) {
            ROOT.setAttribute("data-fc-missing", rep.missing.length + " not in the parts collection: " + rep.missing.slice(0, 12).join(", "));
            if (window.console && console.warn) console.warn("[feed calculator] " + rep.missing.length + " product variants are in the engine but not in the " + "Feed Calculator Parts collection, so they cannot be priced or bought:", rep.missing)
          }
        }
      } catch (e) {}(function() {
        if (!FC.hideWidgets) return;
        var PAT = /smile|whats.?app|wa\.me|wa-widget|wa-chat|wacb|chaty|tidio|rewards.?launcher|chat.?(bubble|button|widget|launcher)/i;
        var EXTRA = FC.hideExtra;
        var hidden = [];

        function names(el) {
          var c = el.getAttribute ? el.getAttribute("class") || "" : "";
          return [el.id || "", c, el.getAttribute && (el.getAttribute("src") || ""), el.getAttribute && (el.getAttribute("href") || ""), el.getAttribute && (el.getAttribute("title") || ""), el.getAttribute && (el.getAttribute("aria-label") || ""), el.getAttribute && (el.getAttribute("data-testid") || "")].join(" ")
        }

        function tooBig(n) {
          var r = n.getBoundingClientRect();
          return r.width > innerWidth * .6 && r.height > innerHeight * .6
        }

        function fixedHost(el) {
          var last = el;
          for (var n = el; n && n !== document.body; n = n.parentElement || n.getRootNode && n.getRootNode().host) {
            if (n.nodeType !== 1) continue;
            if (getComputedStyle(n).position === "fixed") return tooBig(n) ? last : n;
            last = n
          }
          return el.parentElement === document.body ? el : null
        }

        function hide(el) {
          if (!el || el.nodeType !== 1 || el === ROOT || ROOT.contains(el) || el.contains(ROOT)) return;
          if (el.dataset.fcHid) return;
          el.dataset.fcHid = "1";
          hidden.push([el, el.style.display]);
          el.style.display = "none"
        }

        function scan(root) {
          var all = root.querySelectorAll("*");
          for (var i = 0; i < all.length; i++) {
            var el = all[i];
            if (el.shadowRoot) scan(el.shadowRoot);
            if (PAT.test(names(el))) hide(fixedHost(el))
          }
        }

        function sweep() {
          if (!document.body) return;
          scan(document.body);
          if (EXTRA) {
            try {
              Array.prototype.forEach.call(document.querySelectorAll(EXTRA), hide)
            } catch (e) {}
          }
        }
        sweep();
        var mo = new MutationObserver(function() {
          sweep()
        });
        if (document.body) mo.observe(document.body, {
          childList: true,
          subtree: true
        });
        [400, 1200, 3e3, 6e3, 1e4].forEach(function(t) {
          setTimeout(sweep, t)
        });
        window.addEventListener("pagehide", function() {
          mo.disconnect();
          hidden.forEach(function(p) {
            p[0].style.display = p[1];
            delete p[0].dataset.fcHid
          })
        })
      })();
      var arrivedWithBuild = false,
        arrivedFromFeed = false;
      (function() {
        var q;
        try {
          q = new URL(window.location.href).searchParams
        } catch (e) {
          return
        }
        var b = q.get("b");
        if (b) {
          restore(b);
          arrivedWithBuild = true;
          return
        }
        var f = q.get("feed");
        if (f && E.LINES[f]) {
          var media = E.LINES[f].media;
          if (media.indexOf(st.type) < 0) {
            st.type = media[0];
            st.size = E.sizesFor(st.type)[0].k
          }
          st.line = f;
          st.brand = E.LINES[f].brand;
          arrivedWithBuild = true;
          arrivedFromFeed = true
        }
      })();
      buildTypes();
      buildIrrig();
      buildSizes();
      buildBrands();
      buildExtras();
      if (arrivedWithBuild && picked()) shareLast = serialise();
      render();
      if (arrivedFromFeed && picked()) {
        $("arrivedFeed").textContent = E.LINES[st.line].label;
        $("arrived").style.display = ""
      }
      goStep(arrivedWithBuild && !arrivedFromFeed && picked() ? STEPS.indexOf("result") : 0, {
        quiet: true
      });
      track("fc_open", {
        fc_entry: arrivedFromFeed ? "brand_link" : arrivedWithBuild ? "shared_build" : "fresh"
      })
    })();
  }

  window.FC_START = function() {
    var q = window.FC_QUEUE || [];
    while (q.length) {
      try {
        FC_INIT(q.shift());
      } catch (e) {
        if (window.console) console.error(e);
      }
    }
  };
  window.FC_START();
})();